import * as React from 'react';
import Svg, {
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  RadialGradient,
  ClipPath,
  Ellipse,
  Circle,
  Rect,
} from 'react-native-svg';
import { BODY_PARTS, BodyPartsSvgProps } from '../../../components/screens/Game/bodyPartsControls/bodyPartsConstants';
import { View } from 'react-native';
import { BODY_PARTS_SVG_BUTTON_TYPES, BodyPartSvgButton } from '../../../components/helperComponents/BodyPartSvgButton';

const BodyTypesSVG_fullBodyFront = ({ onPress, containerStyle, highlightedParts }: BodyPartsSvgProps) => {
  const [active, setActive] = React.useState<BODY_PARTS | undefined>();


  return (
    <View style={containerStyle}>
      <Svg
        //width={209}
        //height={447}
        style={{ width: '100%', height: '100%' }}
        viewBox="0 0 315 475"
        fill="none"
      >
        <G id="Group 27658">
          <G id="Group 27649">
            <G id="pressable_rightLeg">
              <G id="Group 27544">
                <Path
                  id="Vector"
                  d="M180.574 467.897a5.426 5.426 0 005.956 4.584 9.547 9.547 0 003.586-.468 3.585 3.585 0 002.12-1.809 4.613 4.613 0 005.239 1.216c.25-.088.491-.203.717-.343a4.826 4.826 0 001.996.375 5.19 5.19 0 002.588-.686c.431.092.878.092 1.309 0a4.566 4.566 0 002.277-.811h.156c3.118.717 5.02-3.118 3.616-5.8a14.15 14.15 0 00-3.118-3.492 18.932 18.932 0 01-3.492-5.052 62.758 62.758 0 00-4.896-7.359c-.249-.343-1.559-2.089-1.715-2.401.374-2.744-1.465-6.236-1.465-9.136a76.715 76.715 0 011.247-12.723c1.279-11.599 3.118-23.23 1.777-34.924a113.251 113.251 0 00-2.837-17.368 52.063 52.063 0 01-1.31-8.326c-.842-8.637 1.956-31.938 2.367-40.713.312-7.889-1.217-51.402-1.217-51.402-6.049.998-35.296-5.745-35.92.491-5.557 19.875 8.702 82.893 9.17 89.317a53.93 53.93 0 004.334 17.618c1.965 5.332.967 11.381.842 17.056a50.313 50.313 0 001.902 18.024 158.311 158.311 0 014.147 17.087c.624 5.707-.873 10.01.811 15.841a21.211 21.211 0 00-.811 5.239c0 1.496.218 3.741.187 5.207a4.775 4.775 0 01-.498 2.183 7.79 7.79 0 00.935 8.575z"
                  fill="#915548"
                />
                <Path
                  id="Vector_2"
                  d="M209.606 467.616a.422.422 0 000 .187 2.065 2.065 0 01-3.119 1.185 2.925 2.925 0 01-3.617.592c-3.021.081-6.037.278-9.043.593-.748-.593-1.029-1.403-1.434-1.622a7.794 7.794 0 01-.904-.499 2.81 2.81 0 01-1.591 2.838 11.094 11.094 0 01-5.737 0 3.897 3.897 0 01-2.495-3.461 7.86 7.86 0 01-1.559-4.272 24.936 24.936 0 011.31-4.584 40.326 40.326 0 000-6.08c.019-1.889.291-3.766.811-5.582a13.133 13.133 0 01-.936-5.8 52.24 52.24 0 00-.187-12.972c-.998-4.739-3.336-12.659-4.677-18.241a65.086 65.086 0 01-.624-17.618 31.626 31.626 0 00-1.341-14.437 53.451 53.451 0 01-3.866-14.749c-.468-4.896-12.749-59.05-11.507-90.469 0-3.367 8.316.065 16.392-.497 8.076-.561 18.013-.123 18.013-.123 0 .249 2.052 51 1.808 52.462-.779 8.139-2.255 28.336-2.193 32.047a68.444 68.444 0 001.59 16.308 134.105 134.105 0 013.119 25.663 185.64 185.64 0 01-1.871 22.389c-.655 6.954-1.746 11.818-1.622 15.154a22.645 22.645 0 001.123 6.923c.561 1.808.281 3.118.561 3.804.281.686 1.715 2.37 3.43 4.802a49.723 49.723 0 013.992 6.392 17.989 17.989 0 004.303 5.177 4.09 4.09 0 011.871 4.49z"
                  fill="url(#paint0_linear_5287_7562)"
                />
                <Path
                  id="Vector_3"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M209.542 467.803a2.05 2.05 0 01-1.257 1.389 2.047 2.047 0 01-1.861-.204 2.928 2.928 0 01-3.617.592c-3.021.081-6.038.278-9.043.593-.749-.593-1.029-1.403-1.435-1.622a7.787 7.787 0 01-.904-.498 2.807 2.807 0 01-1.59 2.837c-1.88.503-3.858.503-5.738 0a3.894 3.894 0 01-2.494-3.461 7.86 7.86 0 01-1.559-4.272 24.933 24.933 0 011.309-4.584 40.326 40.326 0 000-6.08c.019-1.889.292-3.766.811-5.582a13.119 13.119 0 01-.935-5.8 52.289 52.289 0 00-.188-12.972c-.997-4.739-3.336-12.659-4.677-18.241a65.126 65.126 0 01-.623-17.618 31.626 31.626 0 00-1.341-14.437 53.453 53.453 0 01-3.867-14.749c-.468-4.896-7.424-38.816-7.424-42.183-4.891-13.566-4.11-48.672-4.11-48.672l4.546 32.342s3.868 23.118 4.305 28.7c.436 5.581 3.494 19.086 3.494 22.454a13.906 13.906 0 001.933 7.483c1.029 1.622.873-2.214 3.524-3.804a10.445 10.445 0 001.465 9.105c2.058 2.027 2.214 2.027 1.622 4.709-.593 2.681.779 8.201 1.933 13.782a157.762 157.762 0 011.528 42.751 65.254 65.254 0 00-1.123 11.163c.323 1.992.52 4.002.593 6.018-.156 1.934-.405 5.364-.499 8.482a15.602 15.602 0 01-.561 5.114 6.608 6.608 0 001.091 4.926 3.68 3.68 0 003.118 2.058c1.699.194 3.415.194 5.114 0 .811-.218.904-.28.78-1.122a7.751 7.751 0 00-1.341-2.463 11.291 11.291 0 01-1.715-3.119 12.66 12.66 0 003.118 2.807c.748.374.655 1.434 1.029 2.276.374.842.655 1.902 1.621 2.089 1.462.288 2.967.288 4.428 0 .499-.374.281-.655-.374-1.746a45.105 45.105 0 00-4.116-5.052c1.88.981 3.52 2.365 4.802 4.054.468.811.936 2.183 1.871 2.588.935.406 2.495.655 2.744 0a3.985 3.985 0 00-1.278-2.931 36.364 36.364 0 00-3.711-3.461 15.206 15.206 0 014.428 3.118c.58.747 1.082 1.551 1.497 2.401.436.873 2.525.873 2.712.25a4.052 4.052 0 00-.685-2.62 15.319 15.319 0 00-3.867-3.118 9.352 9.352 0 014.272 2.744c.408.894.877 1.759 1.403 2.588.249.156.312.717.842.998z"
                  fill="url(#paint1_linear_5287_7562)"
                />
                <Path
                  id="Vector_4"
                  d="M186.592 359.26c.48.868.826 1.804 1.029 2.775.218.94.282 1.909.187 2.869a9.635 9.635 0 01-.592 2.775c-.166.46-.364.908-.593 1.341-.219.443-.469.87-.748 1.278a6.815 6.815 0 001.029-1.091c.317-.406.589-.845.811-1.31a8.7 8.7 0 00.81-2.962 9.007 9.007 0 00-.436-3.118 7.673 7.673 0 00-1.497-2.557z"
                  fill="#7E4336"
                />
                <Path
                  id="Vector_5"
                  d="M176.146 360.352a7.554 7.554 0 00-1.123 5.987 7.362 7.362 0 001.372 2.806 6.582 6.582 0 002.37 1.964 9.349 9.349 0 01-1.933-2.276 8.47 8.47 0 01-1.123-2.682 8.196 8.196 0 01-.249-2.9 8.738 8.738 0 01.686-2.899z"
                  fill="#7E4336"
                />
                <Path
                  id="Vector_6"
                  d="M183.412 464.751c.029.246.092.488.187.717a3.04 3.04 0 000 .405 1.311 1.311 0 001.216.53h2.339a6.78 6.78 0 011.122 0c.379.006.757.059 1.123.156.226.047.46.047.686 0a.594.594 0 00.406-.623 1.156 1.156 0 00-.375-.53s0-.344-.281-.531a2.562 2.562 0 00-.841-1.029 5.064 5.064 0 00-1.248-.467 8.367 8.367 0 00-1.278-.219 4.712 4.712 0 00-1.31 0c-.467.056-.909.24-1.278.531a1.451 1.451 0 00-.468 1.06zm.343.374v-.374a1.153 1.153 0 01.562-.842 4.266 4.266 0 012.213-.374h1.185a5.33 5.33 0 011.123.311c.354.18.655.448.873.78l.468.561c.1.114.165.255.187.406 0 0 0 .187-.25.218a.97.97 0 01-.467 0 7.318 7.318 0 00-1.185-.281h-1.217a8.172 8.172 0 00-1.216.156l-1.122.218a.904.904 0 01-.905-.187 1.18 1.18 0 01-.249-.592zm9.76-.374a.956.956 0 00-.312.748 1.56 1.56 0 000 .374l.187.281.343.53c.13.198.288.376.468.53.263.162.565.248.873.25.249.019.499.019.749 0l1.434-.156h1.029s.281 0 .281-.188a2.212 2.212 0 000-.717 3.77 3.77 0 00-.25-.623 3.109 3.109 0 00-2.214-1.466 3.69 3.69 0 00-1.309 0c-.458.03-.899.181-1.279.437zm0 .779a.561.561 0 01.218-.343c.329-.17.691-.266 1.061-.28a6.78 6.78 0 011.122 0 2.484 2.484 0 011.871 1.029l.281.498c0 .156 0 .375.156.468h-.312l-.593-.156a6.3 6.3 0 00-1.528 0h-1.309a1.745 1.745 0 01-.749-.748v-.281a.399.399 0 01-.093-.187h-.125zm5.644-.156a1.817 1.817 0 000 1.092 1.9 1.9 0 00.655.81c.2.119.423.194.655.219h1.216c.424.06.854.06 1.278 0 0 0 .312-.156.343-.343.019-.124.019-.25 0-.374a.855.855 0 00-.374-.531.562.562 0 010 .531v.28c0-.031-.717 0-1.154 0a1.652 1.652 0 00-.686 0H200.001a1.579 1.579 0 01-.374-.717 1.33 1.33 0 010-.78.678.678 0 01.467-.405 1.998 1.998 0 011.591 0c.562.237 1.01.685 1.247 1.247a2.273 2.273 0 00-1.06-1.621 2.316 2.316 0 00-2.027-.218 1.267 1.267 0 00-.561.81h-.125zm4.303 0c.126.368.366.685.686.905.136.213.317.394.53.53.203.131.447.186.686.156.198.017.396.017.593 0h.468c.217.03.437.03.654 0a.72.72 0 00.343-.219.584.584 0 000-.374 1.493 1.493 0 00-.218-.561c.138.258.305.498.499.717a.826.826 0 000 .343 1.15 1.15 0 001.185.468c.199-.019.391-.083.561-.187h.187a.593.593 0 00.375-.219.803.803 0 00.249-.686 1.446 1.446 0 00-.374-.53v-.156a3.193 3.193 0 00-.343-.717 1.882 1.882 0 00-.531-.717 1.622 1.622 0 00-.966-.187 1.159 1.159 0 00-.904.53 1.271 1.271 0 000 .748 2.372 2.372 0 00-2.339-1.372 1.568 1.568 0 00-1.091.562 1.28 1.28 0 00-.125 1.091l-.125-.125zm4.147-.28a1.013 1.013 0 010-.562.602.602 0 01.437-.218.778.778 0 01.592 0s.312.281.468.468c.337.363.583.801.717 1.278a.37.37 0 01-.155.187h-.437l-.437.187a.764.764 0 01-.374 0 .8.8 0 01-.592-.28c.124-.187-.063-.593-.094-.936l-.125-.124zm-3.523-.562a.964.964 0 01.686-.343 1.846 1.846 0 011.621.53c.408.373.709.846.873 1.373 0 .218 0 .187-.249.218h-.499a1.508 1.508 0 00-.655 0 2.158 2.158 0 01-.966 0h-.25a1.847 1.847 0 01-.655-1.06.82.82 0 01.219-.593l-.125-.125z"
                  fill="#915548"
                />
              </G>
              <Path
                id="Vector_7"
                d="M191.627 465.696c.031.519.031 1.04 0 1.559a7.788 7.788 0 01-.281 1.528 9.351 9.351 0 01-.467 1.309 9.868 9.868 0 01-.531.905 3.576 3.576 0 002.121-1.809v-.187a10.266 10.266 0 000-3.523 4.712 4.712 0 00-.53-1.716 6.654 6.654 0 00-1.217-1.247 6.794 6.794 0 01-1.06-1.247 7.85 7.85 0 01-.748-1.434c.115.538.294 1.061.53 1.559.213.524.496 1.017.842 1.465.34.405.653.832.936 1.279a4.06 4.06 0 01.405 1.559z"
                fill="#915548"
              />
              <Path
                id="Vector_8"
                d="M198.362 465.506c.222.423.329.896.312 1.372a5.982 5.982 0 01-.312 1.341c-.179.4-.421.768-.717 1.092l-1.153 1.185c.371.062.751.062 1.122 0 .251-.089.491-.204.717-.343a2.902 2.902 0 001.185-1.466c.256-.61.332-1.281.218-1.933a4.268 4.268 0 00-.717-1.778c-.331-.462-.696-.9-1.091-1.309-.374-.406-.717-.842-1.091-1.279a14.108 14.108 0 00-2.464-2.276 12.847 12.847 0 012.121 2.557l.904 1.403c.36.452.683.931.966 1.434z"
                fill="#915548"
              />
              <Path
                id="Vector_9"
                d="M203.228 465.852a3.105 3.105 0 010 1.59c-.1.511-.337.985-.686 1.372a5.456 5.456 0 01-1.154 1.091c-.311.219-.623.468-.997.686.908.003 1.8-.234 2.588-.686.13-.12.246-.256.343-.405a4.914 4.914 0 00.748-1.933 4.053 4.053 0 00-.249-2.027 6.244 6.244 0 00-1.029-1.684c-.413-.47-.85-.917-1.31-1.341a21.905 21.905 0 00-2.931-2.183 19.926 19.926 0 012.557 2.557c.4.449.765.929 1.091 1.435.422.451.769.967 1.029 1.528z"
                fill="#915548"
              />
              <Path
                id="Vector_10"
                d="M207.031 464.887a4.566 4.566 0 010 1.59c-.057.51-.227 1-.499 1.435a8.854 8.854 0 01-.967 1.185c-.311.312-.654.655-1.06.998a4.566 4.566 0 002.277-.811h.156c.242-.246.442-.531.592-.842a4.574 4.574 0 00.53-1.902 4.356 4.356 0 00-.312-1.902 4.42 4.42 0 00-.935-1.622 10.146 10.146 0 00-1.341-1.247 7.613 7.613 0 00-3.118-1.684c.55.199 1.065.483 1.528.842.455.362.882.758 1.278 1.185.409.403.794.83 1.154 1.278.315.459.557.964.717 1.497z"
                fill="#915548"
              />
              <G id="pressable_rightLeg_2">
                <G id="Group 27544_2">
                  <Path
                    id="Vector_11"
                    d="M181.337 468.092a5.428 5.428 0 005.956 4.584 9.522 9.522 0 003.586-.468A3.587 3.587 0 00193 470.4a4.61 4.61 0 005.238 1.216c.251-.089.491-.203.717-.343a4.831 4.831 0 001.996.374c.908.002 1.8-.234 2.588-.686a3.11 3.11 0 001.31 0 4.543 4.543 0 002.276-.811h.156c3.118.718 5.02-3.118 3.617-5.799a14.136 14.136 0 00-3.118-3.493 18.93 18.93 0 01-3.493-5.051 62.75 62.75 0 00-4.895-7.359c-.249-.343-1.559-2.089-1.715-2.401.374-2.744-1.466-6.237-1.466-9.137a76.811 76.811 0 011.248-12.722c1.278-11.6 3.118-23.231 1.777-34.924a113.373 113.373 0 00-2.837-17.368 52.081 52.081 0 01-1.31-8.326c-.842-8.637 1.955-31.938 2.367-40.714.311-7.889-1.217-51.401-1.217-51.401.533-1.094-37.267-4.645-37.267-.713-5.557 19.875 10.049 84.097 10.516 90.521a53.894 53.894 0 004.335 17.617c1.964 5.333.966 11.382.841 17.057a50.355 50.355 0 001.902 18.023 158.39 158.39 0 014.148 17.088c.624 5.706-.873 10.01.811 15.841a21.164 21.164 0 00-.811 5.238c0 1.497.218 3.742.187 5.208a4.77 4.77 0 01-.499 2.182 7.795 7.795 0 00.935 8.575z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_12"
                    d="M210.367 467.812a.453.453 0 000 .187 2.051 2.051 0 01-1.256 1.389 2.063 2.063 0 01-1.862-.204 2.934 2.934 0 01-3.617.592c-3.021.08-6.038.278-9.043.593-.748-.593-1.029-1.404-1.434-1.622a7.807 7.807 0 01-.905-.499 2.803 2.803 0 01-1.59 2.838c-1.88.503-3.858.503-5.737 0a3.892 3.892 0 01-2.495-3.461 7.855 7.855 0 01-1.559-4.272 24.967 24.967 0 011.309-4.584 40.078 40.078 0 000-6.081c.019-1.888.292-3.765.811-5.581a13.119 13.119 0 01-.935-5.8 52.288 52.288 0 00-.187-12.972c-.998-4.74-3.337-12.66-4.678-18.241a65.13 65.13 0 01-.623-17.618 31.63 31.63 0 00-1.341-14.438 53.47 53.47 0 01-3.867-14.749c-.467-4.895-12.748-59.05-11.506-90.468 0-3.368 1.825-1.899 9.901-2.46 8.076-.561 24.504 1.839 24.504 1.839 0 .25 2.052 51.001 1.808 52.463-.78 8.138-2.256 28.336-2.193 32.047a68.449 68.449 0 001.59 16.308 134.015 134.015 0 013.118 25.663 185.25 185.25 0 01-1.871 22.389c-.654 6.953-1.746 11.818-1.621 15.154a22.649 22.649 0 001.122 6.923c.562 1.808.281 3.118.562 3.804.281.686 1.715 2.37 3.43 4.802a49.579 49.579 0 013.991 6.392 17.987 17.987 0 004.303 5.176 4.086 4.086 0 011.871 4.491z"
                    fill="url(#paint2_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_13"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M210.306 467.999a2.074 2.074 0 01-.461.846 2.068 2.068 0 01-1.751.665 2.064 2.064 0 01-.907-.326 2.93 2.93 0 01-3.617.592 116.3 116.3 0 00-9.043.593c-.748-.593-1.029-1.404-1.434-1.622a7.794 7.794 0 01-.904-.499 2.81 2.81 0 01-1.591 2.838 11.094 11.094 0 01-5.737 0 3.897 3.897 0 01-2.494-3.461 7.864 7.864 0 01-1.56-4.272 24.97 24.97 0 011.31-4.584 40.339 40.339 0 000-6.081c.019-1.888.292-3.765.811-5.581a13.133 13.133 0 01-.936-5.8 52.24 52.24 0 00-.187-12.972c-.998-4.74-3.336-12.66-4.677-18.241a65.13 65.13 0 01-.624-17.618 31.603 31.603 0 00-1.341-14.438 53.433 53.433 0 01-3.866-14.749c-.468-4.895-7.424-38.815-7.424-42.183-4.891-13.566-4.111-48.671-4.111-48.671l4.547 32.342s3.868 23.118 4.305 28.7c.436 5.581 3.494 19.086 3.494 22.453a13.903 13.903 0 001.933 7.484c1.029 1.621.873-2.214 3.523-3.804a10.458 10.458 0 001.466 9.105c2.058 2.027 2.214 2.027 1.621 4.708-.592 2.682.78 8.201 1.934 13.783a157.762 157.762 0 011.528 42.751 65.144 65.144 0 00-1.123 11.163 48.58 48.58 0 01.592 6.018c-.156 1.933-.405 5.363-.498 8.481a15.6 15.6 0 01-.562 5.114 6.61 6.61 0 001.092 4.927 3.677 3.677 0 003.118 2.058c1.699.193 3.415.193 5.114 0 .81-.218.904-.28.779-1.122a7.764 7.764 0 00-1.34-2.464 11.315 11.315 0 01-1.716-3.118 12.66 12.66 0 003.119 2.806c.748.375.654 1.435 1.029 2.277.374.842.654 1.902 1.621 2.089 1.462.288 2.966.288 4.428 0 .499-.374.281-.655-.374-1.746a45.015 45.015 0 00-4.116-5.052c1.88.981 3.52 2.365 4.802 4.054.468.811.935 2.183 1.871 2.588.935.405 2.494.655 2.744 0a3.999 3.999 0 00-1.278-2.931 36.252 36.252 0 00-3.711-3.461 15.22 15.22 0 014.428 3.118c.58.747 1.081 1.551 1.496 2.401.437.873 2.526.873 2.713.249a4.056 4.056 0 00-.686-2.619 15.275 15.275 0 00-3.866-3.118 9.357 9.357 0 014.272 2.744c.408.894.876 1.758 1.403 2.588.249.156.312.717.842.998z"
                    fill="url(#paint3_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_14"
                    d="M187.356 359.455a9.973 9.973 0 011.029 2.776c.218.939.281 1.908.187 2.868a9.602 9.602 0 01-.593 2.776c-.165.46-.363.908-.592 1.34-.219.444-.469.871-.748 1.279a6.857 6.857 0 001.029-1.091c.317-.406.589-.845.81-1.31a8.69 8.69 0 00.811-2.962 8.993 8.993 0 00-.437-3.119 7.68 7.68 0 00-1.496-2.557z"
                    fill="#7E4336"
                  />
                  <Path
                    id="Vector_15"
                    d="M176.91 360.547a7.545 7.545 0 00-1.123 5.987 7.36 7.36 0 001.372 2.807 6.582 6.582 0 002.37 1.964 9.349 9.349 0 01-1.933-2.276 8.456 8.456 0 01-1.123-2.682 8.22 8.22 0 01-.25-2.9 8.74 8.74 0 01.687-2.9z"
                    fill="#7E4336"
                  />
                  <Path
                    id="Vector_16"
                    d="M184.176 464.946c.029.247.091.488.187.718-.01.134-.01.27 0 .405a1.31 1.31 0 001.216.53h2.338a6.792 6.792 0 011.123 0c.379.006.756.058 1.123.156.226.047.46.047.686 0a.592.592 0 00.405-.624 1.147 1.147 0 00-.374-.53s0-.343-.281-.53a2.556 2.556 0 00-.842-1.029 5.084 5.084 0 00-1.247-.468 8.511 8.511 0 00-1.278-.218 4.636 4.636 0 00-1.31 0 2.554 2.554 0 00-1.278.53c-.146.136-.263.3-.344.482-.08.182-.122.379-.124.578zm.343.375v-.375a1.147 1.147 0 01.561-.842 4.282 4.282 0 012.214-.374h1.185c.384.063.761.167 1.122.312.354.179.656.448.874.78l.467.561a.773.773 0 01.187.405s0 .187-.249.219a.975.975 0 01-.468 0 7.19 7.19 0 00-1.185-.281h-1.216a8.026 8.026 0 00-1.216.156l-1.123.218a.9.9 0 01-.904-.187 1.188 1.188 0 01-.249-.592zm9.76-.375a.977.977 0 00-.239.34.989.989 0 00-.073.409 1.56 1.56 0 000 .374l.187.281.343.53c.13.198.287.376.468.53.262.161.564.248.873.249.249.019.499.019.748 0l1.434-.156h1.03s.28 0 .28-.187a2.212 2.212 0 000-.717 3.69 3.69 0 00-.249-.624 3.122 3.122 0 00-2.214-1.465 3.696 3.696 0 00-1.31 0 2.59 2.59 0 00-1.278.436zm0 .78a.558.558 0 01.218-.343 2.53 2.53 0 011.06-.281c.374-.03.749-.03 1.123 0 .368.023.727.127 1.051.304.323.178.603.426.82.725l.28.499c0 .156 0 .374.156.468h-.311l-.593-.156a6.2 6.2 0 00-1.528 0h-1.309a1.745 1.745 0 01-.749-.748v-.281a.403.403 0 01-.093-.187h-.125zm5.644-.156a1.813 1.813 0 000 1.091c.138.326.365.607.655.811.2.119.423.193.654.218h1.216c.424.06.855.06 1.279 0 0 0 .312-.156.343-.343.018-.124.018-.25 0-.374a.838.838 0 00-.374-.53.571.571 0 010 .53v.281c0-.031-.717 0-1.154 0a1.652 1.652 0 00-.686 0h-1.092a1.598 1.598 0 01-.374-.717 1.346 1.346 0 010-.78.692.692 0 01.468-.405 1.998 1.998 0 011.59 0 2.337 2.337 0 011.248 1.247 2.282 2.282 0 00-1.06-1.621 2.304 2.304 0 00-2.027-.219 1.28 1.28 0 00-.562.811h-.124zm4.303 0c.126.367.366.684.686.904.135.214.316.395.53.53.203.131.446.187.686.156.197.018.395.018.592 0h.468c.217.03.438.03.655 0a.718.718 0 00.343-.218.598.598 0 000-.374 1.493 1.493 0 00-.218-.561c.137.257.305.498.499.717a.794.794 0 000 .343 1.156 1.156 0 001.185.467c.199-.018.39-.082.561-.187h.187a.594.594 0 00.374-.218.813.813 0 00.207-.313c.043-.119.057-.247.043-.373a1.437 1.437 0 00-.375-.53v-.156a3.07 3.07 0 00-.343-.717 1.87 1.87 0 00-.53-.717 1.615 1.615 0 00-.966-.187 1.146 1.146 0 00-.905.53 1.288 1.288 0 000 .748 2.374 2.374 0 00-2.338-1.372 1.556 1.556 0 00-1.092.561 1.282 1.282 0 00-.124 1.092l-.125-.125zm4.147-.281a.992.992 0 010-.561.603.603 0 01.437-.218.778.778 0 01.592 0s.312.28.468.468c.337.363.583.801.717 1.278a.372.372 0 01-.156.187h-.436l-.437.187a.764.764 0 01-.374 0 .814.814 0 01-.593-.28c.125-.188-.062-.593-.093-.936l-.125-.125zm-3.523-.561a.962.962 0 01.685-.343 1.833 1.833 0 011.622.53c.407.372.709.846.873 1.372 0 .218 0 .187-.25.218h-.498a1.539 1.539 0 00-.655 0 2.134 2.134 0 01-.967 0h-.249a1.836 1.836 0 01-.655-1.06.803.803 0 01.218-.592l-.124-.125z"
                    fill="#915548"
                  />
                </G>
                <Path
                  id="Vector_17"
                  d="M192.391 465.891c.031.52.031 1.04 0 1.56a7.862 7.862 0 01-.281 1.528c-.123.447-.28.885-.468 1.309-.16.311-.337.613-.53.904a3.583 3.583 0 002.121-1.808v-.187a10.272 10.272 0 000-3.524 4.734 4.734 0 00-.531-1.715 6.618 6.618 0 00-1.216-1.247 6.828 6.828 0 01-1.06-1.247 7.827 7.827 0 01-.748-1.435c.115.539.293 1.062.53 1.559.213.525.496 1.018.842 1.466.34.405.652.832.935 1.278a4.07 4.07 0 01.406 1.559z"
                  fill="#915548"
                />
                <Path
                  id="Vector_18"
                  d="M199.126 465.702c.222.423.329.895.312 1.372a6.007 6.007 0 01-.312 1.341c-.179.4-.421.768-.717 1.091l-1.154 1.185c.372.062.751.062 1.123 0 .25-.088.491-.203.717-.343a2.9 2.9 0 001.185-1.465 3.462 3.462 0 00.218-1.934 4.277 4.277 0 00-.717-1.777 11.585 11.585 0 00-1.091-1.31c-.375-.405-.718-.842-1.092-1.278a14.137 14.137 0 00-2.463-2.276 12.842 12.842 0 012.12 2.557l.904 1.403c.36.451.684.931.967 1.434z"
                  fill="#915548"
                />
                <Path
                  id="Vector_19"
                  d="M203.992 466.047a3.13 3.13 0 010 1.591c-.1.511-.337.985-.686 1.372-.33.417-.718.785-1.154 1.091-.312.218-.623.468-.998.686a5.174 5.174 0 002.588-.686c.131-.121.246-.257.343-.405a4.9 4.9 0 00.749-1.934 4.055 4.055 0 00-.25-2.027 6.229 6.229 0 00-1.029-1.683c-.412-.47-.849-.918-1.309-1.341a21.829 21.829 0 00-2.932-2.183 19.807 19.807 0 012.558 2.557c.4.449.765.929 1.091 1.434.422.452.769.968 1.029 1.528z"
                  fill="#915548"
                />
                <Path
                  id="Vector_20"
                  d="M207.795 465.083a4.566 4.566 0 010 1.59c-.058.509-.228 1-.499 1.434a8.806 8.806 0 01-.967 1.185c-.312.312-.655.655-1.06.998a4.552 4.552 0 002.276-.81h.156c.243-.246.443-.531.593-.842a4.608 4.608 0 00.53-1.903 4.373 4.373 0 00-.312-1.902 4.432 4.432 0 00-.936-1.621 10.019 10.019 0 00-1.341-1.247 7.6 7.6 0 00-3.118-1.684 5.59 5.59 0 011.528.842c.456.362.883.758 1.279 1.185.409.403.794.83 1.153 1.278.316.458.558.964.718 1.497z"
                  fill="#915548"
                />
                <Path
                  id="highlight_rightLeg"
                  d="M176.567 268.837c9.411.385 13.701 1.409 19.719 2.369 1.9 34.265 1.459 53.486-.745 87.124-.3 7.664 1.462 12.087 2.814 19.394 5 27.038-1.469 45.766-1.469 60.786 1.008 3.038 1.578 4.88 1.66 7.688l8 13 3 3c4.501 2.504 2.448 8.869-1.497 7.77-1.217.852-2.007.86-3.5.501-1.725.66-2.749.911-5.001.501-1.002.728-4.5 1.502-6-.501-.502 4.729-13 3.462-12.501-2.271-1.999-2.503-2-5.74 0-10.246-.548-3.847-.033-5.856.999-10.254-1.342-3.174-1.822-5.817-.999-9.274 0-5.726-.401-9.917-2.501-16.226-4.275-15.276-5.5-19.975-3.5-37.5 1.001-2.503-5.5-12.984-5.5-24-9.416-40.477-12.141-60.797-10.969-91.411 3.201-.448 10.485-.757 17.99-.45z"
                  fill="#A430FF"
                  fillOpacity={0.25}
                  stroke="#A430FF"
                  strokeWidth={1.5}
                  opacity={highlightedParts.includes(BODY_PARTS.leg) ? 1 : 0}
                />
              </G>
            </G>
            <G id="pressable_leftLeg">
              <G id="Group 27545">
                <Path
                  id="Vector_21"
                  d="M138.81 467.952a5.481 5.481 0 01-2.082 3.482 5.48 5.48 0 01-3.905 1.101 9.364 9.364 0 01-3.555-.467 3.772 3.772 0 01-2.12-1.809 4.552 4.552 0 01-5.207 1.216 3.096 3.096 0 01-.718-.343 4.886 4.886 0 01-2.026.374 5.362 5.362 0 01-2.589-.686 3.106 3.106 0 01-1.309 0 4.46 4.46 0 01-2.245-.81h-.156c-3.118.717-5.052-3.119-3.617-5.8a14.079 14.079 0 013.118-3.493 18.233 18.233 0 003.492-5.051 62.96 62.96 0 014.927-7.359c.218-.343 1.559-2.089 1.684-2.401-.343-2.744 1.497-6.237 1.497-9.136a80.205 80.205 0 00-1.248-12.723c-1.278-11.599-3.274-23.23-1.808-34.924a117.273 117.273 0 012.837-17.368 45.865 45.865 0 001.31-8.326c.842-8.637-1.95-82.916-2.792-91.616-.267-4.005 8.603-2.464 13.856-2.464 5.806-.553 22.601-3.195 23.225 3.042-.25 6.236-8.221 82.307-8.657 88.731a55.56 55.56 0 01-4.335 17.618c-1.995 5.332-.998 11.381-.873 17.056a50.994 50.994 0 01-1.871 18.024 158.547 158.547 0 00-4.147 17.087c-.655 5.707.873 10.01-.811 15.841.478 1.707.74 3.466.78 5.238 0 1.497-.218 3.742-.156 5.208-.02.754.14 1.503.468 2.183a7.855 7.855 0 01-.967 8.575z"
                  fill="#915548"
                />
                <Path
                  id="Vector_22"
                  d="M159.259 272.286c0 .468-6.424 52.666-6.642 54.256-1.341 8.856-3.477 32.588-3.914 36.798a54.567 54.567 0 01-3.835 14.749 32.023 32.023 0 00-1.372 14.437 62.678 62.678 0 01-.624 17.618c-1.309 5.582-3.648 13.502-4.677 18.241a50.56 50.56 0 000 12.972 13.099 13.099 0 01-.967 5.8c.516 1.818.799 3.693.842 5.582a37.177 37.177 0 000 6.08 24.704 24.704 0 011.341 4.584c.017.145.017.292 0 .437a8.517 8.517 0 01-1.559 3.835 3.862 3.862 0 01-2.495 3.461 10.977 10.977 0 01-5.706 0 2.774 2.774 0 01-1.622-2.837 5.932 5.932 0 01-.904.499c-.374.218-.655 1.028-1.434 1.621a117.465 117.465 0 00-9.012-.593 2.928 2.928 0 01-3.617-.592 2.092 2.092 0 01-2.697-.48 2.09 2.09 0 01-.421-.892 4.083 4.083 0 011.809-4.521 17.891 17.891 0 004.271-5.177 57.878 57.878 0 013.992-6.392c1.746-2.432 3.118-4.178 3.461-4.802.114-1.278.301-2.548.561-3.804a22.79 22.79 0 001.092-6.923c0-3.336-.967-8.201-1.622-15.154a192.42 192.42 0 01-1.84-22.389c.23-8.642 1.327-17.24 3.274-25.663a68.35 68.35 0 001.715-16.183c0-3.836.484-25.028-.297-33.432.373-4.085-1.473-52.169-1.473-52.169s11.13-.277 15.374.331c8.107.624 19.216-2.572 18.998.702z"
                  fill="url(#paint4_linear_5287_7562)"
                />
                <Path
                  id="Vector_23"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M128.738 340.136c.56 6.699.727 13.426.499 20.144-.249 2.214 2.245-.998 4.397-1.933a14.216 14.216 0 00-.218 9.354c1.122 2.838 1.434 4.054.218 4.865a5.946 5.946 0 00-1.96 1.939 5.949 5.949 0 00-.878 2.613c0 2.245-4.303 4.74-5.269 12.473a164.954 164.954 0 00.81 30.496 83.865 83.865 0 01.811 17.088 17.987 17.987 0 01-1.84 5.769 10.82 10.82 0 00-.187 3.461c0 .811-2.245 2.339-3.866 4.958-1.622 2.619-5.052 7.421-5.582 8.232a34.452 34.452 0 01-3.43 3.118 5.95 5.95 0 00-1.403 2.058c-.281.624.343.343 1.06-.592a8.853 8.853 0 015.176-2.931 11.535 11.535 0 00-3.523 3.555c-.406.873.467 1.933 1.684.467a17.418 17.418 0 015.425-3.773 12.163 12.163 0 00-3.118 3.742c-.312.904-.187 1.497.499 1.559.686.063 1.029-.249 1.964-1.652a14.805 14.805 0 014.834-3.836 14.55 14.55 0 00-1.84 2.62c-.281.748-.904 1.372-1.279 2.245-.374.873 0 1.153.375 1.746a2.557 2.557 0 002.744.187c.873-.499 1.184-.53 1.372-1.372a14.592 14.592 0 012.899-3.742 8.34 8.34 0 001.497-2.214 12.697 12.697 0 01-1.808 3.96 2.73 2.73 0 00-.556 1.22c-.082.446-.052.905.088 1.337.187.53 1.933.717 3.679.717 1.374.136 2.761.073 4.116-.187.749-.312 1.466-2.432 1.466-3.118.312.998 1.154.156 1.559-.935a8.506 8.506 0 01-1.559 3.835 3.862 3.862 0 01-2.494 3.461 10.98 10.98 0 01-5.707 0 2.767 2.767 0 01-1.272-1.155 2.768 2.768 0 01-.349-1.682 5.852 5.852 0 01-.905.498c-.374.219-.654 1.03-1.434 1.622a116.96 116.96 0 00-9.012-.592 2.928 2.928 0 01-3.617-.593 2.092 2.092 0 01-2.697-.48 2.095 2.095 0 01-.421-.892 4.083 4.083 0 011.809-4.521 17.91 17.91 0 004.272-5.177 57.721 57.721 0 013.991-6.392c1.746-2.432 3.118-4.178 3.461-4.802.114-1.278.301-2.548.561-3.804a22.79 22.79 0 001.092-6.923c0-3.336-.967-8.2-1.622-15.154a192.218 192.218 0 01-1.839-22.389 129.07 129.07 0 013.274-25.663 68.454 68.454 0 001.715-16.183c0-3.836-.308-26.101-1.056-33.523-.468-4.365-1.48-38.465-.83-37.645-.432-1.147 1.854 9.823 1.854 9.823l1.45 13.153s.932 8.711 1.788 13.264c-.927 3.128-1.491 11.884-.868 18.276z"
                  fill="url(#paint5_linear_5287_7562)"
                />
                <Path
                  id="Vector_24"
                  d="M132.762 359.315a10.103 10.103 0 00-1.217 5.644c.07.951.281 1.886.624 2.775.155.46.342.908.561 1.341.25.436.499.873.78 1.278a8.743 8.743 0 01-1.06-1.091 9.393 9.393 0 01-.811-1.31 8.013 8.013 0 01-.78-2.962 7.675 7.675 0 01.437-3.118 8.137 8.137 0 011.466-2.557z"
                  fill="#7E4336"
                />
                <Path
                  id="Vector_25"
                  d="M143.207 360.407a7.127 7.127 0 011.185 2.837 7.652 7.652 0 010 3.118 7.852 7.852 0 01-1.372 2.807 7.121 7.121 0 01-2.37 1.964 11.14 11.14 0 001.934-2.276 8.444 8.444 0 001.122-2.682 8.99 8.99 0 00.25-2.9 9.633 9.633 0 00-.749-2.868z"
                  fill="#7E4336"
                />
                <Path
                  id="Vector_26"
                  d="M135.381 463.525a2.574 2.574 0 00-1.247-.53 4.857 4.857 0 00-1.341 0 9.09 9.09 0 00-1.279.218 5.615 5.615 0 00-1.247.468 3.12 3.12 0 00-.842 1.029l-.281.53c-.162.14-.281.324-.343.53 0 .249 0 .53.375.623.236.048.48.048.717 0a4.42 4.42 0 011.091-.155c.384-.031.77-.031 1.154 0h2.307a1.347 1.347 0 001.248-.531 1.103 1.103 0 000-.405c.109-.224.173-.468.187-.717a1.378 1.378 0 00-.499-1.06zm0 2.182a.871.871 0 01-.873.188l-1.154-.219a7.38 7.38 0 00-1.185-.156h-1.216a7.424 7.424 0 00-1.185.281.975.975 0 01-.468 0s-.249 0-.249-.218a1.108 1.108 0 010-.406l.499-.561c.214-.323.503-.59.842-.779.361-.145.738-.25 1.122-.312h1.216a4.399 4.399 0 012.214.374 1.021 1.021 0 01.531.842c.015.124.015.25 0 .374a.936.936 0 01-.125.592h.031zm-10.789-1.372a3.65 3.65 0 00-1.31 0 3.129 3.129 0 00-2.183 1.466 2.22 2.22 0 00-.249.624 2.212 2.212 0 000 .717c0 .187 0 .218.281.187h.997l1.435.156c.259.019.52.019.779 0 .3.003.593-.084.842-.25.197-.135.358-.317.468-.53l.343-.53.187-.28a.848.848 0 000-.375 1.004 1.004 0 00-.343-.748 2.405 2.405 0 00-1.278-.437h.031zm1.154 1.435v.281c-.178.323-.45.584-.78.748a1.76 1.76 0 01-.561 0h-.717a6.2 6.2 0 00-1.528 0l-.593.156h-.312c.046-.162.109-.319.188-.468.062-.182.157-.351.28-.499a2.396 2.396 0 011.84-1.029c.384-.031.77-.031 1.154 0 .36.014.711.11 1.029.281a.443.443 0 01.218.343s-.25.125-.25.187h.032zm-6.424-1.216a2.377 2.377 0 00-2.058.218 2.223 2.223 0 00-1.029 1.621 2.188 2.188 0 012.027-1.41c.278 0 .554.055.811.163a.629.629 0 01.436.406c.062.256.062.523 0 .779a1.583 1.583 0 01-.374.717h-1.091a1.539 1.539 0 00-.655 0h-1.154c-.343 0 0 0-.187-.28a.689.689 0 010-.53 1.03 1.03 0 00-.374.904c0 .187.187.281.343.343.424.06.854.06 1.278 0h1.185c.232-.025.455-.099.655-.218a1.53 1.53 0 00.655-.811c.18-.334.236-.721.156-1.091a1.341 1.341 0 00-.655-.811h.031zm-3.617-.25a1.686 1.686 0 00-1.091-.561 2.336 2.336 0 00-2.027.873 2.833 2.833 0 00-.343.499 1.288 1.288 0 000-.748 1.153 1.153 0 00-.873-.53 1.56 1.56 0 00-.967.187c-.232.2-.422.444-.561.717a2.893 2.893 0 00-.312.717v.156c0 .156-.312.249-.374.53a.712.712 0 00.249.686.46.46 0 00.374.218h.188c.168.109.361.174.561.187a.935.935 0 00.655 0 .815.815 0 00.418-.277.818.818 0 00.174-.471 6.17 6.17 0 00.53-.717c-.113.166-.177.36-.187.561a.436.436 0 000 .374.595.595 0 00.343.219c.207.03.417.03.624 0h.499c.196.022.395.022.592 0 .24.023.48-.032.686-.156a2.86 2.86 0 00.53-.53c.303-.238.539-.549.686-.905a1.5 1.5 0 00-.405-1.029h.031zm-4.365 2.152a.754.754 0 01-.562.281.893.893 0 01-.405 0l-.437-.188h-.405a1.003 1.003 0 01-.187-.187c.151-.47.395-.904.717-1.278.133-.188.303-.347.499-.468a.754.754 0 01.592 0c.219 0 .343 0 .406.218.053.184.053.379 0 .562.031.218-.125.623-.25 1.029l.032.031zm3.991-1.06a2.248 2.248 0 01-.655 1.06H113.429a1.572 1.572 0 00-.655 0h-.499c-.156 0-.187 0-.249-.218.166-.519.455-.989.841-1.372a1.904 1.904 0 011.653-.531.98.98 0 01.686.344.922.922 0 01.094.717h.031z"
                  fill="#915548"
                />
              </G>
              <Path
                id="Vector_27"
                d="M127.801 466.153a6.462 6.462 0 000 1.56c.047.514.131 1.025.249 1.528.134.448.3.886.499 1.309l.499.904a3.77 3.77 0 01-2.12-1.808v-.187a8.896 8.896 0 010-3.524c.05-.603.231-1.188.53-1.715.34-.474.75-.895 1.216-1.247a8.14 8.14 0 001.029-1.247c.308-.451.569-.931.779-1.435a9.297 9.297 0 01-.53 1.559 6.194 6.194 0 01-.873 1.466c-.34.405-.653.832-.935 1.278a4.068 4.068 0 00-.343 1.559z"
                fill="#915548"
              />
              <Path
                id="Vector_28"
                d="M120.91 465.964a2.21 2.21 0 00-.312 1.372c.037.46.142.912.312 1.341.168.406.411.776.717 1.091l1.122 1.185c-.361.064-.73.064-1.091 0a3.07 3.07 0 01-.717-.343 2.742 2.742 0 01-1.185-1.465 3.462 3.462 0 01-.218-1.934 4.24 4.24 0 01.686-1.777 9.218 9.218 0 011.122-1.31c.374-.405.717-.842 1.06-1.278a13.28 13.28 0 012.495-2.276 11.83 11.83 0 00-2.12 2.557c-.312.436-.593.935-.905 1.403-.36.451-.683.931-.966 1.434z"
                fill="#915548"
              />
              <Path
                id="Vector_29"
                d="M116.046 466.309a3.13 3.13 0 000 1.591c.111.507.347.978.686 1.371a6.6 6.6 0 001.185 1.092l.967.686a5.359 5.359 0 01-2.588-.686l-.343-.406a4.85 4.85 0 01-.717-1.933 3.742 3.742 0 01.249-2.027 5.375 5.375 0 01.998-1.683c.412-.47.85-.918 1.31-1.341a20.082 20.082 0 012.962-2.183 19.976 19.976 0 00-2.588 2.557c-.374.468-.749.935-1.092 1.434-.436.44-.785.958-1.029 1.528z"
                fill="#915548"
              />
              <Path
                id="Vector_30"
                d="M112.241 465.345a4.566 4.566 0 000 1.59c.083.508.263.995.53 1.434.278.43.602.827.967 1.185.312.312.624.655 1.029.998a4.451 4.451 0 01-2.245-.811h-.156a3.117 3.117 0 01-.593-.841 4.626 4.626 0 01-.561-1.903 4.898 4.898 0 01.312-1.902 4.977 4.977 0 01.967-1.621c.405-.448.843-.865 1.309-1.247a7.734 7.734 0 013.118-1.684 5.585 5.585 0 00-1.527.842c-.466.361-.904.757-1.31 1.185-.408.395-.783.823-1.123 1.278-.34.444-.584.953-.717 1.497z"
                fill="#915548"
              />
              <G id="pressable_leftLeg_2">
                <G id="Group 27545_2">
                  <Path
                    id="Vector_31"
                    d="M139.982 468.268a5.486 5.486 0 01-5.987 4.584 9.384 9.384 0 01-3.555-.468 3.772 3.772 0 01-2.12-1.809 4.552 4.552 0 01-5.208 1.216 3.109 3.109 0 01-.717-.343 4.889 4.889 0 01-2.027.375 5.384 5.384 0 01-2.588-.686 3.139 3.139 0 01-1.309 0 4.463 4.463 0 01-2.245-.811h-.156c-3.118.717-5.052-3.118-3.617-5.8a14.017 14.017 0 013.118-3.492 18.252 18.252 0 003.492-5.052 62.96 62.96 0 014.927-7.359c.218-.343 1.559-2.089 1.684-2.401-.343-2.744 1.497-6.236 1.497-9.136a80.205 80.205 0 00-1.248-12.723c-1.278-11.599-3.274-23.23-1.808-34.923a117.265 117.265 0 012.837-17.369 45.868 45.868 0 001.31-8.325c.842-8.638-2.278-82.709-2.792-91.616-.132-3.44 8.613-2.651 13.866-2.651 5.886 0 25.412-2.082 24.598 2.623-.249 6.236-9.604 82.913-10.041 89.336a55.518 55.518 0 01-4.334 17.618c-1.995 5.332-.998 11.381-.873 17.057a51.014 51.014 0 01-1.871 18.023 158.547 158.547 0 00-4.147 17.087c-.655 5.707.873 10.01-.811 15.841.478 1.707.74 3.467.78 5.239 0 1.496-.218 3.741-.156 5.207-.02.754.14 1.503.468 2.183a7.863 7.863 0 01-.967 8.575z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_32"
                    d="M160.431 272.602c0 .468-6.424 52.666-6.642 54.256-1.341 8.856-3.477 32.588-3.914 36.798a54.567 54.567 0 01-3.835 14.749 32.009 32.009 0 00-1.372 14.437 62.678 62.678 0 01-.624 17.618c-1.31 5.582-3.648 13.502-4.677 18.242a50.552 50.552 0 000 12.971 13.099 13.099 0 01-.967 5.8 22.39 22.39 0 01.842 5.582 36.955 36.955 0 000 6.08 24.704 24.704 0 011.341 4.584c.017.145.017.292 0 .437a8.517 8.517 0 01-1.559 3.835 3.87 3.87 0 01-2.495 3.461 10.977 10.977 0 01-5.706 0 2.774 2.774 0 01-1.622-2.837 5.932 5.932 0 01-.904.499c-.374.218-.655 1.029-1.434 1.621a116.96 116.96 0 00-9.012-.592 2.93 2.93 0 01-3.617-.593 2.092 2.092 0 01-2.697-.48 2.09 2.09 0 01-.421-.892 4.083 4.083 0 011.808-4.521 17.894 17.894 0 004.272-5.177 57.73 57.73 0 013.992-6.392c1.746-2.432 3.118-4.178 3.461-4.802.114-1.278.301-2.548.561-3.804a22.759 22.759 0 001.091-6.923c0-3.336-.966-8.2-1.621-15.154a192.42 192.42 0 01-1.84-22.389c.23-8.642 1.327-17.24 3.274-25.663a68.35 68.35 0 001.715-16.183c0-3.836.483-25.028-.297-33.432.373-4.085-1.473-52.169-1.473-52.169s10.487-.223 15.101-.326c8.164-.256 19.489-1.915 19.271 1.359z"
                    fill="url(#paint6_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_33"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M129.91 340.452c.56 6.699.727 13.425.499 20.144-.249 2.214 2.245-.998 4.397-1.933a14.222 14.222 0 00-.219 9.354c1.123 2.838 1.435 4.054.219 4.865a5.965 5.965 0 00-1.961 1.938 5.969 5.969 0 00-.877 2.614c0 2.245-4.303 4.74-5.269 12.473a164.867 164.867 0 00.81 30.496 83.862 83.862 0 01.811 17.088 17.987 17.987 0 01-1.84 5.769 10.82 10.82 0 00-.187 3.461c0 .811-2.245 2.339-3.866 4.958-1.622 2.619-5.052 7.421-5.582 8.232a34.564 34.564 0 01-3.43 3.118 5.95 5.95 0 00-1.403 2.058c-.281.624.343.343 1.06-.592a8.853 8.853 0 015.176-2.931 11.535 11.535 0 00-3.523 3.555c-.406.873.467 1.933 1.683.467a17.405 17.405 0 015.426-3.773 12.151 12.151 0 00-3.118 3.742c-.312.904-.187 1.497.499 1.559.686.062 1.029-.249 1.964-1.653a14.822 14.822 0 014.833-3.835 14.624 14.624 0 00-1.839 2.619c-.281.749-.905 1.372-1.279 2.246-.374.873 0 1.153.374 1.746a2.56 2.56 0 002.744.187c.874-.499 1.185-.53 1.372-1.372a14.595 14.595 0 012.9-3.742 8.34 8.34 0 001.497-2.214 12.72 12.72 0 01-1.808 3.96 2.725 2.725 0 00-.556 1.22c-.082.446-.052.905.088 1.337.187.53 1.933.717 3.679.717a14.35 14.35 0 004.116-.187c.749-.312 1.466-2.432 1.466-3.118.312.998 1.154.156 1.559-.936a8.516 8.516 0 01-1.559 3.836 3.862 3.862 0 01-2.495 3.461 10.977 10.977 0 01-5.706 0 2.78 2.78 0 01-1.621-2.838 5.82 5.82 0 01-.905.499c-.374.219-.655 1.029-1.434 1.622a117.465 117.465 0 00-9.012-.593 2.928 2.928 0 01-3.617-.592 2.092 2.092 0 01-2.697-.48 2.095 2.095 0 01-.421-.892 4.083 4.083 0 011.809-4.521 17.91 17.91 0 004.272-5.177 57.573 57.573 0 013.991-6.392c1.746-2.432 3.118-4.178 3.461-4.802.114-1.278.301-2.548.561-3.804a22.79 22.79 0 001.092-6.923c0-3.336-.967-8.201-1.622-15.154a192.438 192.438 0 01-1.84-22.389c.23-8.642 1.327-17.24 3.275-25.663a68.454 68.454 0 001.715-16.183c0-3.836-.308-26.101-1.056-33.523-.468-4.365-1.48-38.465-.83-37.645-.432-1.147 1.854 9.823 1.854 9.823l1.45 13.153s.932 8.711 1.788 13.264c-.927 3.127-1.491 11.884-.868 18.276z"
                    fill="url(#paint7_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_34"
                    d="M133.933 359.631a10.11 10.11 0 00-1.216 5.644c.07.951.28 1.886.624 2.775.155.46.342.908.561 1.341.25.436.499.873.78 1.278a8.673 8.673 0 01-1.06-1.091 9.393 9.393 0 01-.811-1.31 8.013 8.013 0 01-.78-2.962 7.675 7.675 0 01.437-3.118 8.135 8.135 0 011.465-2.557z"
                    fill="#7E4336"
                  />
                  <Path
                    id="Vector_35"
                    d="M144.379 360.723a7.127 7.127 0 011.185 2.837 7.652 7.652 0 010 3.118 7.852 7.852 0 01-1.372 2.807 7.131 7.131 0 01-2.37 1.964 11.14 11.14 0 001.934-2.276 8.444 8.444 0 001.122-2.682 8.99 8.99 0 00.25-2.9 9.633 9.633 0 00-.749-2.868z"
                    fill="#7E4336"
                  />
                  <Path
                    id="Vector_36"
                    d="M136.553 463.841a2.578 2.578 0 00-1.247-.53 4.857 4.857 0 00-1.341 0 9.09 9.09 0 00-1.279.218 5.615 5.615 0 00-1.247.468 3.096 3.096 0 00-.842 1.029l-.281.53c-.162.14-.281.324-.343.53 0 .249 0 .53.375.624.236.047.48.047.717 0 .355-.098.722-.15 1.091-.156.384-.031.77-.031 1.154 0H135.617a1.347 1.347 0 001.248-.53 1.108 1.108 0 000-.406c.109-.224.173-.468.187-.717a1.378 1.378 0 00-.499-1.06zm0 2.183a.879.879 0 01-.873.187l-1.154-.219a7.38 7.38 0 00-1.185-.156h-1.216a7.398 7.398 0 00-1.185.281.975.975 0 01-.468 0s-.249 0-.249-.218a1.108 1.108 0 010-.406l.499-.561c.214-.323.503-.59.842-.779.361-.145.738-.25 1.122-.312h1.216a4.399 4.399 0 012.214.374 1.03 1.03 0 01.53.842c.016.124.016.25 0 .374a.933.933 0 01-.124.593h.031zm-10.789-1.372a3.605 3.605 0 00-1.31 0 3.107 3.107 0 00-2.183 1.465 2.162 2.162 0 00-.249.624 2.212 2.212 0 000 .717c0 .187 0 .218.281.187h.997l1.435.156c.259.019.52.019.779 0 .3.003.593-.084.842-.249a1.46 1.46 0 00.468-.531l.343-.53.187-.28a.848.848 0 000-.375.989.989 0 00-.343-.748 2.398 2.398 0 00-1.278-.436h.031zm1.154 1.434v.281c-.178.323-.45.584-.78.748a1.76 1.76 0 01-.561 0h-.718a6.192 6.192 0 00-1.527 0l-.593.156h-.312c.046-.162.109-.319.187-.468.063-.182.158-.351.281-.499a2.396 2.396 0 011.84-1.029c.384-.031.77-.031 1.154 0 .359.014.711.11 1.029.281a.443.443 0 01.218.343s-.25.125-.25.187h.032zm-6.424-1.216a2.377 2.377 0 00-2.058.218 2.223 2.223 0 00-1.029 1.622 2.182 2.182 0 012.027-1.411c.278 0 .554.055.811.163a.617.617 0 01.436.406c.062.256.062.523 0 .779-.061.268-.19.515-.374.717h-1.091a1.539 1.539 0 00-.655 0h-1.154c-.343 0 0 0-.187-.28a.689.689 0 010-.53 1.03 1.03 0 00-.374.904c0 .187.187.281.343.343.424.06.854.06 1.278 0h1.185c.232-.025.455-.099.655-.218a1.53 1.53 0 00.655-.811c.18-.334.235-.721.156-1.091a1.341 1.341 0 00-.655-.811h.031zm-3.617-.25a1.686 1.686 0 00-1.091-.561 2.336 2.336 0 00-2.027.873 2.833 2.833 0 00-.343.499 1.288 1.288 0 000-.748 1.153 1.153 0 00-.874-.53 1.556 1.556 0 00-.966.187c-.232.2-.422.444-.561.717a2.893 2.893 0 00-.312.717v.156c0 .156-.312.249-.374.53a.712.712 0 00.249.686.465.465 0 00.374.218h.187c.169.109.362.174.562.188a.943.943 0 00.654 0 .822.822 0 00.419-.278.818.818 0 00.174-.471c.193-.226.371-.466.53-.717-.113.166-.177.36-.187.561a.436.436 0 000 .374.592.592 0 00.343.219c.207.03.417.03.624 0h.498c.197.022.396.022.593 0 .239.023.48-.032.686-.156a2.86 2.86 0 00.53-.53c.302-.238.539-.549.686-.905a1.5 1.5 0 00-.405-1.029h.031zm-4.366 2.152a.75.75 0 01-.561.281.893.893 0 01-.405 0l-.437-.187h-.405a1.04 1.04 0 01-.187-.188c.151-.47.395-.904.717-1.278.133-.188.303-.347.499-.468a.75.75 0 01.592 0c.218 0 .343 0 .406.218.053.184.053.379 0 .562.031.218-.125.623-.25 1.029l.031.031zm3.992-1.06a2.248 2.248 0 01-.655 1.06H114.601a1.572 1.572 0 00-.655 0h-.499c-.156 0-.187 0-.25-.218.167-.518.456-.989.842-1.372a1.903 1.903 0 011.653-.53.956.956 0 01.686.343.94.94 0 01.093.717h.032z"
                    fill="#915548"
                  />
                </G>
                <Path
                  id="Vector_37"
                  d="M128.973 466.47a6.453 6.453 0 000 1.559c.047.514.131 1.025.249 1.528.133.448.3.886.499 1.309l.499.905a3.776 3.776 0 01-2.12-1.809v-.187a8.896 8.896 0 010-3.524c.05-.603.231-1.188.53-1.715.34-.474.75-.895 1.216-1.247a8.15 8.15 0 001.029-1.247c.308-.45.569-.931.779-1.435a9.338 9.338 0 01-.53 1.56 6.207 6.207 0 01-.873 1.465c-.34.405-.653.832-.935 1.278a4.073 4.073 0 00-.343 1.56z"
                  fill="#915548"
                />
                <Path
                  id="Vector_38"
                  d="M122.082 466.28a2.21 2.21 0 00-.312 1.372c.037.46.142.912.312 1.341.168.406.411.776.717 1.091l1.122 1.185c-.361.064-.73.064-1.091 0a3.07 3.07 0 01-.717-.343 2.738 2.738 0 01-1.185-1.465 3.457 3.457 0 01-.218-1.933c.09-.637.325-1.245.685-1.778a9.225 9.225 0 011.123-1.31c.374-.405.717-.841 1.06-1.278a13.28 13.28 0 012.495-2.276 11.888 11.888 0 00-2.121 2.557c-.311.436-.592.935-.904 1.403-.36.451-.683.931-.966 1.434z"
                  fill="#915548"
                />
                <Path
                  id="Vector_39"
                  d="M117.218 466.625a3.13 3.13 0 000 1.591c.111.507.347.979.686 1.372.349.411.747.777 1.185 1.091l.967.686a5.356 5.356 0 01-2.588-.686l-.343-.405a4.854 4.854 0 01-.717-1.934 3.728 3.728 0 01.249-2.026 5.35 5.35 0 01.998-1.684c.412-.47.85-.918 1.31-1.341a20.082 20.082 0 012.962-2.183 19.976 19.976 0 00-2.588 2.557 24.51 24.51 0 00-1.092 1.435 4.918 4.918 0 00-1.029 1.527z"
                  fill="#915548"
                />
                <Path
                  id="Vector_40"
                  d="M113.413 465.661a4.566 4.566 0 000 1.59c.083.508.263.995.53 1.435.278.429.602.826.967 1.185.312.311.623.654 1.029.997a4.46 4.46 0 01-2.245-.81h-.156a3.137 3.137 0 01-.593-.842 4.626 4.626 0 01-.561-1.902 4.903 4.903 0 01.312-1.903 4.977 4.977 0 01.967-1.621c.405-.448.842-.864 1.309-1.247a7.734 7.734 0 013.118-1.684 5.605 5.605 0 00-1.528.842c-.465.362-.903.758-1.309 1.185-.408.395-.783.823-1.123 1.278a4.03 4.03 0 00-.717 1.497z"
                  fill="#915548"
                />
                <Path
                  id="highlight_leftLeg"
                  d="M144.4 269.378c-12.348.203-14.383-.136-20.354.407l2.215 88.738c.301 7.654-1.148 11.203-2.5 18.5-5 27 1 46.5 1 61.5-1.007 3.033-1.418 4.695-1.5 7.5l-8.5 13-2.5 3c-4.5 2.5-2.5 9.5 2.001 8 1.217.85 2.006.858 3.5.5 1.724.659 2.748.91 5 .5 2.497.443 4.499 1.5 6-.5 2.999 5 10.999 2.5 12-2.5 1.999-2.5 1.965-5.361-.035-9.861.549-3.841.566-6.248-.466-10.639 1.342-3.17 1.228-6.666 1-9-.923-6.623-.1-10.2 2-16.5 4.276-15.255 5-18.5 3-36-1-2.5 6-14 6-25l10.059-90.16c-2.519-2.91-10.864-2.164-17.92-1.485z"
                  fill="#A430FF"
                  fillOpacity={0.25}
                  stroke="#A430FF"
                  strokeWidth={1.5}
                  opacity={highlightedParts.includes(BODY_PARTS.leg) ? 1 : 0}
                />
              </G>
            </G>
            <Path
              id="Vector 10"
              d="M122.29 271.505c-.937-16.818 1.932-25.494 5.698-40.111 26.068 4.539 39.286 4.268 60.805-.377 7.11 15.931 7.562 24.964 6.927 41.115l-36.716.069-36.714-.696z"
              fill="#915548"
            />
            <Path
              id="Vector 11"
              d="M123.905 271.545c-.894-16.818 1.715-25.395 5.306-40.012 24.318 3.348 37.174 4.129 57.686-.516 6.779 15.931 7.21 24.964 6.604 41.115l-35 .069-34.596-.656z"
              fill="url(#paint8_linear_5287_7562)"
            />
            <Path
              id="Vector 15"
              d="M185.866 188.648c.478-4.316 3.581-10.527 3.581-10.527l.846 8.149-3.681 42.205 1.494-26.136s-2.837-8.306-2.24-13.691z"
              fill="#DD976A"
            />
            <G id="Group 27557">
              <Path
                id="Vector_41"
                d="M150.619 135.075c-53.295 7.584-25.801 7.8-25.164 22.217.182 13.9-.544 18.662-.023 27.197.102 7.876 2.572 38.614 2.552 47.328 6.485 3.389 59.847 1.73 60.807-.785 0 0 2.75-40.829 3.174-48.25-.008-8.178 5.483-31.982 2.584-42.092-4.115-1.065-6.59-1.734-9.519-2.131-14.924-2.239-13.394-4.304-34.411-3.484z"
                fill="#915548"
              />
              <Path
                id="Vector_42"
                d="M186.895 231.04c-2.292 4.151-29.655 4.071-40.225 3.852-7.406-.083-15.04-1.773-17.16-2.732 0 0-.683-12.515-.767-14.626-.053-1.053-.301-5.451-.423-7.816 0 0-.022-3.625-.422-8.977-.4-5.353-1.189-30.857-2.291-42.903-2.012-19.899-11.447-14.514 17.185-20.26 18.18-4.525 50.613 4.034 50.613 4.034-.208 15.36-6.51 89.428-6.51 89.428z"
                fill="url(#paint9_linear_5287_7562)"
              />
              <Path
                id="Vector 14"
                d="M126.391 167.735c-.128-2.274-.085-3.79-.085-3.79.028 1.289.056 2.552.085 3.79.355 6.293 2.022 18.39 9.541 20.211 3.284.795-4.262 2.556-5.608 6.509-2.78 8.169 1.392 18.052.554 26.64-.516 5.301-1.553 11.885-1.553 11.885-1.494-24.551-2.334-39.625-2.934-65.245z"
                fill="url(#paint10_linear_5287_7562)"
              />
              <Path
                id="Vector 13"
                d="M157.467 179.296c-.677 4.88-2.68 7.44-7.649 9.019-.229.073-.174.458.066.452l16.038-.373c.239-.005.278-.395.048-.458-4.892-1.348-6.989-3.871-7.981-8.657-.048-.236-.489-.221-.522.017z"
                fill="#DD976A"
              />
              <Ellipse
                id="Ellipse 1"
                cx={139.533}
                cy={179.607}
                rx={2.42566}
                ry={1.49792}
                fill="#D4885F"
              />
              <Ellipse
                id="Ellipse 3"
                cx={159.008}
                cy={226.79}
                rx={2.42566}
                ry={1.49792}
                fill="#915548"
              />
              <Ellipse
                id="Ellipse 2"
                cx={175.666}
                cy={180.64}
                rx={2.42566}
                ry={1.49792}
                fill="#D4885F"
              />
            </G>
            <G id="pressable_hips" clipPath="url(#clip0_5287_7562)">
              <G id="Group 27542">
                <Path
                  id="Vector_43"
                  d="M201.949 293.303c.297 3.177-5.68 3.478-8.276 3.92-10.118 1.056-21.343 1.201-31.499.434-2.913-.048-4.463-.001-4.631-1.62-.298 1.006-.445 1.717-1.939 1.823-11.09 1.37-21.351 1.48-32.476.328-3.412-.576-10.841-.965-9.675-5.31 3.179-16.76 6.475-33.494 10.83-50.078 0-.141.064-.283.106-.425-.36-2.849-.307-5.973-.36-8.849 1.059-4.309 15.798-.085 22.305-.195 13.126.551 13.236 1.434 36.729-2.647 2.12.46 7.325-1.954 7.908.276a69.47 69.47 0 01.9 10.619c.02.078.045.155.074.23 0 .124.075.239.117.363 2.31 7.424 5.182 14.822 6.496 22.486 1.547 9.548 2.31 19.088 3.391 28.645z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_44"
                  d="M125.364 233.621s0 6.894.35 8.849c-3.402 12.133-10.597 48.388-10.937 51.388-.339 3 13.777 3.743 21.523 3.893 6.734.069 13.464-.283 20.135-1.053 1.261-.301 1.971-5.69 2.119-8.238.901 3.743-.71 7.637 3.412 7.964 6.5.488 13.03.639 19.552.451 6.994-.301 19.371-.885 19.011-3.292-.36-2.407-2.119-23.07-3.762-30.866-1.643-7.796-5.744-18.725-6.273-20.964a69.345 69.345 0 00-.901-10.619c-.361-1.769-16.905 3.307-31.815 3.608-14.91.301-31.884-4.112-32.414-1.121z"
                  fill="url(#paint11_radial_5287_7562)"
                />
                <Path
                  id="Vector_45"
                  d="M200.529 293.585c.36 2.398-12.017 2.991-19.075 3.291-5.08.168-10.167.106-15.238-.185a247.345 247.345 0 01-4.313-.266c-5.132-.218-2.512-4.194-3.402-7.964-.18 2.548-1.901 7.964-3.119 8.238h-.064c-6.636.76-12.331 1.109-19.028 1.045a121.684 121.684 0 01-15.652-1.16c-3.519-.584-6.03-1.451-5.871-2.734.36-3 7.534-39.255 10.947-51.387-.361-1.947-.361-8.85-.361-8.85.541-2.991 16.477 2.312 31.365 2.012 14.889-.301 32.493-6.348 32.875-4.551.573 3.519.874 7.066.901 10.619.095.407.317 1.106.625 2.017 1.335 4.106 4.334 12.575 5.648 18.955 1.611 7.814 3.402 28.486 3.762 30.92z"
                  fill="url(#paint12_radial_5287_7562)"
                />
                <Path
                  id="Vector_46"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M186.911 260.302c-.138-6.698-2.119-10.973-3.454-12.937-1.336-1.965-4.144-.575-4.239 3.124a35.528 35.528 0 01-1.516 9.583c.52-6.07-.551-11.548-2.119-13.052-1.568-1.505-5.807-1.036-6.92 0-1.113 1.035-.138 11.442-2.49 15.132-.138-6.354-2.067-12.938-3.179-14.672-1.113-1.735-4.144-1.965-6.772-1.965s-6.093 1.85-6.92 5.779c-.826 3.929-2.119 7.513-2.119 8.318-.551-5.194-.689-9.734-.827-11.433-.138-1.699-3.179-2.779-6.093-2.54-2.914.239-3.317 8.08-3.593 11.318-1.903-2.164-3.337-4.59-4.238-7.167-.689-1.841-3.455-.461-3.868 5.663-.414 6.124-4.568 14.557-4.981 19.867-.381 4.911-2.776 15.734-2.914 21.238-3.518-.584-6.03-1.452-5.871-2.735.36-3 7.535-39.255 10.947-51.387-.36-1.947-.36-8.849-.36-8.849.54-2.991 17.15 1.985 32.039 1.685 14.889-.301 31.819-6.022 32.2-4.225.573 3.52.874 7.067.901 10.619.095.407.318 1.106.625 2.018-2.003 0-3.296.486-3.773 1.663-.741 1.788 2.046 9.761-.466 14.955z"
                  fill="url(#paint13_linear_5287_7562)"
                />
                <Path
                  id="Vector_47"
                  d="M129.91 235.516c.085.629.127 1.248.18 1.868l.096 1.867v3.743c-.085-.31-.18-.611-.244-.885a16.905 16.905 0 01-.18-.929 16.056 16.056 0 01-.18-1.876c-.022-.619 0-1.257 0-1.885.065-.639.175-1.274.328-1.903z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_48"
                  d="M134.87 235.509c.085.672.127 1.336.148 1.991.022.654 0 1.318 0 1.982 0 .664-.106 1.318-.127 1.973-.021.655 0 1.31 0 1.974a6.675 6.675 0 01-.445-1.965c-.063-.664 0-1.327 0-1.991 0-.664.085-1.327.149-1.991.063-.664.137-1.319.275-1.973z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_49"
                  d="M139.119 235.88c.096.664.17 1.328.212 1.982a59.3 59.3 0 01.106 1.974c.021.655 0 1.292 0 1.982v1.734a.125.125 0 000 .107h.053c-.042 0 0 .106-.085.062a.18.18 0 01-.063-.133l-.064-.239-.095-.496c-.064-.33-.117-.657-.159-.982a25.299 25.299 0 01-.159-1.982c-.021-.655 0-1.328 0-1.991.041-.676.126-1.35.254-2.018z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_50"
                  d="M143.972 237.287a6.05 6.05 0 00.138 1.69 9.08 9.08 0 01.212 1.726c0 .584-.117 1.159-.191 1.717a8.178 8.178 0 00-.095 1.69 3.74 3.74 0 01-.413-1.708v-1.708-1.69a3.471 3.471 0 01.349-1.717z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_51"
                  d="M148.752 238.474c.117.46.202.885.265 1.389.064.505.096.885.127 1.381.032.495 0 .885 0 1.398-.016.466-.069.93-.158 1.389a9.087 9.087 0 01-.276-1.38c-.064-.46-.095-.929-.117-1.389-.021-.461 0-.93 0-1.39 0-.46.075-.929.159-1.398z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_52"
                  d="M153.308 239.437c.108.385.186.775.233 1.168.053.39.085.779.106 1.169.021.389 0 .778 0 1.168a5.654 5.654 0 01-.223 1.168 6.674 6.674 0 01-.254-1.168c0-.39-.074-.779-.074-1.168 0-.39 0-.779.063-1.169.025-.391.074-.781.149-1.168z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_53"
                  d="M157.716 237.435c.138.549.254 1.106.329 1.664.074.557.137 1.106.169 1.663.032.558 0 1.106 0 1.664a12.832 12.832 0 01-.159 1.681 13.249 13.249 0 01-.339-1.663 21.887 21.887 0 01-.159-1.664c-.032-.558 0-1.106 0-1.664 0-.557.074-1.124.159-1.681z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_54"
                  d="M162.316 236.473c-.01.297.018.593.085.885 0 .327.084.637.127.938.074.619.148 1.239.18 1.867.032.628 0 1.248 0 1.867-.004.63-.05 1.26-.138 1.885a16.627 16.627 0 01-.318-1.867 27.933 27.933 0 01-.148-1.867c-.032-.62 0-1.248 0-1.876-.01-.615.061-1.23.212-1.832z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_55"
                  d="M166.533 235.738c.138.69.265 1.38.35 2.079.084.699.148 1.389.201 2.089.053.699.053 1.398 0 2.097-.053.699 0 1.398-.106 2.106a23.738 23.738 0 01-.36-2.088c-.096-.7-.149-1.39-.191-2.089-.042-.699 0-1.389 0-2.088 0-.699.053-1.407.106-2.106z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_56"
                  d="M171.483 234.693c.356.744.554 1.535.583 2.336 0 .788.074 1.575.074 2.363s0 1.566-.095 2.354c-.096.788-.128 1.566-.265 2.354-.138-.788-.202-1.575-.255-2.354a34.993 34.993 0 01-.074-2.363c0-.787 0-1.566.085-2.354a9.091 9.091 0 00-.053-2.336z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_57"
                  d="M176.611 234.182c.138.814.255 1.628.329 2.442.074.814.148 1.619.18 2.442.032.823 0 1.629 0 2.443 0 .814 0 1.637-.148 2.451-.17-.814-.265-1.628-.35-2.442-.085-.815-.127-1.62-.17-2.434-.042-.814 0-1.628 0-2.451 0-.823.085-1.629.159-2.451z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_58"
                  d="M181.422 233.962c.191.787.35 1.575.466 2.371.117.797.223 1.593.307 2.39.085.796.138 1.592.117 2.407a5.083 5.083 0 01-.583 2.38 8.133 8.133 0 00.074-2.372c-.095-.805-.18-1.592-.265-2.371a30.122 30.122 0 01-.137-2.398 29.723 29.723 0 01.021-2.407z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_59"
                  d="M186.043 233.216c.225.782.398 1.573.519 2.371.117.797.191 1.593.223 2.398.032.806 0 1.602-.085 2.407-.066.801-.2 1.596-.403 2.381-.074-.806-.095-1.602-.127-2.39-.032-.787 0-1.601-.074-2.389v-2.38c-.042-.744-.042-1.505-.053-2.398z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_60"
                  d="M192.062 242.153l-5.044.743-3.031.434h-.084c-1.06.168-2.226.345-3.338.54a30.689 30.689 0 01-3.105.389h-.17c-1.06.062-2.194.106-3.296.133-2.193.062-4.387.079-6.57.07h-13.119c-1.897 0-3.794 0-5.68-.079h-.064a188.613 188.613 0 01-7.418-.319c-2.479-.15-4.895-.371-7.333-.593a332.67 332.67 0 00-5.065-.442h-.085l-.53-.044a111.407 111.407 0 00-3.825-.222c0-.141.063-.283.106-.424 1.261 0 2.511.088 3.762.168 4.376.265 8.721.717 13.066.938 4.345.221 8.721.345 13.087.336h6.56l6.559.044h6.549c1.06 0 2.183-.053 3.264-.106h.117a36.722 36.722 0 003.094-.345c1.06-.168 2.035-.319 3.063-.451l3.412-.452 5.023-.637c.011.08.053.195.095.319z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_61"
                  d="M148.656 244.074c-.063 1.026-.159 2.044-.254 3.062a267.204 267.204 0 01-.307 3.053c-.106 1.009-.233 2.009-.361 3.044-.127 1.035-.254 1.947-.402 3.053 0-1.027-.074-2.053 0-3.08.074-1.026.106-2.044.201-3.061.095-1.018.265-2.036.456-3.053.191-1.018.381-2.018.667-3.018z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_62"
                  d="M133.799 243.294c.149 1.071.286 2.045.424 3 .138.956.308 1.991.467 2.982l.498 2.983.529 2.982a28.499 28.499 0 01-.964-2.92 32.455 32.455 0 01-.646-2.983c-.17-1-.255-2.008-.318-3.017a24.073 24.073 0 01.01-3.027z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_63"
                  d="M128.892 242.771a7.724 7.724 0 00-.859 2.752c-.148.947-.233 1.911-.402 2.867-.17.956-.339 1.894-.541 2.841a67.952 67.952 0 01-.678 2.84c.053-.964.127-1.929.223-2.884a65.45 65.45 0 01.36-2.876c.138-.956.307-1.912.551-2.859a6.19 6.19 0 011.346-2.681z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_64"
                  d="M177.354 243.676a42.58 42.58 0 01.519 3.424c.127 1.142.212 2.301.275 3.452.064 1.15 0 2.3 0 3.451 0 1.15-.106 2.301-.222 3.442-.074-1.23-.138-2.336-.202-3.442-.063-1.106-.106-2.301-.169-3.434l-.127-3.442-.074-3.451z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_65"
                  d="M164.107 243.846c.329.637.626 1.274.901 1.938a25.14 25.14 0 011.643 6.088c.183 1.384.251 2.777.201 4.168 0 .691-.085 1.381-.169 2.071-.085.69-.212 1.381-.35 2.062.116-1.38.138-2.761.106-4.141a35.4 35.4 0 00-.35-4.106 38.503 38.503 0 00-.773-4.071 42.976 42.976 0 00-1.209-4.009z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_66"
                  d="M183.488 242.861c.58.492.993 1.102 1.198 1.77.286.637.551 1.275.795 1.929a30.813 30.813 0 011.197 3.947c.599 2.674.834 5.397.699 8.115a56.539 56.539 0 00-.498-4.035 58.959 58.959 0 00-.773-3.991c-.308-1.337-.636-2.655-1.06-3.938a61.804 61.804 0 00-.625-1.956 3.795 3.795 0 00-.933-1.841z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_67"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M167.638 285.257c5.401-2.512 10.208-5.909 14.162-10.009-2.089 6.236-9.134 10.851-12.746 13.658-2.655 2.089-2.337 4.085-1.664 7.982l-4.563-.531c-5.232-.326-2.27-4.146-3.297-8.106-.177 2.682-.803 8.048-2.042 8.391.151-1.791-.062-3.283-.401-5.055-.531-2.432-3.54-3.305-6.196-4.521-3.202-1.201-5.968-3.154-7.997-5.645-2.03-2.49-3.243-5.424-3.509-8.48 3.328 4.396 8.32 9.853 11.506 10.976 3.187 1.122 3.045-1.341 2.054-2.588-.991-1.248-4.001-1.435-6.373-4.491-2.136-3.87-2.806-8.242-1.912-12.473 2.337 6.237 4.992 12.037 8.143 14.126 3.151 2.089 6.373 1.59 7.612 3.399 1.24 1.808 17.455-11.943 21.598-20.456-.573 5.696-3.036 11.118-7.081 15.591-3.23 3.247-7.121 5.934-11.472 7.921-2.478 1.34.283 1.871 4.178.311z"
                  fill="url(#paint14_linear_5287_7562)"
                />
                <Path
                  id="Vector_68"
                  d="M181.27 263.494a37.98 37.98 0 01-.956 2.807l-.566 1.403-.673 1.341-.708 1.34-.779 1.31c-.567.842-1.133 1.684-1.77 2.495a48.815 48.815 0 01-1.983 2.37l-1.098 1.122-1.133 1.091-1.203 1.03-1.24.966-2.655 1.777 1.239-.966 1.204-.998a69.152 69.152 0 002.301-2.12l1.063-1.092 1.061-1.122c.673-.78 1.346-1.559 1.948-2.339a47.496 47.496 0 001.806-2.463l.814-1.279.743-1.278c.496-.873.956-1.746 1.417-2.651l.602-1.372.566-1.372z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_69"
                  d="M180.243 277.278a26.387 26.387 0 01-2.549 2.9 32.066 32.066 0 01-3.045 2.525 26.065 26.065 0 01-3.54 2.121 29.59 29.59 0 01-3.541 1.652 39.71 39.71 0 003.541-2.026 57.602 57.602 0 003.293-2.183 43.703 43.703 0 003.08-2.401 35.503 35.503 0 002.761-2.588z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_70"
                  d="M144.803 266.489a18.54 18.54 0 00.672 3.118c0 .499.319.998.496 1.466.177.467.354.997.567 1.496a29.59 29.59 0 001.31 2.838 32.667 32.667 0 001.663 2.775 14.959 14.959 0 01-2.053-2.588 20.647 20.647 0 01-1.487-2.869 18.958 18.958 0 01-.885-3.118 18.878 18.878 0 01-.283-3.118z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_71"
                  d="M140.27 274.627a27.89 27.89 0 002.053 3.711 17.51 17.51 0 002.868 3.118 31.906 31.906 0 003.54 2.744c1.204.842 2.479 1.684 3.541 2.495-1.345-.655-2.726-1.341-4.036-2.12a27.073 27.073 0 01-3.541-2.682 15.79 15.79 0 01-2.762-3.43 21.352 21.352 0 01-1.663-3.836z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_72"
                  d="M154.326 280.427c.637.81 1.275 1.621 1.877 2.463a68.651 68.651 0 011.735 2.557 13.804 13.804 0 011.416 2.744c.376.951.473 1.969.283 2.962a7.613 7.613 0 00-.779-2.806 22.176 22.176 0 00-1.522-2.619 67.446 67.446 0 01-1.558-2.62 66.763 66.763 0 01-1.452-2.681z"
                  fill="#1C1E1F"
                />
              </G>
              <G id="highlight_hips">
                <G id="Group 27542_2">
                  <Path
                    id="Vector_73"
                    d="M202.226 293.508c.297 3.177-5.68 3.478-8.276 3.92-10.118 1.056-21.343 1.201-31.498.434-2.913-.048-4.464-.001-4.631-1.62-.299 1.006-.446 1.717-1.939 1.823-11.09 1.37-21.351 1.48-32.477.328-3.412-.576-10.84-.965-9.675-5.31 3.179-16.76 6.475-33.494 10.831-50.078 0-.141.063-.283.105-.424-.36-2.85-.307-5.974-.36-8.85 1.06-4.309 15.798-.085 22.306-.195 13.125.551 13.235 1.434 36.729-2.647 2.119.46 7.324-1.954 7.907.276.572 3.52.873 7.067.901 10.619.019.078.044.155.074.23 0 .124.074.239.116.363 2.31 7.424 5.182 14.822 6.496 22.486 1.548 9.548 2.311 19.088 3.391 28.645z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_74"
                    d="M124.641 233.826s0 6.894.35 8.849c-3.402 12.133-10.597 48.388-10.936 51.388-.339 3 13.776 3.743 21.522 3.893 6.734.069 13.464-.283 20.135-1.053 1.261-.3 1.971-5.69 2.119-8.238.901 3.743-.71 7.637 3.413 7.964 6.499.488 13.029.639 19.551.451 6.994-.3 19.372-.885 19.011-3.292-.36-2.407-2.119-23.069-3.762-30.866-1.642-7.796-5.743-18.725-6.273-20.963a69.347 69.347 0 00-.901-10.62c-.36-1.769-16.905 3.307-31.815 3.608-14.91.301-31.884-4.112-32.414-1.121z"
                    fill="url(#paint15_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_75"
                    d="M199.806 293.79c.361 2.398-12.017 2.991-19.074 3.292-5.08.168-10.167.106-15.239-.186a247.345 247.345 0 01-4.313-.266c-5.132-.218-2.511-4.194-3.402-7.964-.18 2.548-1.9 7.964-3.119 8.239h-.064c-6.636.759-12.33 1.108-19.028 1.044a121.876 121.876 0 01-15.652-1.159c-3.518-.585-6.03-1.452-5.871-2.735.361-3 7.535-39.255 10.947-51.387-.36-1.947-.36-8.85-.36-8.85.54-2.991 16.476 2.313 31.365 2.012 14.889-.301 32.493-6.348 32.874-4.551.573 3.52.874 7.067.901 10.619.095.407.318 1.106.625 2.017 1.335 4.106 4.334 12.575 5.648 18.955 1.611 7.814 3.402 28.486 3.762 30.92z"
                    fill="url(#paint16_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_76"
                    style={{
                      mixBlendMode: 'multiply',
                    }}
                    d="M186.189 260.508c-.138-6.699-2.12-10.974-3.455-12.938-1.335-1.965-4.144-.575-4.239 3.124a35.566 35.566 0 01-1.515 9.583c.519-6.07-.551-11.548-2.12-13.052-1.568-1.505-5.807-1.036-6.92 0-1.112 1.035-.137 11.442-2.49 15.132-.138-6.354-2.066-12.938-3.179-14.672s-4.144-1.965-6.772-1.965-6.093 1.85-6.919 5.779c-.827 3.929-2.12 7.513-2.12 8.318-.551-5.194-.689-9.734-.826-11.433-.138-1.699-3.18-2.779-6.094-2.54-2.914.239-3.317 8.08-3.592 11.319-1.903-2.165-3.338-4.591-4.239-7.168-.689-1.841-3.455-.461-3.868 5.663-.413 6.124-4.567 14.557-4.981 19.867-.381 4.911-2.776 15.734-2.914 21.238-3.518-.584-6.029-1.451-5.87-2.735.36-2.999 7.534-39.255 10.946-51.387-.36-1.947-.36-8.849-.36-8.849.54-2.991 17.151 1.985 32.04 1.685 14.889-.301 31.818-6.021 32.199-4.225.573 3.52.874 7.067.901 10.619.095.407.318 1.106.625 2.018-2.002 0-3.295.486-3.772 1.663-.742 1.788 2.045 9.761-.466 14.956z"
                    fill="url(#paint17_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_77"
                    d="M129.188 235.722c.084.628.127 1.247.18 1.867l.095 1.867v3.743c-.085-.31-.18-.61-.244-.885a17.9 17.9 0 01-.18-.929 16.275 16.275 0 01-.18-1.876c-.021-.619 0-1.257 0-1.885.065-.639.175-1.274.329-1.902z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_78"
                    d="M134.147 235.714c.085.672.128 1.336.149 1.991.021.655 0 1.318 0 1.982 0 .664-.106 1.318-.127 1.973-.022.655 0 1.31 0 1.974a6.637 6.637 0 01-.445-1.965c-.064-.664 0-1.327 0-1.991 0-.664.084-1.327.148-1.991.064-.664.138-1.319.275-1.973z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_79"
                    d="M138.397 236.085c.095.664.169 1.328.212 1.982.042.655.084 1.319.106 1.974.021.655 0 1.292 0 1.982v1.734a.119.119 0 000 .107h.052c-.042 0 0 .106-.084.062a.178.178 0 01-.064-.133l-.063-.239-.096-.496c-.063-.33-.116-.657-.159-.982a25.299 25.299 0 01-.159-1.982c-.021-.655 0-1.327 0-1.991.042-.676.126-1.35.255-2.018z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_80"
                    d="M143.25 237.492a6.049 6.049 0 00.137 1.69 9.08 9.08 0 01.212 1.726c0 .584-.116 1.159-.19 1.717a8.11 8.11 0 00-.096 1.69 3.75 3.75 0 01-.413-1.708v-1.708-1.69a3.474 3.474 0 01.35-1.717z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_81"
                    d="M148.03 238.679c.116.46.201.885.265 1.39.063.504.095.884.127 1.38.032.496 0 .885 0 1.398-.016.466-.069.93-.159 1.39a9.124 9.124 0 01-.276-1.381 15.48 15.48 0 01-.116-1.389c-.021-.46 0-.929 0-1.39 0-.46.074-.929.159-1.398z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_82"
                    d="M152.585 239.642c.109.385.186.775.233 1.169.053.389.085.778.106 1.168.021.389 0 .778 0 1.168a5.719 5.719 0 01-.222 1.168 6.568 6.568 0 01-.255-1.168c0-.39-.074-.779-.074-1.168 0-.39 0-.779.064-1.168.024-.392.073-.782.148-1.169z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_83"
                    d="M156.993 237.64c.138.549.255 1.106.329 1.664.074.557.138 1.106.169 1.663.032.558 0 1.106 0 1.664a13.004 13.004 0 01-.158 1.681 13.252 13.252 0 01-.34-1.663 21.838 21.838 0 01-.159-1.664c-.031-.557 0-1.106 0-1.664 0-.557.075-1.123.159-1.681z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_84"
                    d="M161.593 236.678c-.01.297.018.593.085.885 0 .327.085.637.127.938.074.619.149 1.239.18 1.867.032.629 0 1.248 0 1.867a14 14 0 01-.137 1.885 16.148 16.148 0 01-.318-1.867 27.937 27.937 0 01-.149-1.867c-.031-.62 0-1.248 0-1.876a7.14 7.14 0 01.212-1.832z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_85"
                    d="M165.81 235.943c.138.69.265 1.38.35 2.079.085.699.148 1.39.201 2.089.053.699.053 1.398 0 2.097-.053.699 0 1.398-.106 2.106a23.738 23.738 0 01-.36-2.088c-.095-.7-.148-1.39-.191-2.089-.042-.699 0-1.389 0-2.088 0-.699.053-1.407.106-2.106z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_86"
                    d="M170.76 234.898c.357.744.554 1.535.583 2.336 0 .788.074 1.576.074 2.363 0 .788 0 1.566-.095 2.354s-.127 1.566-.265 2.354c-.138-.788-.201-1.575-.254-2.354a34.993 34.993 0 01-.074-2.363c0-.787 0-1.566.084-2.354a9.091 9.091 0 00-.053-2.336z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_87"
                    d="M175.889 234.387c.137.814.254 1.628.328 2.442.074.814.149 1.619.18 2.442.032.823 0 1.629 0 2.443 0 .814 0 1.637-.148 2.451-.17-.814-.265-1.628-.35-2.442a47.445 47.445 0 01-.169-2.434c-.043-.814 0-1.628 0-2.451 0-.823.085-1.628.159-2.451z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_88"
                    d="M180.699 234.167c.191.787.35 1.575.466 2.371.117.797.223 1.593.308 2.39.085.796.138 1.593.116 2.407a5.071 5.071 0 01-.583 2.38 8.133 8.133 0 00.075-2.372c-.096-.805-.18-1.592-.265-2.371a29.657 29.657 0 01-.138-2.398 30.665 30.665 0 01.021-2.407z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_89"
                    d="M185.32 233.421c.225.782.399 1.573.52 2.371.116.797.19 1.593.222 2.398.032.806 0 1.602-.085 2.407-.065.801-.2 1.596-.402 2.381-.075-.805-.096-1.602-.128-2.389-.031-.788 0-1.602-.074-2.39v-2.38c-.042-.744-.042-1.505-.053-2.398z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_90"
                    d="M191.34 242.358l-5.045.743-3.03.434h-.085c-1.06.168-2.225.345-3.338.54a30.653 30.653 0 01-3.105.389h-.17a98.754 98.754 0 01-3.295.133c-2.194.062-4.387.079-6.57.071H153.582c-1.897 0-3.793 0-5.68-.08h-.063a188.613 188.613 0 01-7.418-.319c-2.48-.15-4.896-.371-7.333-.593a332.8 332.8 0 00-5.066-.442h-.085l-.529-.044a111.465 111.465 0 00-3.826-.222c0-.141.064-.283.106-.424 1.261 0 2.512.088 3.762.168 4.377.265 8.721.717 13.066.938 4.345.221 8.722.345 13.088.336h6.559l6.56.044h6.549c1.059 0 2.183-.053 3.264-.106h.116a36.335 36.335 0 003.095-.345c1.059-.168 2.034-.318 3.062-.451l3.412-.452 5.023-.637c.011.08.053.195.096.319z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_91"
                    d="M147.934 244.279a96.43 96.43 0 01-.255 3.062 264.947 264.947 0 01-.307 3.053c-.106 1.009-.233 2.009-.36 3.044-.127 1.035-.255 1.947-.403 3.053 0-1.026-.074-2.053 0-3.08.074-1.026.106-2.044.201-3.061a33.77 33.77 0 01.456-3.053c.191-1.018.382-2.018.668-3.018z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_92"
                    d="M133.077 243.5c.148 1.07.286 2.044.424 2.999.137.956.307 1.991.466 2.983l.498 2.982.53 2.982c-.371-.956-.7-1.929-.965-2.92a33.184 33.184 0 01-.646-2.982c-.17-1-.254-2.009-.318-3.018a24.057 24.057 0 01.011-3.026z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_93"
                    d="M128.169 242.976a7.703 7.703 0 00-.858 2.752c-.149.947-.233 1.912-.403 2.867a84.18 84.18 0 01-.54 2.841 69.192 69.192 0 01-.679 2.84c.053-.964.128-1.929.223-2.884.095-.956.223-1.921.36-2.876.138-.956.308-1.912.551-2.859a6.19 6.19 0 011.346-2.681z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_94"
                    d="M176.631 243.881a42.58 42.58 0 01.519 3.424c.127 1.142.212 2.301.276 3.452.063 1.15 0 2.3 0 3.451 0 1.15-.106 2.301-.223 3.442-.074-1.23-.138-2.336-.201-3.442-.064-1.106-.106-2.301-.17-3.434l-.127-3.442-.074-3.451z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_95"
                    d="M163.385 244.051a24.124 24.124 0 011.621 3.929 24.92 24.92 0 01.922 4.098c.184 1.383.251 2.776.201 4.168 0 .69-.084 1.38-.169 2.07s-.212 1.381-.35 2.062c.117-1.38.138-2.761.106-4.141a35.4 35.4 0 00-.35-4.106 38.25 38.25 0 00-.773-4.071 42.669 42.669 0 00-1.208-4.009z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_96"
                    d="M182.766 243.067c.579.491.992 1.101 1.197 1.769.286.638.551 1.275.795 1.93a30.64 30.64 0 011.197 3.946c.6 2.674.834 5.397.7 8.115a59.087 59.087 0 00-1.272-8.026c-.307-1.336-.636-2.655-1.06-3.938a59.32 59.32 0 00-.625-1.956 3.794 3.794 0 00-.932-1.84z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_97"
                    style={{
                      mixBlendMode: 'multiply',
                    }}
                    d="M166.915 285.463c5.402-2.512 10.208-5.91 14.162-10.01-2.088 6.236-9.134 10.851-12.745 13.658-2.656 2.089-2.337 4.085-1.664 7.982l-4.563-.531c-5.233-.326-2.271-4.146-3.297-8.106-.177 2.682-.804 8.048-2.043 8.391.151-1.791-.061-3.283-.4-5.054-.531-2.433-3.541-3.306-6.196-4.522-3.203-1.201-5.969-3.154-7.998-5.644-2.029-2.491-3.243-5.425-3.509-8.481 3.328 4.396 8.32 9.853 11.507 10.976 3.186 1.122 3.045-1.341 2.053-2.588-.991-1.248-4-1.435-6.373-4.491-2.136-3.87-2.806-8.242-1.912-12.472 2.337 6.236 4.993 12.036 8.144 14.125 3.151 2.089 6.373 1.59 7.612 3.399 1.239 1.808 17.455-11.943 21.597-20.456-.573 5.697-3.036 11.118-7.081 15.591-3.23 3.247-7.12 5.934-11.471 7.921-2.479 1.341.283 1.871 4.177.312z"
                    fill="url(#paint18_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_98"
                    d="M180.547 263.699a37.973 37.973 0 01-.955 2.807l-.567 1.403-.673 1.341-.708 1.341-.779 1.309c-.566.842-1.133 1.684-1.77 2.495a47.24 47.24 0 01-1.983 2.37l-1.097 1.122-1.133 1.092-1.204 1.029-1.239.966-2.656 1.778 1.24-.967 1.203-.998a70.194 70.194 0 002.302-2.12l1.062-1.092 1.062-1.122c.673-.78 1.345-1.559 1.947-2.339a47.496 47.496 0 001.806-2.463l.814-1.279.744-1.278c.495-.873.956-1.746 1.416-2.651l.602-1.372.566-1.372z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_99"
                    d="M179.521 277.483a26.397 26.397 0 01-2.55 2.9 32.179 32.179 0 01-3.044 2.525 26.076 26.076 0 01-3.541 2.121 29.65 29.65 0 01-3.54 1.652 39.693 39.693 0 003.54-2.026 57.252 57.252 0 003.293-2.183 43.473 43.473 0 003.08-2.401 35.698 35.698 0 002.762-2.588z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_100"
                    d="M144.08 266.694c.134 1.053.358 2.095.673 3.118 0 .499.318.998.495 1.466.177.467.354.997.567 1.496.389.967.814 1.903 1.31 2.838a32.68 32.68 0 001.664 2.775 14.965 14.965 0 01-2.054-2.588 20.756 20.756 0 01-1.487-2.869 18.958 18.958 0 01-.885-3.118 18.987 18.987 0 01-.283-3.118z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_101"
                    d="M139.547 274.833a27.816 27.816 0 002.053 3.71 17.51 17.51 0 002.868 3.118 31.707 31.707 0 003.541 2.744c1.204.842 2.478 1.684 3.54 2.495-1.345-.655-2.726-1.341-4.036-2.12a26.996 26.996 0 01-3.54-2.682 15.732 15.732 0 01-2.762-3.43 21.378 21.378 0 01-1.664-3.835z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_102"
                    d="M153.604 280.632c.637.81 1.274 1.621 1.876 2.463a68.651 68.651 0 011.735 2.557 13.751 13.751 0 011.416 2.744c.376.951.473 1.97.283 2.962a7.594 7.594 0 00-.779-2.806 22.038 22.038 0 00-1.522-2.619 67.446 67.446 0 01-1.558-2.62 68.036 68.036 0 01-1.451-2.681z"
                    fill="#1C1E1F"
                  />
                </G>
                <Path
                  id="highlight_hips_2"
                  d="M157.618 297.165l.568-.92.401.517c.376.485.959.771 1.573.776 22.641.168 37.501.637 41.288-2.999-1.09-20.56-1.86-32.085-9.765-52.571.083-4.053.406-6.748-.792-9.74-.472-1.181-1.784-1.729-3.033-1.485-12.353 2.417-19.599 3.198-31.624 3.6-13.59-1.096-25.851-3.221-30.425-1.361-.792.323-1.136 1.181-1.123 2.036l.113 7.217-11.021 51.415c-.19.889.238 1.802 1.079 2.148 8.042 3.312 21.523 3.24 41.151 2.314a2.009 2.009 0 001.61-.947z"
                  fill="#A430FF"
                  fillOpacity={0.25}
                  stroke="#A430FF"
                  strokeWidth={1.5}
                  opacity={highlightedParts.includes(BODY_PARTS.hips) ? 1 : 0}
                />
              </G>
            </G>
            <G id="Arm">
              <Path
                id="Vector_103"
                d="M214.06 198.191c-.872-5.998-1.42-12.621-2.344-19.36-1.158-5.615-2.105-35.089-17.269-38.136-3.02-.765-9.157 41.904-.597 53.889 2.358 4.505 3.224 6.296 3.438 10.307a98.6 98.6 0 001.201 17.273c1.647 8.962 4.727 17.803 4.653 26.989-.102 3.126 4.011 4.122 6.347 4.653 2.932.605 7.445.065 7.082-3.983.075-5.054.307-21.703.382-26.989.4-8.339-1.039-17.772-2.893-24.643z"
                fill="#915548"
              />
              <Path
                id="Vector_104"
                d="M215.358 221.04c-.261 6.096-.261 26.468-.261 30.879 0 3.89-8.581 2.224-10.507 0a1.271 1.271 0 01-.391-.931 36.32 36.32 0 00-.651-8.04c-.521-3.248-1.815-9.214-3.369-15.821-1.554-6.608-1.694-14.891-1.694-19.544 0-4.653-1.241-10.258-3.239-13.029-12.378-13.135-3.022-52.395-1.886-52.943 16.39 4.505 15.935 34.839 17.614 45.486.819 4.067 1.176 10.235 1.837 12.45 2.071 6.976 2.812 14.22 2.547 21.493z"
                fill="url(#paint19_linear_5287_7562)"
              />
              <Path
                id="Vector_105"
                style={{
                  mixBlendMode: 'darken',
                }}
                d="M203.604 230.877c1.2 5.491 2.894 14.556 1.2 20.344-.065.233-.14.466-.214.698a1.267 1.267 0 01-.391-.93 36.333 36.333 0 00-.651-8.041c-.521-3.248-1.815-9.213-3.369-15.821-1.554-6.608-1.694-14.89-1.694-19.544-1.636-11.788-11.961-20.87-8.914-42.901-.095-9.344 2.431-25.091 7.116-22.476 1.458.912 3.952 2.599 5.367 5.467-11.885 4.235 1.233 50.818-2.033 51.823.661 4.122.895 8.301.698 12.471-.103 4.653 1.693 13.429 2.885 18.91z"
                fill="url(#paint20_linear_5287_7562)"
              />
              <Path
                id="Vector_106"
                style={{
                  mixBlendMode: 'darken',
                }}
                d="M214.092 282.687a38.446 38.446 0 01-2.28 4.151c-.791 1.2-1.861 2.224-2.792 2.336-1.024 2.047-2.159 2.903-3.294 2.847-1.48 1.303-2.96.736-3.016-.511-1.079.623-2.103 0-2.103-.931a19.579 19.579 0 011.024-4.151c.446-1.48 1.247-3.471 1.247-4.607a19.24 19.24 0 00-.112-3.927c-.288-1.591-.931-3.871-1.787-7.966-.056.689-1.079 2.903-.93 4.495.148 1.591.26 3.983-.531 5.351-.791 1.368-1.656 3.09-3.136 2.522-1.48-.568-.624-2.727-.391-4.262a23.002 23.002 0 000-3.928c.12-1.502.12-3.011 0-4.513a12.567 12.567 0 011.601-7.548c1.368-2.271 2.447-4.206 3.722-5.974a21.687 21.687 0 002.885-5.1c.168-.496.495-.921.931-1.21a22.448 22.448 0 01-3.332 6.961c-1.991 2.913-4.244 5.323-4.653 8.152-.41 2.83 2.838 2.253 4.169 3.081 1.331.828 1.862 6.663 1.992 8.376.13 1.712.419 5.081.419 6.328 0 1.247 1.665 1.75 2.661.419 1.508 1.414 3.36 1.256 4.002.335.931.409 2.355 0 2.662-.67.345.081.707.062 1.042-.056z"
                fill="url(#paint21_linear_5287_7562)"
              />
              <Path
                id="Vector_107"
                d="M196.364 277.258a1.402 1.402 0 00-.875 1.665 1.313 1.313 0 01.987-1.293 1.171 1.171 0 011.293.633c.112.258.169.537.168.819l.056.93c.056.28.02.571-.103.829a.921.921 0 01-.205.26c-.083.045-.17.082-.26.112a3.484 3.484 0 01-1.247 0H195.275a.683.683 0 01-.121-.196 2.392 2.392 0 010-1.284c-.27.409-.388.9-.335 1.387.028.15.099.289.205.4a.494.494 0 00.232.112.725.725 0 00.205.046l.68.102c.491.072.992.011 1.451-.176.236-.116.431-.301.559-.531a1.164 1.164 0 000-.167c.153-.263.234-.562.232-.866a8.4 8.4 0 01.056-.977 2.045 2.045 0 00-.195-1.024 1.571 1.571 0 00-1.88-.781zm6.933 13.112a.928.928 0 00.345-.819 1.067 1.067 0 00-.559-.791 1.423 1.423 0 00-1.861.438 3.93 3.93 0 00-.437.8 1.245 1.245 0 00-.066.996 1.085 1.085 0 00.801.53c.277.112.588.112.865 0a1.304 1.304 0 01-.782-.204c-.251-.112-.474-.27-.521-.456a.929.929 0 01.159-.633 4.23 4.23 0 01.409-.68 1.14 1.14 0 01.596-.428.927.927 0 01.66 0 .82.82 0 01.494.466.987.987 0 01-.103.781zm2.513-.539a1.34 1.34 0 00-1.833.502 7.891 7.891 0 00-.401.782l-.176.391-.093.195c0 .065-.103.224 0 .335a.861.861 0 00.335.456c.131.096.279.166.437.205a1.115 1.115 0 00.875-.112 1.123 1.123 0 01-.782-.13 1.012 1.012 0 01-.288-.233c-.075-.074-.159-.232-.14-.242.019-.009 0 0 0-.065l.112-.177.223-.372c.149-.233.289-.512.419-.707a.798.798 0 01.465-.41.932.932 0 01.642 0 .81.81 0 01.466.475c.061.263.061.537 0 .8.178-.249.273-.549.27-.856a1.11 1.11 0 00-.531-.837zm2.289-.857a1.102 1.102 0 00-.8.317 2.812 2.812 0 00-.475.595 3.17 3.17 0 00-.279.689c-.072.245-.11.499-.111.754a.732.732 0 00.158.428.543.543 0 00.419.205c.288 0 .456-.168.688-.224a2.095 2.095 0 01-.651-.046c-.177-.075-.158-.177-.149-.354.043-.198.106-.391.186-.577a5.28 5.28 0 01.279-.558c.214-.372.438-.707.735-.754a.464.464 0 01.429.177c.13.158.204.372.335.568a2.25 2.25 0 00-.084-.726.783.783 0 00-.68-.494zm3.528-2.978a1.427 1.427 0 00-1.127.791 2.644 2.644 0 00-.437 1.238c-.002.117.014.233.047.344 0 .14.102.27.232.317.131.046.307-.065.41-.14l.26-.204-.325.065h-.187a.225.225 0 010-.131v-.195c.125-.332.294-.645.503-.931a1.187 1.187 0 01.651-.66.79.79 0 01.847.428.856.856 0 00-.236-.652.866.866 0 00-.638-.27z"
                fill="#915548"
              />
              <G id="Group 27556">
                <Path
                  id="Vector_108"
                  d="M215.441 281.52c-1.396 2.643-2.494 6.133-5.584 7.65a7.887 7.887 0 01-1.359 1.861 4.108 4.108 0 01-1.405.931 3.04 3.04 0 01-.931.214c-.308.23-.646.417-1.005.558a3.304 3.304 0 01-.93.205h-.121a2.478 2.478 0 01-1.862-.838 1.32 1.32 0 01-.139-.177 3.623 3.623 0 01-.596-.065c-3.564-.614-1.247-5.323-.502-7.957a13.963 13.963 0 00.837-6.151 26.874 26.874 0 00-.596-3.146c-.083.586-.074 1.508-.111 2.317a7.126 7.126 0 01-.484 2.709c-.987 1.861-2.615 3.517-4.653 2.792-2.485-1.061-1.396-3.723-1.136-5.529a22.898 22.898 0 000-3.722 26.198 26.198 0 000-4.411 10.818 10.818 0 01-.111-1.536c0-6.738 6.17-12.098 8.375-17.552.093-.279.931.717 1.043.475 1.023-1.582 10.116-.931 10.953.819.131.27 1.136-.41 1.164-.084.642 5.174.781 11.987.93 18.241a45.491 45.491 0 01-1.777 12.396z"
                  fill="#915548"
                />
                <Path
                  id="Vector_109"
                  d="M215.6 274.979a36.258 36.258 0 01-1.229 6.087 9.745 9.745 0 01-.279.623 38.257 38.257 0 01-2.28 4.151c-.791 1.201-1.861 2.224-2.792 2.336-1.024 2.047-2.159 2.904-3.294 2.848-1.48 1.303-2.96.735-3.016-.512-1.079.624-2.103 0-2.103-.931a19.585 19.585 0 011.024-4.15c.446-1.48 1.247-3.472 1.247-4.607.097-1.31.059-2.626-.112-3.927-.288-1.592-.931-3.872-1.787-7.967-.056.689-1.079 2.904-.93 4.495.148 1.592.26 3.983-.531 5.352-.791 1.368-1.656 3.089-3.136 2.522-1.48-.568-.624-2.727-.391-4.263a22.99 22.99 0 000-3.927c.12-1.502.12-3.012 0-4.514a12.564 12.564 0 011.601-7.547c1.368-2.271 2.447-4.207 3.722-5.975a21.667 21.667 0 002.885-5.1c.168-.495.495-.921.931-1.21a6.453 6.453 0 014.43-.549c2.224.344 5.407 1.024 5.528 2.671.121 1.647.447 4.551.558 5.919.112 1.368.289 10.805.345 12.285a35.827 35.827 0 01-.391 5.89z"
                  fill="url(#paint22_linear_5287_7562)"
                />
                <Path
                  id="Vector_110"
                  d="M207.828 273.041c-.112 1.935-.214 3.843-.326 5.751-.047.97-.15 1.936-.307 2.894a11.54 11.54 0 01-.8 2.792c-.363.931-.791 1.778-1.21 2.634a40.143 40.143 0 01-1.359 2.578 15.072 15.072 0 01-1.638 2.364 1.32 1.32 0 01-.139-.177 3.853 3.853 0 01-.596-.065 45.745 45.745 0 001.629-2.56c.521-.874.93-1.656 1.358-2.512.429-.856.875-1.703 1.248-2.56.387-.855.699-1.742.93-2.652.205-.931.326-1.861.456-2.792.217-1.88.469-3.778.754-5.695z"
                  fill="#915548"
                />
                <Path
                  id="Vector_111"
                  d="M211.551 272.445a276.679 276.679 0 01-.232 6.068 26.114 26.114 0 01-.307 3.043 13.198 13.198 0 01-.81 2.997 14.843 14.843 0 01-1.433 2.717l-1.601 2.597a17.899 17.899 0 01-1.74 2.494l-.298.363a3.337 3.337 0 01-.931.204c.196-.353.391-.698.596-1.042.521-.856 1.042-1.722 1.61-2.55l1.675-2.503a17.9 17.9 0 001.48-2.578c.409-.895.721-1.831.93-2.792.196-.977.326-1.973.438-2.969.158-2.029.381-4.039.623-6.049z"
                  fill="#915548"
                />
              </G>
              <Path
                id="Vector_112"
                d="M214.036 273.389a298.234 298.234 0 01-.381 5.807c-.056.931-.177 1.945-.298 2.922a11.01 11.01 0 01-.931 2.792c-.874 1.787-1.991 3.36-2.847 5.081-.354.67-.68 1.331-1.08 1.992a4.108 4.108 0 01-1.405.931l.409-.773c.419-.819.847-1.731 1.312-2.568.466-.838.931-1.722 1.48-2.532a34.13 34.13 0 001.508-2.457 9.41 9.41 0 001.042-2.615c.158-.93.317-1.861.428-2.857.205-1.88.475-3.806.763-5.723z"
                fill="#915548"
              />
            </G>
            <G id="Group 27558">
              <G id="Group 27553">
                <Path
                  id="Vector_113"
                  d="M125.316 140.594c-16.291-.861-23.953 26.277-25.61 33.552-3.7 14.314-3.073 17.61-2.372 25.288.723 6.986-12.6 15.134-6.158 19.588 6.486 3.389 10.802-.615 13.191-3.857 3.776-5.12 7.185-11.292 10.236-16.481 7.697-12.946 19.158-57.034 10.713-58.09z"
                  fill="#915548"
                />
                <Path
                  id="Vector_114"
                  d="M115.187 195.082c-2.137 4.63-8.294 13.227-10.859 17.862-.499 1.074-1.232 1.944-2.12 2.515a4.554 4.554 0 01-2.916.727c-1.704-.255-.31-1.837-1.836-2.875 0 0-.63-2.626-1.03-7.978-.399-5.353.877-16.391 4.09-30.116 2.911-14.052 11.209-33.496 25.506-34.437 2.753.377 2.586 6.693 2.192 11.775-.242 3.116-1.033 8.74-1.967 11.586-.418 1.274-1.434 2.992-1.766 4.228-4.84 19.082-7.332 22.014-9.294 26.713z"
                  fill="url(#paint23_linear_5287_7562)"
                />
              </G>
              <G id="Group 27539">
                <Path
                  id="Vector_115"
                  d="M99.938 196.581c-1.424-3.666-2.792-7.65-4.123-11.363-3.09-8.441-5.677-17.105-8.05-25.704-1.982-5.026-7.11-3.099-10.237-.242-1.396 1.2-2.876 2.885-2.587 4.942 1.005 5.946 1.787 11.996 2.447 18.008.661 6.011.68 12.098 1.955 18.259 1.116 6.235 4.532 11.605 7.79 16.975.874 1.219 1.637 2.68 2.95 3.546 1.982 1.07 4.169.66 6.15.139 3.295-.735 5.517-3.387 7.638-5.677.624-.651-2.016-1.601-2.165-3.266-.205-2.346.344-3.825.158-6.794a36.272 36.272 0 00-1.926-8.823z"
                  fill="#915548"
                />
                <Path
                  id="Vector_116"
                  d="M103.371 214.384c-1.472 1.591-2.818 2.894-4.897 4.127-2.317 1.389-6.903 2.468-8.552.158-1.573-1.861-3.63-5.091-7.138-11.745-3.509-6.654-3.565-16.928-4.253-23.499-.689-6.57-1.862-15.318-2.792-20.111-.605-3.35 7.073-9.306 10.014-5.063.46.653.776 1.395.93 2.178 1.694 7.994 9.567 30.879 11.503 34.75a67.161 67.161 0 014.653 15.496c.177 1.451.976 3.009.532 3.709z"
                  fill="url(#paint24_linear_5287_7562)"
                />
                <Path
                  id="Vector_117"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M103.568 214.342c-1.319 1.501-3.167 2.908-4.88 4.104-3.393 1.907-7.178 2.223-8.75.362-1.573-1.861-3.63-5.091-7.139-11.745-3.508-6.654-3.564-16.928-4.253-23.499-.688-6.57-1.86-15.318-2.792-20.111-.604-3.35 7.073-9.306 10.014-5.063-1.796 2.578-3.992 5.37-3.992 5.37-2.048 2.541-2.95 3.444-2.048 10.814.903 7.371 2.048 19.153 2.978 25.23.931 6.077 4.142 11.773 6.208 15.132 2.066 3.36 4.532 2.718 6.859 2.457 1.2-.13 4.954-2.519 7.699-5.637.186 1.387.45 2.232.096 2.586z"
                  fill="url(#paint25_linear_5287_7562)"
                />
                <Path
                  id="Vector_118"
                  d="M99.263 136.286c-3.304-2.308-7.073 3.648-7.064 6.403a3.362 3.362 0 01-1.117 2.54 9.85 9.85 0 01-1.712 1.703 15.816 15.816 0 01-1.573-4.876c-.186-1.713-.977-11.643-1.117-14.676-.083-1.722-.511-2.904-1.321-3.593a2.652 2.652 0 00-2.047-.614c-2.588.279-2.588 3.723-2.588 5.193 0 1.861-.083 6.775-.149 9.614-1.051-3.611-3.62-12.704-4.141-14.118-1.247-3.36-3.052-3.639-4.355-3.285-2.792.763-2.076 3.787-1.796 4.923.362 1.545 3.769 13.624 4.318 15.765a.437.437 0 01-.103.139c-.372-.651-1.256-2.317-2.187-4.076-3.192-5.426-4.653-11.233-8.525-9.381-.93.54-1.86 1.862-.725 4.812.54 1.461 5.025 11.028 5.863 12.535a.605.605 0 010 .066c-.633-.791-1.74-2.243-2.792-3.555-2.383-2.792-3.807-6.394-7.12-4.412-1.414 1.238-.251 3.444.13 4.17.754 1.451 4.728 7.445 5.687 8.766 2.122 3.239 2.494 6.319 3.974 9.549 1.228 3.62 3.266 7.975 8.068 8.376 2.355 0 4.347-4.012 5.352-4.654 1.86.261 4.532 2.02 6.3.987a8.818 8.818 0 002.792-2.318 46.062 46.062 0 003.825-7.063c.335-1.404.76-2.784 1.275-4.132.884-2.038 1.936-4.142 2.15-6.329a19.552 19.552 0 011.368-5.202 2.791 2.791 0 00-.67-3.257z"
                  fill="#915548"
                />
                <Path
                  id="Vector_119"
                  d="M98.881 139.003a20.29 20.29 0 00-1.47 5.584c-.196 1.992-1.22 4.049-2.057 5.975a33.696 33.696 0 00-1.322 4.225 45.88 45.88 0 01-3.676 6.794c-.986 1.47-5.323 4.011-7.938 3.276-.493.409-4.244 2.959-6.794 2.01a8.692 8.692 0 01-4.811-5.063c-.652-1.796-2.122-5.295-3.043-8.134a14.861 14.861 0 00-1.992-4.039c-.93-1.284-4.877-7.259-5.584-8.608-.707-1.349-.93-2.243-.428-2.708a1.943 1.943 0 012.56.567c.837.931 5.164 6.738 6.058 7.762.521.596 1.107.158 1.433-.465a1.48 1.48 0 00.14-1.312c-.456-.708-5.268-10.926-5.845-12.471-.512-1.368-.66-2.569 0-3.192.077-.081.165-.15.26-.205.931-.512 1.797-.065 2.635 1.098.837 1.163 5.844 10.851 6.616 12.099.438.744 1.145.567 1.638.121a1.428 1.428 0 00.503-1.192c-.195-.93-3.9-14.025-4.346-15.886-.419-1.722-.438-2.95.67-3.425l.298-.102c1.414-.391 2.317.828 2.96 2.569.641 1.74 4.299 14.825 4.652 15.923a.771.771 0 00.931.596.862.862 0 00.763-.605c.065-.512.214-9.446.214-11.82 0-2.373.298-3.787 1.405-4.011a.254.254 0 01.14 0c1.2-.111 1.945.866 2.048 3.099.148 3.062.93 12.946 1.126 14.751a15.143 15.143 0 001.302 4.393c.27.633.587 1.321.931 2.084a11.142 11.142 0 002.96-2.531 4.702 4.702 0 001.507-3.406 7.712 7.712 0 013.21-5.388c.857-.596 1.527-.512 1.946-.159a1.61 1.61 0 01.4 1.796z"
                  fill="url(#paint26_linear_5287_7562)"
                />
                <Path
                  id="Vector_120"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M64.15 132.351c-.511-1.368-.66-2.568 0-3.192.039 1.454.391 2.883 1.033 4.188 1.22 2.876 3.24 7.054 4.03 8.851.791 1.796 1.992 3.136.689 3.936a1.48 1.48 0 00.14-1.312c-.503-.707-5.314-10.926-5.892-12.471z"
                  fill="url(#paint27_linear_5287_7562)"
                />
                <Path
                  id="Vector_121"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M71.419 125.232c-.42-1.722-.438-2.95.67-3.425a6.869 6.869 0 00.242 3.974c.502 1.592 2.159 8.209 2.596 10.237.438 2.029 1.796 5.687.503 6.264a.365.365 0 01-.168 0 1.429 1.429 0 00.503-1.192c-.196-.874-3.9-13.997-4.346-15.858z"
                  fill="url(#paint28_linear_5287_7562)"
                />
                <Path
                  id="Vector_122"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M82.418 164.857c-.493.41-4.244 2.96-6.794 2.011a8.68 8.68 0 01-4.811-5.063c-.652-1.796-2.122-5.296-3.043-8.134a14.833 14.833 0 00-1.992-4.039c-.93-1.284-4.877-7.259-5.584-8.609-.707-1.349-.93-2.242-.428-2.708a8.641 8.641 0 001.191 2.876c1.08 1.861 3.527 5.398 4.654 6.905a17.578 17.578 0 012.736 5.333c.865 2.448 2.661 7.845 4.03 9.716 1.367 1.871 4.857 4.793 10.041 1.712z"
                  fill="url(#paint29_linear_5287_7562)"
                />
                <Path
                  id="Vector_123"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M81.04 140.827a.223.223 0 01-.13 0 .862.862 0 00.763-.605c.065-.512.214-9.446.214-11.819 0-2.374.298-3.788 1.406-4.012-.522.27-.931 2.448-.931 5.966.074 3.816-.214 7.445-.214 8.487 0 1.043-.242 1.908-1.108 1.983z"
                  fill="url(#paint30_linear_5287_7562)"
                />
                <Path
                  id="Vector_124"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M98.528 137.178c-.996-.102-2.364 1.173-3.295 2.569a7.938 7.938 0 00-1.294 3.955 9.309 9.309 0 01-2.661 4.393c-1.015.791-3.239 1.805-4.653 2.792-1.415.986-4.03 3.666-4.533 5.034-.148-3.378 2.3-6.04 4.03-7.556a14.626 14.626 0 001.861-1.806c.27.633.587 1.322.931 2.085a11.166 11.166 0 002.96-2.532 4.71 4.71 0 001.507-3.406 7.712 7.712 0 013.21-5.388c.838-.549 1.509-.493 1.937-.14z"
                  fill="url(#paint31_linear_5287_7562)"
                />
                <Path
                  id="Vector_125"
                  d="M67.22 149.528a16.231 16.231 0 012.886-4.42 13.962 13.962 0 014.327-3.146 17.21 17.21 0 015.147-1.405c.877-.105 1.76-.155 2.643-.149.884 0 1.768.065 2.643.14-.875.065-1.75.195-2.615.297-.866.103-1.713.242-2.56.41a22.714 22.714 0 00-4.913 1.47 14.852 14.852 0 00-4.254 2.792 20.86 20.86 0 00-3.303 4.011z"
                  fill="#915548"
                />
                <Path
                  id="Vector_126"
                  d="M82.186 155.189c.356-1.172.91-2.273 1.637-3.258a11.172 11.172 0 012.653-2.568c1.023-.698 2.094-1.247 3.108-1.862.505-.299.987-.635 1.443-1.005.47-.373.883-.812 1.228-1.303a5.582 5.582 0 01-.93 1.564 9.054 9.054 0 01-1.369 1.238c-.986.744-2.047 1.321-3.024 1.973a13.093 13.093 0 00-2.68 2.28 14.093 14.093 0 00-2.066 2.941z"
                  fill="#915548"
                />
                <Path
                  id="Vector_127"
                  d="M77.83 156.029c.77.262 1.479.676 2.085 1.219a6.28 6.28 0 012.168 4.216 5.458 5.458 0 01-.307 2.298c.01-.769-.064-1.537-.223-2.289a8.322 8.322 0 00-.745-2.103 8.447 8.447 0 00-1.256-1.862 9.595 9.595 0 00-1.722-1.479z"
                  fill="#915548"
                />
              </G>
            </G>
            <G id="pressable_leftArm">
              <G id="Group 27559">
                <G id="Group 27553_2">
                  <Path
                    id="Vector_128"
                    d="M125.412 140.706c-16.291-.861-23.953 26.277-25.611 33.552-3.7 14.314-3.072 17.61-2.371 25.288.723 6.986-12.6 15.134-6.158 19.588 6.486 3.389 10.802-.615 13.19-3.857 3.777-5.12 7.186-11.292 10.237-16.481 7.696-12.946 19.158-57.034 10.713-58.09z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_129"
                    d="M115.283 195.194c-2.137 4.63-8.294 13.227-10.86 17.862-.498 1.074-1.232 1.944-2.119 2.515a4.556 4.556 0 01-2.916.727c-1.704-.255-.31-1.837-1.836-2.875 0 0-.63-2.626-1.03-7.978-.4-5.353.877-16.391 4.089-30.116 2.912-14.052 11.21-33.496 25.507-34.437 2.752.377 2.586 6.693 2.192 11.775-.242 3.116-1.033 8.741-1.967 11.586-.418 1.274-1.434 2.992-1.766 4.228-4.84 19.082-7.332 22.014-9.294 26.713z"
                    fill="url(#paint32_linear_5287_7562)"
                  />
                </G>
                <G id="Group 27539_2">
                  <Path
                    id="Vector_130"
                    d="M100.035 196.693c-1.423-3.666-2.791-7.649-4.122-11.363-3.09-8.441-5.677-17.105-8.05-25.704-1.983-5.026-7.11-3.099-10.237-.242-1.397 1.2-2.876 2.885-2.588 4.942 1.005 5.946 1.787 11.996 2.448 18.008.66 6.012.68 12.098 1.954 18.259 1.117 6.235 4.532 11.605 7.79 16.975.875 1.219 1.638 2.68 2.95 3.546 1.982 1.07 4.17.66 6.151.139 3.295-.735 5.516-3.387 7.638-5.677.624-.651-2.016-1.6-2.165-3.266-.205-2.346.344-3.825.158-6.794a36.283 36.283 0 00-1.927-8.823z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_131"
                    d="M103.469 214.496c-1.473 1.591-2.818 2.894-4.897 4.127-2.318 1.389-6.903 2.468-8.552.158-1.573-1.861-3.63-5.091-7.138-11.745-3.51-6.654-3.565-16.928-4.254-23.499-.688-6.57-1.86-15.318-2.791-20.111-.605-3.35 7.072-9.306 10.013-5.063.46.653.777 1.395.93 2.178 1.695 7.994 9.568 30.879 11.504 34.75a67.192 67.192 0 014.653 15.496c.177 1.452.976 3.009.532 3.709z"
                    fill="url(#paint33_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_132"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M103.666 214.454c-1.319 1.501-3.167 2.908-4.88 4.104-3.393 1.907-7.178 2.223-8.75.362-1.574-1.861-3.63-5.091-7.139-11.745-3.508-6.654-3.564-16.928-4.253-23.499-.689-6.57-1.861-15.318-2.792-20.111-.605-3.35 7.073-9.306 10.014-5.063-1.796 2.578-3.993 5.37-3.993 5.37-2.047 2.541-2.95 3.444-2.047 10.814.903 7.371 2.047 19.153 2.978 25.23.93 6.077 4.141 11.773 6.207 15.132 2.067 3.36 4.533 2.718 6.86 2.457 1.2-.13 4.954-2.519 7.699-5.637.186 1.387.45 2.232.096 2.586z"
                    fill="url(#paint34_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_133"
                    d="M99.36 136.398c-3.303-2.308-7.073 3.648-7.063 6.403a3.36 3.36 0 01-1.117 2.54 9.846 9.846 0 01-1.712 1.703 15.818 15.818 0 01-1.573-4.876c-.186-1.713-.977-11.642-1.117-14.676-.084-1.722-.512-2.904-1.322-3.593a2.651 2.651 0 00-2.047-.614c-2.587.279-2.587 3.723-2.587 5.193 0 1.861-.084 6.775-.149 9.614-1.052-3.611-3.62-12.704-4.141-14.118-1.247-3.36-3.053-3.639-4.356-3.285-2.792.763-2.075 3.787-1.796 4.923.363 1.545 3.77 13.624 4.318 15.765a.437.437 0 01-.102.139c-.372-.651-1.256-2.317-2.187-4.076-3.192-5.425-4.653-11.233-8.525-9.381-.93.54-1.861 1.862-.726 4.812.54 1.461 5.026 11.028 5.863 12.536a.587.587 0 010 .065c-.633-.791-1.74-2.243-2.792-3.555-2.382-2.792-3.806-6.394-7.119-4.412-1.415 1.238-.251 3.444.13 4.17.754 1.451 4.728 7.445 5.687 8.766 2.121 3.239 2.494 6.319 3.973 9.549 1.229 3.62 3.267 7.975 8.07 8.376 2.354 0 4.345-4.012 5.35-4.654 1.862.261 4.533 2.02 6.3.987a8.829 8.829 0 002.793-2.317 46.127 46.127 0 003.825-7.064c.335-1.404.76-2.784 1.275-4.132.884-2.038 1.935-4.142 2.15-6.329a19.573 19.573 0 011.367-5.202 2.785 2.785 0 00.203-1.739 2.785 2.785 0 00-.873-1.518z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_134"
                    d="M98.979 139.115a20.293 20.293 0 00-1.47 5.584c-.196 1.992-1.22 4.049-2.057 5.975a33.68 33.68 0 00-1.322 4.225 45.89 45.89 0 01-3.676 6.794c-.986 1.47-5.323 4.011-7.938 3.276-.494.409-4.244 2.959-6.794 2.01a8.692 8.692 0 01-4.811-5.063c-.652-1.796-2.122-5.295-3.044-8.134a14.855 14.855 0 00-1.991-4.039c-.93-1.284-4.877-7.259-5.584-8.608-.707-1.349-.93-2.243-.428-2.708a1.942 1.942 0 012.559.568c.838.93 5.165 6.737 6.058 7.761.522.596 1.108.158 1.434-.465a1.48 1.48 0 00.14-1.312c-.457-.708-5.268-10.926-5.845-12.471-.512-1.368-.66-2.569 0-3.192a1.13 1.13 0 01.26-.205c.931-.512 1.797-.065 2.634 1.098.838 1.164 5.845 10.852 6.617 12.099.438.744 1.145.567 1.638.121a1.429 1.429 0 00.503-1.192c-.196-.93-3.9-14.024-4.346-15.886-.42-1.721-.438-2.95.67-3.425l.297-.102c1.415-.391 2.318.828 2.96 2.569.642 1.74 4.3 14.825 4.653 15.923a.771.771 0 00.93.596.862.862 0 00.764-.605c.065-.512.214-9.446.214-11.819 0-2.374.298-3.788 1.405-4.012a.255.255 0 01.14 0c1.2-.111 1.945.866 2.047 3.099.149 3.062.93 12.946 1.126 14.751a15.146 15.146 0 001.303 4.393c.27.633.586 1.321.93 2.085a11.164 11.164 0 002.96-2.532 4.704 4.704 0 001.508-3.406 7.712 7.712 0 013.21-5.388c.857-.596 1.527-.512 1.946-.159a1.61 1.61 0 01.4 1.796z"
                    fill="url(#paint35_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_135"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M64.248 132.463c-.512-1.368-.66-2.568 0-3.192a10.09 10.09 0 001.033 4.188c1.22 2.876 3.239 7.054 4.03 8.851.79 1.796 1.991 3.136.688 3.936a1.48 1.48 0 00.14-1.312c-.502-.707-5.314-10.926-5.89-12.471z"
                    fill="url(#paint36_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_136"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M71.516 125.344c-.419-1.721-.437-2.95.67-3.425a6.868 6.868 0 00.242 3.974c.503 1.592 2.16 8.209 2.597 10.237.437 2.029 1.796 5.687.502 6.264a.365.365 0 01-.167 0 1.428 1.428 0 00.502-1.192c-.195-.874-3.899-13.996-4.346-15.858z"
                    fill="url(#paint37_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_137"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M82.516 164.969c-.494.41-4.244 2.96-6.794 2.011a8.68 8.68 0 01-4.811-5.063c-.652-1.796-2.122-5.296-3.044-8.134a14.827 14.827 0 00-1.991-4.039c-.93-1.284-4.877-7.259-5.584-8.608-.707-1.35-.93-2.243-.428-2.709a8.63 8.63 0 001.191 2.876c1.08 1.861 3.527 5.398 4.653 6.905a17.578 17.578 0 012.736 5.333c.866 2.448 2.662 7.845 4.03 9.716 1.368 1.871 4.858 4.793 10.042 1.712z"
                    fill="url(#paint38_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_138"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M81.138 140.939a.223.223 0 01-.13 0 .862.862 0 00.763-.605c.065-.512.214-9.446.214-11.819 0-2.374.298-3.788 1.405-4.011-.52.269-.93 2.447-.93 5.965.074 3.816-.214 7.445-.214 8.487 0 1.043-.242 1.908-1.108 1.983z"
                    fill="url(#paint39_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_139"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M98.625 137.29c-.996-.102-2.364 1.173-3.294 2.569a7.938 7.938 0 00-1.294 3.955 9.31 9.31 0 01-2.662 4.393c-1.014.791-3.238 1.805-4.653 2.792-1.414.986-4.03 3.666-4.532 5.034-.149-3.378 2.299-6.039 4.03-7.556a14.612 14.612 0 001.861-1.806c.27.633.586 1.322.93 2.085a11.164 11.164 0 002.96-2.532 4.71 4.71 0 001.508-3.406 7.7 7.7 0 013.21-5.388c.838-.549 1.508-.493 1.936-.14z"
                    fill="url(#paint40_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_140"
                    d="M67.318 149.64a16.231 16.231 0 012.885-4.42 13.96 13.96 0 014.328-3.146 17.208 17.208 0 015.146-1.405c.877-.105 1.76-.155 2.643-.149.885 0 1.769.065 2.643.14-.874.065-1.75.195-2.615.298-.865.102-1.712.241-2.559.409a22.715 22.715 0 00-4.914 1.47 14.853 14.853 0 00-4.253 2.792 20.856 20.856 0 00-3.304 4.011z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_141"
                    d="M82.283 155.301c.356-1.172.91-2.273 1.638-3.258a11.172 11.172 0 012.652-2.568c1.024-.698 2.094-1.247 3.109-1.861.504-.3.986-.636 1.442-1.006a6.29 6.29 0 001.229-1.302 5.591 5.591 0 01-.93 1.563 9.06 9.06 0 01-1.369 1.238c-.986.744-2.047 1.321-3.025 1.973a13.097 13.097 0 00-2.68 2.28 14.096 14.096 0 00-2.066 2.941z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_142"
                    d="M77.928 156.141c.77.262 1.478.677 2.084 1.219a6.28 6.28 0 012.169 4.216 5.46 5.46 0 01-.307 2.298c.01-.769-.065-1.536-.224-2.289a8.315 8.315 0 00-.744-2.103 8.443 8.443 0 00-1.257-1.862 9.592 9.592 0 00-1.721-1.479z"
                    fill="#915548"
                  />
                </G>
              </G>
              <G id="highlight_leftArm" fill="#A430FF" opacity={highlightedParts.includes(BODY_PARTS.arm) ? 1 : 0}>
                <Path
                  d="M74.969 168.196s.568 3.05.904 5.009c1.996 11.626 1.41 22.57 3.596 29.991 2.186 7.42 8.063 16.205 10.063 17.705 2.48 1.75 6.685 1.012 9.41-.549 2.637-1.738 3.443-2.525 6.293-5.634 11.962-13.322 27.619-55.035 22.385-71.932-.528-1.705-2.217-2.717-3.991-2.507-13.256 1.569-21.844 15.999-27.07 45.475a985.657 985.657 0 00-4.59-13.058l-2.5-8c2.952-1.538 4.878-5.987 6-9l3-7s.573-4.362 1.5-7c.492-1.403 1-2.5 1-2.5.318-3.683-2.674-4.31-5-3-3.083 1.735-3.855 3.836-4 7.5l-2.5 2.5-1-3.5-1.5-17c0-3.5-6.5-4-6.5 0v12.5l-4.5-16.5c-1-3-7.5-1.5-6.5 2.5l5 17-6-11.5c-2-4.5-8-2-5.5 3.5l6 12-6.5-8c-2.5-2-5.5 1-4 3.5l7 11.5c1.647 4.927 3.036 7.09 4.5 11.5.83 2.5 2.332 3.841 5 4.5z"
                  fillOpacity={0.25}
                />
                <Path d="M75.873 173.205l.74-.127-.74.127zm-.904-5.009l.737-.138-.089-.475-.469-.115-.18.728zm-5-4.5l-.712.236.712-.236zm-4.5-11.5l.71-.238-.026-.08-.044-.072-.64.39zm-7-11.5l-.644.386.003.004.64-.39zm4-3.5l.582-.473-.051-.063-.063-.05-.468.586zm6.5 8l-.583.473a.75.75 0 001.253-.809l-.67.336zm-6-12l-.683.31.005.013.007.012.67-.335zm5.5-3.5l-.686.304.01.022.01.021.666-.347zm6 11.5l-.665.347a.75.75 0 001.384-.559l-.72.212zm-5-17l-.728.182.004.015.004.014.72-.211zm6.5-2.5l.723-.198-.005-.02-.007-.019-.712.237zm4.5 16.5l-.724.197a.75.75 0 001.474-.197h-.75zm6.5-12.5h-.75v.033l.002.033.748-.066zm1.5 17l-.748.066.007.071.02.069.72-.206zm1 3.5l-.722.206.35 1.225.902-.901-.53-.53zm2.5-2.5l.53.53a.75.75 0 00.219-.501l-.75-.029zm4-7.5l.367.653-.367-.653zm5 3l.68.315.055-.12.012-.131-.747-.064zm-1 2.5l.707.248-.707-.248zm-1.5 7l.689.295.04-.095.014-.102-.743-.098zm-3 7l-.69-.296-.007.017-.006.017.703.262zm-6 9l-.347-.665-.556.289.187.599.716-.223zm2.5 8l-.716.223.004.015.005.015.707-.253zm-2.437 48.205l-.45.6.009.006.009.007.432-.613zm9.41-.549l.373.651.02-.012.02-.013-.413-.626zm6.293-5.634l.553.507.006-.006-.559-.501zm22.385-71.932l.716-.222-.716.222zm-31.062 42.968l-.71.245.943 2.737.506-2.851-.739-.131zm27.071-45.475l-.088-.745.088.745zm-47.017 32.799a334.438 334.438 0 00-.812-4.511 218.029 218.029 0 00-.088-.474l-.005-.026v-.006l-.001-.002v-.001l-.737.138-.738.137v.002l.002.007c0 .006.002.014.005.026l.018.099.069.372.232 1.261c.184 1.007.41 2.257.577 3.232l1.478-.254zm-1.464-5.61c-1.25-.309-2.17-.764-2.868-1.39-.694-.624-1.216-1.462-1.6-2.618l-1.423.472c.445 1.343 1.09 2.426 2.021 3.262.929.835 2.094 1.38 3.51 1.73l.36-1.456zm-4.468-4.008c-.743-2.24-1.468-3.91-2.204-5.617-.734-1.705-1.483-3.453-2.296-5.885l-1.423.476c.834 2.495 1.604 4.291 2.342 6.003.736 1.708 1.438 3.325 2.158 5.495l1.423-.472zm-4.57-11.654l-7-11.5-1.282.78 7 11.5 1.281-.78zm-6.998-11.496c-.543-.904-.286-1.896.367-2.502.63-.585 1.589-.772 2.521-.027l.937-1.171c-1.568-1.254-3.358-.942-4.479.099-1.097 1.019-1.59 2.777-.633 4.373l1.287-.772zm2.774-2.641l6.5 8 1.165-.946-6.5-8-1.165.946zm7.753 7.191l-6-12-1.341.671 6 12 1.341-.671zm-5.988-11.975c-1.132-2.49-.265-4.007.727-4.524 1.01-.527 2.56-.262 3.405 1.639l1.37-.609c-1.154-2.598-3.604-3.333-5.469-2.36-1.883.982-2.766 3.465-1.398 6.475l1.365-.621zm4.153-2.842l6 11.5 1.33-.694-6-11.5-1.33.694zm7.384 10.941l-5-17-1.439.423 5 17 1.439-.423zm-4.992-16.97c-.195-.78-.024-1.394.33-1.873.368-.5.968-.89 1.663-1.103.696-.215 1.418-.231 1.987-.061.556.165.925.488 1.081.956l1.423-.474c-.344-1.032-1.162-1.647-2.076-1.92-.899-.267-1.927-.221-2.856.065-.93.286-1.83.834-2.43 1.646-.615.834-.882 1.907-.577 3.128l1.455-.364zm5.049-2.121l4.5 16.5 1.447-.395-4.5-16.5-1.447.395zm5.974 16.303v-12.5h-1.5v12.5h1.5zm0-12.5c0-.772.3-1.266.718-1.582.441-.334 1.072-.508 1.753-.481.68.026 1.334.249 1.8.614.453.354.729.834.729 1.449h1.5c0-1.135-.537-2.031-1.304-2.63-.752-.588-1.722-.896-2.668-.932-.944-.037-1.938.196-2.715.784-.802.606-1.313 1.549-1.313 2.778h1.5zm5.002.066l1.5 17 1.495-.132-1.5-17-1.495.132zm1.526 17.14l1 3.5 1.443-.412-1-3.5-1.443.412zM90 146.726l2.5-2.5-1.06-1.061-2.5 2.5 1.06 1.061zm2.719-3.001c.071-1.798.295-3.112.82-4.169.515-1.034 1.354-1.894 2.798-2.707l-.735-1.307c-1.638.922-2.727 1.981-3.406 3.347-.667 1.343-.902 2.912-.976 4.777l1.499.059zm3.618-6.876c1.027-.578 2.099-.667 2.814-.342.632.286 1.211 1.004 1.071 2.624l1.495.129c.178-2.062-.579-3.499-1.946-4.119-1.282-.582-2.87-.33-4.17.401l.736 1.307zm4.633 2.347l-.681-.315-.001.001-.001.003-.005.011-.018.04-.067.149a33.226 33.226 0 00-.935 2.362l1.415.497a32.12 32.12 0 01.891-2.251l.062-.138.016-.034.003-.009.001-.001v-.001l-.68-.314zm-1.708 2.251c-.484 1.378-.867 3.176-1.128 4.603a62.083 62.083 0 00-.401 2.495l-.005.039-.002.01v.004l.744.098.743.098v-.001-.002l.002-.009.004-.035.02-.139.076-.523c.068-.444.167-1.064.295-1.765.258-1.414.625-3.115 1.067-4.376l-1.415-.497zm-1.482 6.953l-3 7 1.379.591 3-7-1.379-.591zm-3.013 7.034c-.556 1.494-1.3 3.31-2.257 4.934-.966 1.64-2.097 2.991-3.387 3.663l.693 1.33c1.663-.866 2.97-2.508 3.986-4.231 1.025-1.738 1.805-3.653 2.37-5.173l-1.405-.523zm-6.013 9.485l2.5 8 1.431-.447-2.5-8-1.431.447zm-8.565 38.065c-1.067-3.62-1.463-8.129-1.84-13.262-.376-5.104-.73-10.787-1.736-16.644l-1.478.254c.99 5.769 1.34 11.371 1.718 16.5.374 5.102.777 9.775 1.897 13.576l1.439-.424zm9.794 17.317c-.407-.305-1.094-1.058-1.96-2.207-.848-1.127-1.824-2.575-2.81-4.212-1.974-3.281-3.956-7.272-5.024-10.898l-1.439.424c1.118 3.794 3.168 7.906 5.179 11.247 1.007 1.674 2.012 3.167 2.896 4.341.868 1.153 1.665 2.06 2.258 2.505l.9-1.2zm8.587-.6a11.534 11.534 0 01-4.494 1.42c-1.603.152-3.07-.099-4.11-.833l-.865 1.226c1.44 1.016 3.315 1.271 5.116 1.101a13.061 13.061 0 005.099-1.612l-.746-1.302zm6.114-5.49c-2.831 3.089-3.59 3.825-6.154 5.515l.826 1.252c2.71-1.786 3.564-2.623 6.433-5.753l-1.105-1.014zm22.22-71.203c1.26 4.066 1.28 9.71.367 16.167-.911 6.439-2.738 13.608-5.105 20.679-4.744 14.173-11.609 27.816-17.488 34.363l1.117 1.002c6.083-6.775 13.027-20.649 17.793-34.888 2.388-7.134 4.241-14.394 5.168-20.945.924-6.533.939-12.439-.419-16.822l-1.433.444zm-35.64 29.941a982.957 982.957 0 014.586 13.05l1.418-.489a987.837 987.837 0 00-4.593-13.067l-1.412.506zm32.278-33.415c-6.923.819-12.563 5.007-17.103 12.634-4.526 7.603-8 18.685-10.618 33.456l1.477.261c2.607-14.705 6.041-25.577 10.43-32.95 4.375-7.35 9.657-11.162 15.991-11.911l-.177-1.49zm4.795 3.03c-.643-2.077-2.69-3.279-4.795-3.03l.177 1.49c1.442-.171 2.772.65 3.185 1.984l1.433-.444z" />
              </G>
            </G>
            <G id="pressable_rightArm">
              <G id="Arm_2">
                <Path
                  id="Vector_143"
                  d="M213.687 198.757c-.872-5.998-1.42-12.622-2.344-19.36-1.158-5.615-2.105-35.089-17.269-38.136-3.02-.765-9.158 41.904-.597 53.889 2.358 4.505 3.224 6.296 3.438 10.307a98.595 98.595 0 001.201 17.272c1.647 8.963 4.727 17.804 4.653 26.989-.102 3.127 4.011 4.123 6.347 4.653 2.931.605 7.445.066 7.082-3.983.075-5.053.307-21.702.382-26.988.4-8.339-1.039-17.772-2.893-24.643z"
                  fill="#915548"
                />
                <Path
                  id="Vector_144"
                  d="M214.985 221.606c-.261 6.096-.261 26.467-.261 30.879 0 3.89-8.581 2.224-10.507 0a1.257 1.257 0 01-.391-.931 36.333 36.333 0 00-.651-8.041c-.522-3.248-1.815-9.213-3.369-15.821-1.554-6.607-1.694-14.89-1.694-19.543 0-4.654-1.241-10.259-3.239-13.029-12.378-13.136-3.022-52.395-1.886-52.943 16.39 4.505 15.935 34.839 17.614 45.485.819 4.067 1.176 10.235 1.837 12.45 2.071 6.977 2.812 14.221 2.547 21.494z"
                  fill="url(#paint41_linear_5287_7562)"
                />
                <Path
                  id="Vector_145"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M203.231 231.443c1.2 5.491 2.894 14.555 1.2 20.344-.065.233-.14.465-.214.698a1.257 1.257 0 01-.391-.931 36.32 36.32 0 00-.651-8.04c-.521-3.248-1.815-9.214-3.369-15.821-1.554-6.608-1.694-14.891-1.694-19.544-1.636-11.788-11.961-20.87-8.914-42.901-.095-9.344 2.431-25.091 7.116-22.476 1.458.911 3.951 2.599 5.367 5.466-11.885 4.236 1.233 50.818-2.034 51.824.662 4.121.896 8.3.698 12.47-.102 4.654 1.694 13.43 2.886 18.911z"
                  fill="url(#paint42_linear_5287_7562)"
                />
                <Path
                  id="Vector_146"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M213.719 283.253a38.51 38.51 0 01-2.28 4.15c-.791 1.201-1.861 2.225-2.792 2.336-1.024 2.048-2.159 2.904-3.295 2.848-1.479 1.303-2.959.735-3.015-.512-1.079.624-2.103 0-2.103-.93a19.579 19.579 0 011.024-4.151c.446-1.48 1.247-3.471 1.247-4.607a19.24 19.24 0 00-.112-3.927c-.288-1.592-.931-3.872-1.787-7.967-.056.689-1.079 2.904-.93 4.496.148 1.591.26 3.983-.531 5.351-.791 1.368-1.656 3.089-3.136 2.522-1.48-.568-.624-2.727-.391-4.263a22.99 22.99 0 000-3.927c.12-1.502.12-3.011 0-4.514a12.565 12.565 0 011.601-7.547c1.368-2.271 2.447-4.207 3.722-5.975a21.647 21.647 0 002.885-5.1c.168-.495.495-.92.931-1.21a22.443 22.443 0 01-3.332 6.962c-1.991 2.913-4.244 5.323-4.653 8.152-.41 2.829 2.838 2.252 4.169 3.081 1.331.828 1.862 6.663 1.992 8.375.13 1.713.419 5.082.419 6.329 0 1.247 1.665 1.749 2.661.419 1.508 1.414 3.36 1.256 4.002.335.931.409 2.355 0 2.662-.67.345.081.707.061 1.042-.056z"
                  fill="url(#paint43_linear_5287_7562)"
                />
                <Path
                  id="Vector_147"
                  d="M195.991 277.823a1.404 1.404 0 00-.875 1.666 1.313 1.313 0 01.987-1.294 1.172 1.172 0 011.293.633c.112.259.169.538.168.819l.056.931c.056.28.02.57-.103.828a.912.912 0 01-.205.261c-.083.045-.17.082-.26.111a3.439 3.439 0 01-1.247 0H194.902a.645.645 0 01-.121-.195 2.392 2.392 0 010-1.284c-.27.409-.388.899-.335 1.386.028.151.099.29.205.401a.492.492 0 00.232.111.694.694 0 00.205.047l.68.102c.491.071.992.01 1.451-.177.236-.115.431-.3.559-.53a1.177 1.177 0 000-.168c.153-.262.234-.561.232-.865a8.4 8.4 0 01.056-.977 2.054 2.054 0 00-.195-1.024 1.571 1.571 0 00-1.88-.782zm6.933 13.113a.931.931 0 00.345-.819 1.068 1.068 0 00-.559-.791 1.423 1.423 0 00-1.861.437c-.176.25-.323.518-.438.801a1.25 1.25 0 00-.065.996 1.085 1.085 0 00.801.53c.277.111.587.111.865 0a1.304 1.304 0 01-.782-.205c-.251-.111-.474-.27-.521-.456a.935.935 0 01.158-.633 4.3 4.3 0 01.41-.679c.146-.205.355-.355.596-.428a.927.927 0 01.66 0 .82.82 0 01.494.465.992.992 0 01-.103.782zm2.513-.54a1.34 1.34 0 00-1.014-.13 1.31 1.31 0 00-.819.633 7.891 7.891 0 00-.401.782l-.176.39-.093.196c0 .065-.103.223 0 .335a.861.861 0 00.335.456c.131.096.279.165.437.205a1.134 1.134 0 00.875-.112 1.129 1.129 0 01-.782-.13 1.047 1.047 0 01-.288-.233c-.075-.074-.159-.233-.14-.242.019-.009 0 0 0-.065l.112-.177.223-.372c.149-.233.288-.512.419-.708a.794.794 0 01.465-.409.932.932 0 01.642 0 .82.82 0 01.466.475c.061.263.061.537 0 .8a1.44 1.44 0 00.269-.856 1.088 1.088 0 00-.53-.838zm2.289-.856a1.098 1.098 0 00-.8.316 2.818 2.818 0 00-.475.596 3.17 3.17 0 00-.279.689c-.072.245-.11.498-.111.754a.73.73 0 00.158.428.543.543 0 00.419.204c.288 0 .456-.167.688-.223a2.095 2.095 0 01-.651-.046c-.177-.075-.158-.177-.149-.354.043-.198.106-.391.186-.577.082-.192.175-.378.279-.559.214-.372.438-.707.735-.753a.455.455 0 01.428.176c.131.159.205.373.335.568a2.226 2.226 0 00-.083-.726.785.785 0 00-.68-.493zm3.528-2.978a1.42 1.42 0 00-1.127.791 2.633 2.633 0 00-.437 1.238c-.002.116.014.232.047.344 0 .14.102.27.232.317.131.046.307-.066.41-.14l.26-.205-.325.065h-.187a.222.222 0 010-.13v-.195c.125-.332.294-.645.503-.931a1.187 1.187 0 01.651-.661.79.79 0 01.847.428.867.867 0 00-.874-.921z"
                  fill="#915548"
                />
                <G id="Group 27556_2">
                  <Path
                    id="Vector_148"
                    d="M215.068 282.085c-1.396 2.643-2.494 6.133-5.584 7.65a7.872 7.872 0 01-1.359 1.862 4.091 4.091 0 01-1.405.93 3.04 3.04 0 01-.931.214c-.308.23-.646.418-1.005.559a3.375 3.375 0 01-.93.205h-.121a2.48 2.48 0 01-2.001-1.015 3.734 3.734 0 01-.596-.065c-3.564-.614-1.247-5.323-.503-7.957a13.954 13.954 0 00.838-6.152 26.857 26.857 0 00-.596-3.145c-.083.586-.074 1.507-.111 2.317a7.118 7.118 0 01-.484 2.708c-.987 1.862-2.615 3.518-4.653 2.792-2.485-1.061-1.396-3.722-1.136-5.528a22.898 22.898 0 000-3.722 26.21 26.21 0 000-4.412 10.793 10.793 0 01-.111-1.535c0-6.738 6.17-12.099 8.375-17.552.093-.279.931.716 1.043.474 1.023-1.582 10.116-.93 10.953.819.131.27 1.136-.409 1.164-.083.642 5.174.781 11.986.93 18.24a45.48 45.48 0 01-1.777 12.396z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_149"
                    d="M215.227 275.545a36.278 36.278 0 01-1.229 6.087c-.074.186-.167.39-.279.623a38.62 38.62 0 01-2.28 4.151c-.791 1.2-1.861 2.224-2.792 2.336-1.024 2.047-2.159 2.903-3.295 2.847-1.479 1.303-2.959.736-3.015-.511-1.079.623-2.103 0-2.103-.931a19.594 19.594 0 011.024-4.151c.446-1.479 1.247-3.471 1.247-4.606.097-1.31.059-2.626-.112-3.928-.288-1.591-.931-3.871-1.787-7.966-.056.689-1.079 2.904-.93 4.495.148 1.591.26 3.983-.531 5.351-.791 1.368-1.656 3.09-3.136 2.522-1.48-.567-.624-2.727-.391-4.262a22.99 22.99 0 000-3.927c.12-1.503.12-3.012 0-4.514a12.567 12.567 0 011.601-7.548c1.368-2.27 2.447-4.206 3.722-5.974a21.687 21.687 0 002.885-5.1c.168-.495.495-.921.931-1.21a6.447 6.447 0 014.43-.549c2.224.344 5.407 1.024 5.528 2.671.121 1.647.446 4.551.558 5.919.112 1.368.289 10.804.345 12.284a35.84 35.84 0 01-.391 5.891z"
                    fill="url(#paint44_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_150"
                    d="M207.455 273.606c-.112 1.936-.214 3.844-.326 5.752-.047.97-.15 1.936-.307 2.894a11.54 11.54 0 01-.8 2.792c-.363.931-.791 1.777-1.21 2.634a40.652 40.652 0 01-1.359 2.578 15.064 15.064 0 01-1.638 2.363 1.312 1.312 0 01-.139-.176 3.736 3.736 0 01-.596-.066 45.357 45.357 0 001.629-2.559 37.13 37.13 0 001.358-2.513c.429-.856.875-1.703 1.248-2.559.387-.855.699-1.742.93-2.652.205-.931.326-1.861.456-2.792.217-1.88.469-3.779.754-5.696z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_151"
                    d="M211.178 273.01a282.796 282.796 0 01-.232 6.068 26.11 26.11 0 01-.307 3.044 13.176 13.176 0 01-.81 2.996 14.851 14.851 0 01-1.433 2.718l-1.601 2.596c-.508.88-1.09 1.714-1.74 2.494l-.298.363a3.303 3.303 0 01-.931.205c.196-.354.391-.698.596-1.042.521-.856 1.042-1.722 1.61-2.55l1.675-2.504a17.846 17.846 0 001.48-2.578c.409-.894.721-1.83.93-2.792.196-.977.326-1.973.438-2.968.158-2.029.381-4.039.623-6.05z"
                    fill="#915548"
                  />
                </G>
                <Path
                  id="Vector_152"
                  d="M213.663 273.954a297.821 297.821 0 01-.381 5.808c-.056.93-.177 1.945-.298 2.922a11.01 11.01 0 01-.931 2.792c-.875 1.787-1.991 3.359-2.847 5.081-.354.67-.68 1.331-1.08 1.992a4.091 4.091 0 01-1.405.93l.409-.772c.419-.819.847-1.731 1.312-2.569.466-.837.931-1.721 1.48-2.531a34.575 34.575 0 001.508-2.457 9.454 9.454 0 001.042-2.615c.158-.931.316-1.861.428-2.857.205-1.88.475-3.807.763-5.724z"
                  fill="#915548"
                />
              </G>
              <G id="highlight_rightArm" fill="#A430FF" opacity={highlightedParts.includes(BODY_PARTS.arm) ? 1 : 0}>
                <Path
                  d="M202.358 250.525c.45-3.494.145-6.314-.979-9.78-3.527-13-4.457-24.507-5.117-40.223l-4.481-8.823c-9.233-13.799-.475-52.15 2.525-50.15 13.721.035 17.635 28.812 19.391 56.045 5.015 17.625 3.521 34.673 2.952 44.371v9.932c.778 14.389 1.548 22.031-1.127 30.318-1.279 3.149-2.817 6.87-5.564 7.576-1.379 2.734-2.246 3.49-4 3-1 1.5-3 1.5-3.5 0-1 1-3.5-1-3-3 0 0 1.994-5.438 2.204-9.081.198-3.426-.98-8.733-.98-8.733l-.187 7.939c-1 4.5-7.506 4.56-7.006.56 1.451-4.985.058-4.834.558-14.334 1.5-6 3.811-9.617 8.311-15.617z"
                  fillOpacity={0.25}
                />
                <Path d="M201.379 240.745l-.724.196.005.018.006.017.713-.231zm.979 9.78l.6.45.118-.159.026-.196-.744-.095zm-8.311 15.617l-.728-.182-.017.07-.004.072.749.04zm-.558 14.334l-.72-.209-.017.057-.007.059.744.093zm7.006-.56l.732.162.016-.071.002-.074-.75-.017zm.187-7.939l.732-.163a.75.75 0 00-1.482.145l.75.018zm.98 8.733l-.749-.044.749.044zm-2.204 9.081l-.704-.258-.013.037-.01.039.727.182zm3 3l.712-.237-.384-1.152-.858.858.53.531zm3.5 0l.202-.723-.524-.146-.302.453.624.416zm4-3l-.186-.727-.33.085-.153.304.669.338zm5.564-7.576l.695.282.01-.025.009-.027-.714-.23zm1.127-30.318h-.75v.02l.001.02.749-.04zm0-9.932l-.749-.044-.001.022v.022h.75zm-20.387-41.443l.749-.031-.007-.163-.073-.145-.669.339zm-4.481-8.823l.668-.34-.02-.04-.025-.037-.623.417zm2.525-50.15l-.416.624.188.126h.226l.002-.75zm19.391 56.045l-.749.048.005.08.022.077.722-.205zm-13.031 43.382c1.092 3.37 1.383 6.078.948 9.453l1.488.191c.465-3.612.146-6.543-1.009-10.107l-1.427.463zm1.092 9.099c-4.518 6.023-6.902 9.737-8.439 15.885l1.456.364c1.463-5.853 3.7-9.373 8.183-15.349l-1.2-.9zm-8.46 16.027c-.252 4.797-.026 7.172.078 8.944.1 1.704.091 2.825-.607 5.221l1.44.419c.754-2.589.773-3.886.664-5.728-.104-1.774-.325-4.073-.077-8.777l-1.498-.079zm-.553 14.281c-.153 1.221.232 2.223.993 2.89.735.644 1.739.905 2.726.86 1.976-.091 4.179-1.427 4.763-4.055l-1.464-.325a3.614 3.614 0 01-3.368 2.881c-.701.033-1.293-.16-1.668-.489-.349-.306-.591-.796-.494-1.576l-1.488-.186zm8.5-.45l.186-7.938-1.499-.036-.187 7.939 1.5.035zm-.563-7.956l-.733.163h.001v.003l.002.01.01.043.036.17a55.49 55.49 0 01.507 2.807c.268 1.745.503 3.863.408 5.493l1.498.087c.104-1.796-.152-4.044-.424-5.808a55.896 55.896 0 00-.572-3.126l-.001-.003v-.001l-.732.162zm.231 8.689c-.1 1.734-.63 3.937-1.152 5.742a56.408 56.408 0 01-1.002 3.111l-.004.011-.001.002v.001l.704.258.705.258v-.001-.001l.001-.003.005-.013a56.973 56.973 0 001.033-3.206c.527-1.824 1.099-4.162 1.209-6.072l-1.498-.087zm-2.182 8.943c-.339 1.356.346 2.621 1.16 3.362.416.377.922.675 1.45.788.541.115 1.17.04 1.648-.438l-1.061-1.061c-.022.022-.08.073-.274.032-.206-.044-.481-.184-.754-.431-.56-.509-.875-1.244-.714-1.888l-1.455-.364zm3.016 3.419c.361 1.083 1.293 1.638 2.274 1.638.958 0 1.934-.517 2.561-1.459l-1.248-.832c-.372.558-.896.791-1.313.791-.394 0-.712-.196-.851-.612l-1.423.474zm4.01.485c.498.139.987.206 1.468.144a2.702 2.702 0 001.332-.564c.759-.585 1.385-1.604 2.071-2.964l-1.339-.676c-.693 1.373-1.19 2.099-1.648 2.453-.208.16-.4.237-.607.263-.218.028-.495.005-.874-.101l-.403 1.445zm4.388-2.996c1.653-.425 2.858-1.731 3.781-3.199.929-1.477 1.656-3.258 2.291-4.821l-1.39-.564c-.644 1.586-1.325 3.241-2.171 4.587-.853 1.357-1.791 2.263-2.884 2.544l.373 1.453zm6.091-8.072c2.728-8.452 1.936-16.268 1.162-30.589l-1.498.081c.781 14.458 1.53 21.926-1.092 30.048l1.428.46zm1.163-30.548v-9.932h-1.5v9.932h1.5zm-21.886-51.343c.66 15.728 1.592 27.303 5.142 40.387l1.448-.393c-3.505-12.916-4.432-24.354-5.092-40.057l-1.498.063zm-4.401-8.515l4.481 8.823 1.338-.679-4.482-8.824-1.337.68zm3.61-51.114a1.168 1.168 0 00-.816-.19 1.459 1.459 0 00-.682.302c-.345.266-.648.685-.917 1.153-.55.956-1.121 2.406-1.676 4.188-1.114 3.58-2.21 8.661-2.919 14.226-.71 5.566-1.037 11.645-.602 17.215.435 5.551 1.633 10.688 4.047 14.297l1.247-.834c-2.202-3.291-3.371-8.122-3.798-13.58-.425-5.439-.107-11.411.594-16.908.701-5.497 1.78-10.491 2.863-13.97.545-1.749 1.077-3.074 1.545-3.886.239-.417.423-.629.531-.712.049-.038.038-.014-.028-.005a.329.329 0 01-.221-.048l.832-1.248zm22.675 101.084c.568-9.674 2.077-26.852-2.979-44.62l-1.443.41c4.975 17.482 3.496 34.4 2.925 44.122l1.497.088zm-2.952-44.463c-.878-13.62-2.298-27.689-5.234-38.372-1.466-5.338-3.327-9.893-5.732-13.13-2.416-3.253-5.434-5.235-9.171-5.245l-.004 1.5c3.123.008 5.74 1.636 7.971 4.64 2.243 3.019 4.044 7.367 5.49 12.632 2.891 10.522 4.306 24.458 5.183 38.071l1.497-.096z" />
              </G>
            </G>
            <G id="Neck">
              <Path
                id="Vector_153"
                d="M173.793 138.112c-.146-.278-.294-1.424-.745-1.853-.915-.54-.437-9.924-.825-15.342-.63-3.518-8.723-3.305-11.476-3.547-3.625 0-15.508-.378-16.07 4.342-.369 5.011.944 13.285-.294 14.123-3.256 2.322-2.221 6.336-2.372 9.062-.804 14.442 10.662 18.832 23.107 15.983 4.032-.97 8.21-3.645 9.693-7.822a14.54 14.54 0 00-1.018-14.946z"
                fill="#915548"
              />
              <Path
                id="Vector_154"
                d="M174.281 154.52c-5.029 9.761-23.939 8.627-28.989 2.859-2.49-3.044-3.649-7.958-3.388-11.882.038-2.437-1.564-6.031.937-7.994 5.382-.897 2.15-8.595 3.094-15.733.175-4.196 24.687-3.877 24.978-.726.194 2.229 0 8.481.581 13.123.517 4.593 2.275 2.645 2.812 4.356 1.881 3.17 4.016 7.923-.025 15.997z"
                fill="url(#paint45_linear_5287_7562)"
              />
              <Path
                id="Vector_155"
                style={{
                  mixBlendMode: 'darken',
                }}
                d="M171.496 134.167a21.673 21.673 0 01-9.499 2.142c-2.472 0-7.066 1.415-7.299 5.409-.232 3.993 1.057 5.534-.232 4.71-1.289-.824-3.179-3.295-5.176-6.358-1.997-3.063-4.003-1.173-3.528 5.418l-3.872.009c.038-2.436-1.057-4.809-.047-7.026 6.528-1.95 3.273-10.146 4.093-16.701.175-4.196 24.687-3.877 24.978-.726.194 2.229.048 8.481.582 13.123z"
                fill="url(#paint46_linear_5287_7562)"
              />
              <Path
                id="Vector_156"
                d="M150.035 137.462l.873 1.716.852 1.715.795 1.735c.262.582.504 1.173.727 1.784a12.93 12.93 0 01-1.134-1.57 19.369 19.369 0 01-.911-1.706 23.882 23.882 0 01-.698-1.803c-.213-.611-.358-1.241-.504-1.871z"
                fill="#915548"
              />
              <Path
                id="Vector_157"
                d="M140.188 145.594c1.246.456 2.601.722 3.987.785 1.378.078 2.763.078 4.142 0a19.19 19.19 0 014.26.184c1.361.33 2.593.906 3.584 1.677a15.214 15.214 0 00-3.779-1.192 24.947 24.947 0 00-4.091 0 27.264 27.264 0 01-4.259-.184c-1.398-.191-2.716-.626-3.844-1.27z"
                fill="#915548"
              />
              <Path
                id="Vector_158"
                d="M160.949 148.242c.42-.534.96-.989 1.589-1.337a6.092 6.092 0 012.071-.689c.739-.135 1.49-.216 2.245-.242.729 0 1.459-.058 2.178-.078 1.448 0 2.896-.096 4.333-.184l2.166-.164c.73-.059 1.459-.097 2.178-.185-.696.185-1.392.378-2.111.514-.718.136-1.436.262-2.155.368a36.962 36.962 0 01-4.389.33h-2.245a17.25 17.25 0 00-2.133.097c-1.426.103-2.755.663-3.727 1.57z"
                fill="#915548"
              />
            </G>
            <G id="pressable_torso">
              <G id="Group 27560">
                <Path
                  id="Vector_159"
                  d="M151.747 135.142c-36.334 3.879-27.492 6.364-27.177 21.721 1.193 13.183 1.469 19.157 1.991 27.692.102 7.876 2.572 38.614 2.551 47.328 6.486 3.389 59.848 1.73 60.808-.785 0 0 3.071-41.005 3.495-48.426.571-7.713 3.134-30.345 2.803-40.875-.027-.862-.632-1.58-1.467-1.796-3.356-.871-5.764-1.492-8.357-1.978-14.54-2.367-17.39-2.802-34.647-2.881z"
                  fill="#915548"
                />
                <Path
                  id="Vector_160"
                  d="M188.023 231.106c-2.292 4.151-29.654 4.071-40.225 3.852-7.405-.083-15.04-1.773-17.159-2.731 0 0-.684-12.516-.768-14.627-.053-1.052-.301-5.451-.422-7.816 0 0-.023-3.624-.423-8.977-.399-5.353-3.384-30.068-4.486-42.114-2.011-19.9-5.917-17.048 16.017-20.974 20.68-3.243 46.064 2.111 52.46 3.595a1.91 1.91 0 011.481 1.936c-.553 18.252-6.475 87.856-6.475 87.856z"
                  fill="url(#paint47_linear_5287_7562)"
                />
                <Path
                  id="Vector 14_2"
                  d="M127.52 167.801c-.128-2.274-.085-3.79-.085-3.79.028 1.29.056 2.552.085 3.79.355 6.293 2.022 18.39 9.541 20.211 3.284.796-4.262 2.556-5.608 6.509-2.78 8.169 1.392 18.052.554 26.641-.517 5.301-1.554 11.884-1.554 11.884-1.493-24.551-2.333-39.625-2.933-65.245z"
                  fill="url(#paint48_linear_5287_7562)"
                />
                <Path
                  id="Vector 13_2"
                  d="M158.596 179.363c-.677 4.88-2.68 7.44-7.65 9.018-.228.073-.173.458.067.453l16.038-.373c.239-.006.278-.395.048-.459-4.892-1.348-6.99-3.871-7.981-8.657-.049-.236-.489-.221-.522.018z"
                  fill="#DD976A"
                />
                <Ellipse
                  id="Ellipse 1_2"
                  cx={140.662}
                  cy={179.674}
                  rx={2.42566}
                  ry={1.49792}
                  fill="#D4885F"
                />
                <Ellipse
                  id="Ellipse 3_2"
                  cx={160.137}
                  cy={226.856}
                  rx={2.42566}
                  ry={1.49792}
                  fill="#915548"
                />
                <Ellipse
                  id="Ellipse 2_2"
                  cx={176.793}
                  cy={180.706}
                  rx={2.42566}
                  ry={1.49792}
                  fill="#D4885F"
                />
              </G>
              <G id="Neck_2">
                <Path
                  id="Vector_161"
                  d="M175.996 138.024c-.146-.278-.343-.998-.794-1.427l-14.81-.396-14.451-.102s-1.576 5.984-1.727 8.709c-.805 14.442 10.662 18.833 23.107 15.983 4.032-.969 8.209-3.644 9.692-7.821a14.543 14.543 0 00-1.017-14.946z"
                  fill="#915548"
                />
                <Path
                  id="Vector_162"
                  d="M176.417 154.82c-5.029 9.761-23.939 8.626-28.989 2.859-2.49-3.045-3.649-7.958-3.388-11.883.038-2.436-1.667-6.756.834-8.719l.692-1.622s10.094-.701 15.967-.423c5.933.281 10.261.844 10.261.844s.065 1.106.564 1.401c1.037.614 4.947 1.112 4.947 1.112 2.109 3.161 3.153 8.357-.888 16.431z"
                  fill="url(#paint49_linear_5287_7562)"
                />
                <Path
                  id="Vector_163"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M174.463 136.913s-6.976-.676-10.264-.692c-2.471 0-7.066 1.415-7.298 5.408-.233 3.994 1.056 5.535-.233 4.711-1.289-.824-3.179-3.295-5.176-6.358-1.996-3.063-4.003-1.173-3.528 5.418l-3.984-.034c-.033-2.351-.782-4.971.157-7.045 1.381-2.5 1.411-2.875 1.411-2.875s8.863-.549 13.905-.529c5.913.024 15.01 1.996 15.01 1.996z"
                  fill="url(#paint50_linear_5287_7562)"
                />
                <Path
                  id="Vector_164"
                  d="M152.238 137.374l.873 1.715.853 1.716.794 1.735c.262.581.504 1.173.727 1.783a12.96 12.96 0 01-1.134-1.57 19.228 19.228 0 01-.911-1.706 23.98 23.98 0 01-.698-1.803c-.213-.61-.358-1.24-.504-1.87z"
                  fill="#915548"
                />
                <Path
                  id="Vector_165"
                  d="M142.391 145.505c1.246.456 2.601.723 3.987.786 1.379.077 2.763.077 4.142 0a19.19 19.19 0 014.26.184c1.362.33 2.593.906 3.585 1.677a15.195 15.195 0 00-3.78-1.193 24.947 24.947 0 00-4.091 0 27.142 27.142 0 01-4.259-.184c-1.398-.19-2.716-.625-3.844-1.27z"
                  fill="#915548"
                />
                <Path
                  id="Vector_166"
                  d="M163.152 148.154c.42-.534.961-.989 1.59-1.337a6.065 6.065 0 012.07-.689c.739-.135 1.49-.216 2.245-.242.73 0 1.459-.058 2.178-.078 1.448 0 2.896-.097 4.333-.184l2.166-.165c.73-.058 1.459-.097 2.178-.184-.696.184-1.392.378-2.111.514-.718.135-1.436.261-2.155.368a36.962 36.962 0 01-4.389.33h-2.245c-.713-.012-1.425.02-2.133.097-1.426.102-2.755.663-3.727 1.57z"
                  fill="#915548"
                />
              </G>
              <Path
                id="highlight_torso"
                d="M128.51 231.995l-5.554-87.51c-.147-2.319 1.038-4.547 3.214-5.36 14.47-5.405 43.52-4.728 66.749.709 1.886.441 3.138 2.207 2.988 4.139l-6.771 87.424c-20.812 4.779-35.517 6.236-60.626.598z"
                fill="#A430FF"
                fillOpacity={0.25}
                stroke="#A430FF"
                strokeWidth={1.5}
                opacity={highlightedParts.includes(BODY_PARTS.torso) ? 1 : 0}
              />
            </G>
            <G id="pressable_face">
              <G id="pressable_head">
                <G id="pressable_leftEar">
                  <G id="Left Ear">
                    <Path
                      id="Vector_167"
                      d="M122.448 73.133c-1.836-3.788-4.798-6.497-9.183-5.257-5.349 1.653-4.041 8.517-3.972 12.788a18.37 18.37 0 003.903 11.295 10.423 10.423 0 0011.801 4.89c-.597-7.99-1.171-15.795-2.549-23.716z"
                      fill="#915548"
                    />
                    <Path
                      id="Vector_168"
                      d="M123.825 95.93c-5.9.988-8.494-3.076-10.767-6.405a20.251 20.251 0 01-2.594-10.859 20.2 20.2 0 01.413-6.887A3.789 3.789 0 01113.862 69a5.53 5.53 0 014.591.803c.155.102.301.217.436.345a13.155 13.155 0 012.641 3.237c.206 1.262.436 2.824.643 4.591v.551c.505 3.903.987 8.656 1.354 13.247.115 1.47.298 2.847.298 4.156z"
                      fill="url(#paint51_linear_5287_7562)"
                    />
                    <Path
                      id="Vector_169"
                      style={{
                        mixBlendMode: 'darken',
                      }}
                      d="M123.825 95.931c-5.9.987-8.494-3.076-10.767-6.405a20.251 20.251 0 01-2.594-10.86 20.2 20.2 0 01.413-6.887c-.145 2.24.072 4.488.643 6.658.436 1.745 1.125-.827 1.4-2.71.276-1.882.689-3.213 2.158-3.627a2.298 2.298 0 012.916 1.056c.781.965.895-1.538.505-3.351.155.101.301.217.436.344a65.093 65.093 0 013.169 7.829c.01.068.01.138 0 .206.012.115.012.23 0 .345.137 1.767 0 5.074 0 5.395 0 .321-1.034-1.102-1.47-1.79-.436-.69-1.653 0-2.296.55a2.944 2.944 0 00-.344 3.33c.712 1.33 1.263 2.433 2.434 2.846 1.171.413 2.571.987 1.813 1.607-.757.62-1.676 1.607-2.295.344-.62-1.262-1.332-1.79-2.021-1.951a5.485 5.485 0 01-2.433-3.742 9.458 9.458 0 012.295-5.625c1.057-.918-.78-.918-1.951 0s-1.676-.298-1.607-1.332c.069-1.033-.964 1.24-1.102 3.054a12.038 12.038 0 004.729 9.597c-1.607 0-4.316-2.64-5.211-5.074-.896-2.434-.436.849.275 2.295.712 1.447 3.329 5.648 5.418 6.543a3.356 3.356 0 004.154-.916c.318-.404.539-.876.645-1.38 0-.344.229-.459.482-.367.023 1.332.206 2.71.206 4.018z"
                      fill="url(#paint52_linear_5287_7562)"
                    />
                    <Path
                      id="Vector_170"
                      d="M121.323 80.273l-.229.16a32.116 32.116 0 00-.85-1.813 29.446 29.446 0 00-2.043-3.49 17.127 17.127 0 00-1.171-1.607 2.288 2.288 0 00-1.607-.826 1.562 1.562 0 00-1.378 1.056 6.204 6.204 0 00-.551 1.951 6.25 6.25 0 01.322-2.043c.13-.335.316-.646.551-.918a1.517 1.517 0 011.056-.437 2.506 2.506 0 011.951.873c.48.509.911 1.062 1.286 1.653a21.07 21.07 0 011.974 3.604c.268.605.498 1.226.689 1.86v-.023z"
                      fill="#915548"
                    />
                    <Path
                      id="Vector_171"
                      d="M122.151 90.972a1.262 1.262 0 01-1.171.551 2.117 2.117 0 01-1.607-1.469.939.939 0 00-.528-.505c-.253 0-.574-.16-.919-.298a4.245 4.245 0 01-2.433-3.169 6.447 6.447 0 01.666-3.88 14.157 14.157 0 012.295-3.122 13.42 13.42 0 00-2.043 3.26 6.09 6.09 0 00-.436 3.65 3.84 3.84 0 002.158 2.687c.276.114.597.16.941.298a1.7 1.7 0 01.873.78c.115.267.27.515.459.735.15.185.362.307.597.345.505 0 .735-.345.505-.804-.23-.459-.827-.62-1.423-.941a5.485 5.485 0 01-2.526-3.122 4.587 4.587 0 01-.206-1.998 2.634 2.634 0 011.01-1.745c.872-.642 1.79-1.17 2.686-1.744l.229-.138-.229.16-1.01.735c-.505.39-1.056.758-1.516 1.171a2.922 2.922 0 00-.528 3.375 5.01 5.01 0 002.296 2.709c.689.2 1.294.619 1.722 1.194.135.183.218.398.242.624.025.226-.011.454-.104.661z"
                      fill="#915548"
                    />
                    <Path
                      id="Vector_172"
                      d="M115.996 75.545a10.25 10.25 0 00-.482 1.56l-.207.758c-.006.115-.006.23 0 .345.115 0 .299 0 .529-.23l.665-.482c.437-.321.896-.62 1.355-.895-.367.413-.758.78-1.148 1.148l-.597.55a1.55 1.55 0 01-.367.276.67.67 0 01-.551 0 .527.527 0 01-.414-.505.96.96 0 010-.482c.072-.267.164-.528.276-.78.275-.449.591-.871.941-1.263z"
                      fill="#915548"
                    />
                    <Path
                      id="Vector_173"
                      d="M114.894 75.108a38.587 38.587 0 00-1.4 4.063 10.17 10.17 0 00-.345 4.156 10.714 10.714 0 001.263 3.972 11.086 11.086 0 002.686 3.26 9.692 9.692 0 01-3.053-3.054 10.494 10.494 0 01-1.447-4.11 10.62 10.62 0 01.482-4.338c.483-1.37 1.09-2.691 1.814-3.95z"
                      fill="#915548"
                    />
                  </G>
                </G>
                <G id="pressable_rightEar">
                  <G id="Right Ear">
                    <Path
                      id="Vector_174"
                      d="M195.903 73.13c1.837-3.789 4.799-6.498 9.184-5.258 5.326 1.653 4.017 8.517 3.948 12.788a18.09 18.09 0 01-3.902 11.295 10.402 10.402 0 01-11.801 4.89c.574-7.99 1.263-15.795 2.571-23.716z"
                      fill="#915548"
                    />
                    <Path
                      id="Vector_175"
                      d="M196.844 73.382c1.79-3.077 3.581-5.327 7.622-4.592 4.04.734 3.558 6.244 3.398 9.711a20.204 20.204 0 01-2.595 10.86c-2.296 3.328-4.844 7.369-10.767 6.405.482-7.783 1.538-17.334 2.342-22.385z"
                      fill="url(#paint53_linear_5287_7562)"
                    />
                    <Path
                      id="Vector_176"
                      style={{
                        mixBlendMode: 'darken',
                      }}
                      d="M198.338 74.736c-.161 1.217.803 1.01 1.63-.16.826-1.171 2.296-2.296 3.49-2.159 1.193.138 2.295 3.467 2.295 4.753v4.798a19.302 19.302 0 00-1.951-5.854c-.482-.643-.161.734 0 1.997.16 1.263-.413 1.309-1.469.62s-2.595-1.102-1.493.482a10.736 10.736 0 012.296 4.913 5.394 5.394 0 01-1.217 4.11c-1.102.94-2.479 1.056-3.007 1.515-.528.459-.299 1.377-1.469 1.377-1.171 0-1.998-1.056-.896-1.469a4.798 4.798 0 002.801-1.997c.781-1.286 1.745-3.077 1.377-4.018a8.033 8.033 0 00-3.237-2.847c-.666-.16.85-6.06.85-6.06z"
                      fill="url(#paint54_linear_5287_7562)"
                    />
                    <Path
                      id="Vector_177"
                      d="M197.005 80.27l.207.16c.275-.597.551-1.217.849-1.814a29.583 29.583 0 012.044-3.49c.358-.563.757-1.1 1.194-1.607a2.13 2.13 0 011.584-.826 1.562 1.562 0 011.377 1.056c.29.616.476 1.275.551 1.952a5.683 5.683 0 00-.321-2.044 2.305 2.305 0 00-.551-.918 1.493 1.493 0 00-1.033-.436 2.525 2.525 0 00-1.975.872c-.48.51-.91 1.063-1.285 1.653a22.804 22.804 0 00-1.975 3.605 16.39 16.39 0 00-.689 1.86l.023-.024z"
                      fill="#915548"
                    />
                    <Path
                      id="Vector_178"
                      d="M196.155 90.969a1.269 1.269 0 001.171.55 2.113 2.113 0 001.607-1.469c.109-.227.297-.406.528-.505.253 0 .574-.16.919-.298a4.153 4.153 0 002.433-3.169 6.447 6.447 0 00-.666-3.88 14.061 14.061 0 00-2.295-3.122 14.05 14.05 0 012.02 3.26 5.919 5.919 0 01.436 3.65 3.78 3.78 0 01-2.158 2.687c-.252.114-.597.16-.918.298a1.629 1.629 0 00-.873.78 2.894 2.894 0 01-.482.735.89.89 0 01-.597.345c-.482 0-.734-.345-.482-.804.253-.459.804-.62 1.401-.941a5.397 5.397 0 002.525-3.122 4.602 4.602 0 00.207-1.998 2.593 2.593 0 00-.987-1.745c-.873-.642-1.814-1.17-2.71-1.744l-.229-.138.206.16 1.011.735c.528.39 1.079.758 1.538 1.171a2.94 2.94 0 01.505 3.375 5.002 5.002 0 01-2.296 2.71c-.689.198-1.294.618-1.722 1.193a1.284 1.284 0 00-.092 1.285z"
                      fill="#915548"
                    />
                    <Path
                      id="Vector_179"
                      d="M203.411 75.104a33.891 33.891 0 011.4 4.063 10.59 10.59 0 01.368 4.156 10.772 10.772 0 01-1.286 3.972 11.086 11.086 0 01-2.686 3.26 9.177 9.177 0 003.053-3.054 10.117 10.117 0 001.447-4.11 9.882 9.882 0 00-.482-4.338 23.765 23.765 0 00-1.814-3.95z"
                      fill="#915548"
                    />
                    <Path
                      id="Vector_180"
                      d="M202.309 75.54c.199.51.368 1.032.505 1.562 0 .252 0 .505.184.758.006.114.006.23 0 .344 0 0-.299 0-.528-.23l-.643-.482c-.46-.321-.896-.62-1.378-.895.368.413.758.78 1.148 1.148l.62.55c.095.115.212.21.344.276a.693.693 0 00.574 0 .577.577 0 00.414-.505c.019-.16.019-.322 0-.482 0-.252-.184-.528-.299-.78a7.396 7.396 0 00-.941-1.263z"
                      fill="#915548"
                    />
                  </G>
                </G>
              </G>
              <Path
                id="Vector_181"
                d="M194.191 33.58c-8.425-16.506-28.766-19.192-45.618-16.208-24.818 4.867-30.488 27.55-28.032 49.269.666 8.953 1.998 18.71 2.985 27.664 1.883 13.041 12.65 22.522 23.899 28.515 9.987 5.372 18.987 3.765 27.941-2.687 7.737-5.67 14.968-12.718 17.93-21.97 2.502-9 2.939-18.482 4.179-27.665 1.813-12.306 2.708-25.484-3.284-36.917z"
                fill="#915548"
              />
              <Path
                id="Vector_182"
                d="M196.738 66.042c-.895 6.566-1.974 17.678-3.558 26.86a33.703 33.703 0 01-9.758 18.367 41.98 41.98 0 01-1.469 1.424c-4.913 4.592-13.293 11.892-22.752 11.892s-21.029-8.976-26.057-14.211a30.853 30.853 0 01-8.426-17.38c-.597-5.51-2.296-17.7-2.962-26.516-.551-6.887-6.244-49.2 38.18-49.2 22.499 0 31.889 10.837 35.539 22.362 3.651 11.525 1.699 23.142 1.263 26.402z"
                fill="url(#paint55_radial_5287_7562)"
              />
              <Path
                id="Vector_183"
                style={{
                  mixBlendMode: 'darken',
                }}
                d="M192.515 49.56c-1.676 1.929-5.074 2.296-7.531 2.548a12.126 12.126 0 005.855.85 17.456 17.456 0 01-4.592 1.837c.735.264 1.52.359 2.296.275a25 25 0 01-11.066 2.296 25.733 25.733 0 01-16.3-7.14c-5.281-4.936-6.612-9.642-10.446-14.028-3.375-3.88-8.587-6.175-12.719-4.844-3.444.322-6.337 3.49-6.474 9.184-.138 5.693-.437 13.775-2.159 18.573-1.721 4.798-3.902 8.494-4.04 15.566.023 6.916.553 13.822 1.584 20.662.735 4.89 4.178 10.813 9.941 16.851 5.762 6.038 16.071 12.237 22.177 11.824 5.786-.414 13.293-2.686 24.428-12.65-.482.482-.964.964-1.469 1.423-4.913 4.592-13.293 11.893-22.752 11.893s-21.03-8.977-26.058-14.212a30.85 30.85 0 01-8.425-17.379c-.597-5.51-2.296-17.7-2.962-26.517-.551-6.887-6.244-49.2 38.18-49.2 22.499 0 31.889 10.837 35.539 22.362l-4.041 5.854a18.36 18.36 0 01-5.624.414c.046 1.24 6.658 3.558 6.658 3.558z"
                fill="url(#paint56_linear_5287_7562)"
              />
              <Path
                id="Vector_184"
                style={{
                  mixBlendMode: 'multiply',
                }}
                opacity={0.7}
                d="M135.28 105.692c5.984 0 10.836-4.851 10.836-10.836s-4.852-10.837-10.836-10.837c-5.985 0-10.837 4.852-10.837 10.837 0 5.985 4.852 10.836 10.837 10.836z"
                fill="url(#paint57_radial_5287_7562)"
              />
              <Path
                id="Vector_185"
                style={{
                  mixBlendMode: 'multiply',
                }}
                opacity={0.7}
                d="M182 105.692c5.985 0 10.837-4.851 10.837-10.836S187.985 84.019 182 84.019c-5.984 0-10.836 4.852-10.836 10.837 0 5.985 4.852 10.836 10.836 10.836z"
                fill="url(#paint58_radial_5287_7562)"
              />
              <Path
                id="Vector_186"
                style={{
                  mixBlendMode: 'darken',
                }}
                d="M147.425 82.804c6.479 0 11.732-5.252 11.732-11.732 0-6.479-5.253-11.731-11.732-11.731-6.479 0-11.732 5.252-11.732 11.731 0 6.48 5.253 11.732 11.732 11.732z"
                fill="url(#paint59_radial_5287_7562)"
              />
              <Path
                id="Vector_187"
                style={{
                  mixBlendMode: 'darken',
                }}
                d="M156.722 105.163c5.959 0 10.79-4.831 10.79-10.79 0-5.96-4.831-10.79-10.79-10.79-5.959 0-10.79 4.83-10.79 10.79 0 5.959 4.831 10.79 10.79 10.79z"
                fill="url(#paint60_radial_5287_7562)"
              />
              <Path
                id="Vector_188"
                style={{
                  mixBlendMode: 'darken',
                }}
                d="M171.462 82.804c6.479 0 11.732-5.252 11.732-11.732 0-6.479-5.253-11.731-11.732-11.731-6.479 0-11.732 5.252-11.732 11.731 0 6.48 5.253 11.732 11.732 11.732z"
                fill="url(#paint61_radial_5287_7562)"
              />
              <Path
                id="Vector_189"
                style={{
                  mixBlendMode: 'darken',
                }}
                d="M159.201 116.115a14.607 14.607 0 018.541 2.87 10.434 10.434 0 001.524-9.345 10.43 10.43 0 00-6.667-6.722 10.424 10.424 0 00-13.683 9.868c.01 2.23.725 4.4 2.043 6.199a13.62 13.62 0 018.242-2.87z"
                fill="url(#paint62_radial_5287_7562)"
              />
              <Path
                id="Vector_190"
                style={{
                  mixBlendMode: 'darken',
                }}
                opacity={0.4}
                d="M142.833 103.971a3.031 3.031 0 100-6.062 3.031 3.031 0 000 6.062z"
                fill="url(#paint63_radial_5287_7562)"
              />
              <Path
                id="Vector_191"
                style={{
                  mixBlendMode: 'darken',
                }}
                opacity={0.4}
                d="M174.216 103.971a3.031 3.031 0 100-6.062 3.031 3.031 0 000 6.062z"
                fill="url(#paint64_radial_5287_7562)"
              />
              <G id="Hair">
                <Path
                  id="Vector_192"
                  d="M197.656 19.21a43.892 43.892 0 00-18.091-13.5 53.836 53.836 0 00-17.448-3.237 25.587 25.587 0 00-3.605.138c1.47-.459 2.916-.895 4.202-1.217a19.494 19.494 0 00-5.051-.964 31.91 31.91 0 00-25.048 11.824c-11.731 1.813-16.185 10.56-17.746 21.466a61.132 61.132 0 00-.345 19.72 85.428 85.428 0 002.778 13.385 44.466 44.466 0 013.743 12.995 34.888 34.888 0 001.79 4.775c.115-1.308.597-5.648.574-6.589V67.193c-.131-2.273.181-4.55.919-6.704 1.423-3.306 4.201-6.107 4.959-9.78 1.354-7.003-2.067-19.469 8.632-19.354a52.324 52.324 0 0112.558.184c4.316.367 8.632.711 13.017.78 6.475 0 12.949-.23 19.423 0 4.477-.298 6.107 4.11 6.153 7.92.138 3.399 0 7.14 0 10.562a26.033 26.033 0 003.65 8.563c2.181 3.467 1.699 7.806 1.745 12.145v10.698c0 1.585.207 4.041.505 6.337a29.097 29.097 0 001.4-4.592c1.286-4.477 1.768-10.285 2.87-14.739 1.079-3.076 2.64-6.451 3.49-9.62 2.227-13.223 2.824-28.835-5.074-40.383z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_193"
                  d="M202.96 45.082a97.092 97.092 0 01-1.079 12.764 18.525 18.525 0 01-.689 2.755c-1.079 3.238-2.594 6.727-3.145 8.45-.551 1.72-2.135 12.65-2.571 15.266.183-4.591 0-13.89 0-16.07a19.801 19.801 0 00-1.24-8.22 51.948 51.948 0 01-4.064-8.609 4.163 4.163 0 010-1.01V43.52c.012-.114.012-.23 0-.344v-1.538-1.01-.965-.505c-.252-3.053-1.607-7.69-6.244-7.943-2.044-.115-5.304 0-8.931 0h-1.86c-4.04 0-8.288.138-11.685 0H159.5c-3.512-.184-7.117-.482-9.941-.735-1.997-.183-3.627-.321-4.591-.367h-.597c-1.424 0-3.72 0-5.373.138H137.759a8.103 8.103 0 00-6.681 2.8c-2.434 3.123-2.296 8.105-2.434 11.48-.137 3.375.391 6.06-2.158 10.17-2.548 4.11-3.696 5.464-3.995 9.367-.298 3.903 0 16.07 0 17.517a48.766 48.766 0 00-3.788-14.578c-.987-1.47-2.732-11.686-3.329-17.839a69.626 69.626 0 012.434-22.315 17.88 17.88 0 0115.566-13.614 30.507 30.507 0 0126.493-11.617 24.316 24.316 0 00-9.688 2.824 60.976 60.976 0 0126.287 1.377c7.416 2.296 16.806 8.495 21.099 15.152 4.293 6.658 5.671 16.668 5.395 24.107z"
                  fill="url(#paint65_radial_5287_7562)"
                />
                <Path
                  id="Vector_194"
                  style={{
                    mixBlendMode: 'screen',
                  }}
                  opacity={0.21}
                  d="M125.475 29.309a10.881 10.881 0 002.296 2.87c.482-.299.965-.597 1.493-.873a5.833 5.833 0 01-.988-2.823c-.958.183-1.896.46-2.801.826zm2.687-5.946c-.643-.712-.414-1.08.367-1.63a13.904 13.904 0 00-3.099.115c-.276.918.597 2.066 1.102 2.87.229.344 0 .78-.138 1.24a23.558 23.558 0 012.571 0c1.47-1.54.115-1.54-.803-2.595zm.849-4.293c.674.2 1.334.446 1.975.734.298-.597-.001-1.125-.322-1.928-.321-.804-.298-1.194.367-1.768h-.941c-.964.505-1.722 1.125-1.286 1.974.161.303.233.646.207.988z"
                  fill="url(#paint66_radial_5287_7562)"
                />
                <Path
                  id="Vector_195"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M202.96 45.082a97.092 97.092 0 01-1.079 12.764 25.625 25.625 0 00-3.03-10.652c2.915 1.331 3.925 0 3.925-1.7a62.645 62.645 0 00-2.8-17.723 37.656 37.656 0 00-17.058-17.953 37.882 37.882 0 00-27.068-.46 43 43 0 00-12.237 6.888 25.712 25.712 0 0115.841-10.331 26.194 26.194 0 00-21.328 14.05 24.83 24.83 0 0112.903-14.142 21.332 21.332 0 00-14.602 10.744 16.968 16.968 0 013.834-7.92 9.618 9.618 0 00-5.28 9.55c-1.355-3.053-8.082-2.479-10.997.322 3.145-.115 8.976.78 11.479 5.395a15.108 15.108 0 00-11.916-1.561c-3.581 1.102-3.581 4.132-.551 4.018 3.031-.115 9.184-1.906 12.903 2.296a19.742 19.742 0 00-10.767.895 10.034 10.034 0 00-5.947 7.645c-.573 2.296 2.296 0 5.602-2.71 3.306-2.708 8.426-5.945 13.775-4.59.15.04.291.11.413.206a7.703 7.703 0 00-1.239.207 8.106 8.106 0 00-6.658 2.731c-2.434 3.123-2.296 8.105-2.434 11.48-.137 3.375.391 6.06-2.158 10.17-2.548 4.11-3.696 5.464-3.995 9.367-.298 3.903 0 16.07 0 17.517a48.766 48.766 0 00-3.788-14.578c-.987-1.47-2.732-11.686-3.329-17.839a69.626 69.626 0 012.434-22.315 17.88 17.88 0 0115.566-13.614 30.507 30.507 0 0126.493-11.617 24.316 24.316 0 00-9.688 2.824 60.976 60.976 0 0126.287 1.377c7.416 2.296 16.806 8.495 21.099 15.152 4.293 6.658 5.671 16.668 5.395 24.107z"
                  fill="url(#paint67_linear_5287_7562)"
                />
                <Path
                  id="Vector_196"
                  d="M133.533 13.79c.322.575.597 1.195.873 1.792.275.597.505 1.262.711 1.905a37.116 37.116 0 011.033 3.88c.276 1.309.483 2.617.712 3.949.23 1.332.459 2.617.735 3.926a28.345 28.345 0 01-1.171-3.834c-.321-1.309-.574-2.617-.849-3.926-.276-1.309-.506-2.617-.827-3.903-.184-.643-.344-1.286-.551-1.905-.207-.62-.413-1.263-.666-1.883z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_197"
                  d="M122.17 20.77c.493-.191.999-.344 1.515-.46.505 0 1.033-.206 1.561-.275.528-.069 1.056 0 1.585 0a12.292 12.292 0 013.168.436c.505.138 1.01.322 1.515.505.49.205.965.443 1.423.712l.666.413.643.483a16.04 16.04 0 00-1.423-.666c-.483-.207-.965-.39-1.447-.551l-1.492-.437-1.515-.275c-.528 0-1.033-.138-1.538-.184h-1.562l-1.561.115c-.505-.023-1.033.069-1.538.184z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_198"
                  d="M119.461 29.172a5.923 5.923 0 003.765-.39c1.194-.46 2.296-1.125 3.605-1.562a9.983 9.983 0 013.948-.459 9.37 9.37 0 013.789 1.08 12.131 12.131 0 00-3.812-.69 11.021 11.021 0 00-3.765.552c-1.217.39-2.296.987-3.65 1.4a5.51 5.51 0 01-3.88.069z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_199"
                  d="M117.877 44.851a8.11 8.11 0 002.296-2.158c.643-.872 1.194-1.767 1.768-2.686a33.032 33.032 0 013.971-5.142 18.074 18.074 0 015.304-3.789 13.579 13.579 0 013.122-.94 10.241 10.241 0 013.237 0 13.044 13.044 0 00-6.176 1.4 18.68 18.68 0 00-4.913 3.719 38.667 38.667 0 00-4.04 4.982c-.62.872-1.217 1.768-1.929 2.594a7.686 7.686 0 01-2.64 2.02z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_200"
                  d="M129.677 37.507a24.438 24.438 0 01-.712 4.248 26.252 26.252 0 01-1.401 4.109 24.256 24.256 0 01-2.089 3.788 10.828 10.828 0 01-1.4 1.676 7.869 7.869 0 01-1.745 1.263 10.888 10.888 0 002.801-3.169 32.665 32.665 0 001.997-3.765 33.376 33.376 0 001.539-3.994 36.803 36.803 0 001.01-4.156z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_201"
                  d="M136.703 15.857c.25-.627.534-1.24.85-1.837.324-.595.684-1.17 1.079-1.722.39-.55.803-1.079 1.239-1.607.437-.528.942-.987 1.424-1.446a21.044 21.044 0 013.283-2.411c.577-.342 1.175-.65 1.79-.918a19.076 19.076 0 011.906-.712 26.57 26.57 0 00-1.814.895l-1.721 1.01c-.551.368-1.08.758-1.608 1.171-.528.414-1.033.85-1.538 1.286-.505.436-.941.918-1.4 1.4-.459.483-.873 1.01-1.286 1.539a21.214 21.214 0 00-1.171 1.63 26.692 26.692 0 00-1.033 1.722z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_202"
                  d="M145.357 18.382l.988-.804 1.056-.78 1.056-.69 1.125-.642 1.148-.597 1.171-.528 1.216-.482 1.217-.413 1.24-.322 1.263-.275 1.285-.23 1.286-.138H163.265l1.286.138H160.671l-1.286.138-1.24.184-1.262.23-1.24.298-1.217.344-1.217.39-1.194.436-1.171.482-1.147.529-1.148.597-1.102.642-1.079.69-1.011.803z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_203"
                  d="M183.285 14.225l1.263.551 1.217.597 1.171.689 1.147.711 1.125.804 1.079.826 1.034.896.987.964.918.987.895 1.056.827 1.08.781 1.124.711 1.148.643 1.217.597 1.217.528 1.263-.643-1.217-.665-1.171-.735-1.125-.804-1.125-.826-1.079-.85-1.056-.872-1.01-.941-.964-.942-.942-1.01-.918-1.033-.85-1.056-.826-1.102-.804-1.125-.734-1.171-.689-1.148-.62z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_204"
                  d="M189.553 27.22c.918.505 1.859.987 2.755 1.538a23.264 23.264 0 012.617 1.837 14.015 14.015 0 012.296 2.296c.654.857 1.172 1.81 1.538 2.824a14.831 14.831 0 00-1.859-2.549 21.98 21.98 0 00-2.296-2.158 40.492 40.492 0 00-2.457-1.974c-.849-.62-1.722-1.217-2.594-1.814z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_205"
                  d="M188.611 32.938a9.19 9.19 0 013.697 2.043 26.448 26.448 0 012.892 3.122 36.327 36.327 0 002.778 3.145 10.106 10.106 0 003.421 2.296 9.18 9.18 0 01-3.742-1.997 26.45 26.45 0 01-2.893-3.122 36.375 36.375 0 00-2.732-3.192 9.773 9.773 0 00-3.421-2.295z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_206"
                  d="M199.676 48.045l1.24 1.079 1.193 1.124c.396.425.687.936.85 1.493.137.547.183 1.113.138 1.676a24.784 24.784 0 00-.505-1.538 4.59 4.59 0 00-.85-1.286l-1.056-1.263-1.01-1.285z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_207"
                  d="M190.311 40.49c.252.827.528 1.653.803 2.457l.804 2.456c.231.821.515 1.627.849 2.411a4.59 4.59 0 001.561 1.974 4.108 4.108 0 01-1.905-1.79 13.778 13.778 0 01-.988-2.434c-.275-.826-.482-1.676-.688-2.502-.207-.827-.299-1.722-.436-2.572z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_208"
                  d="M138.654 18.864l.666-1.332.758-1.309.849-1.24.896-1.193.987-1.148 1.056-1.102 1.102-1.01 1.171-.964 1.239-.873 1.286-.78 1.355-.69 1.377-.62 1.423-.481 1.47-.39 1.469-.276 1.493-.16-1.47.275-1.446.367-1.401.482-1.377.551-1.355.62-1.285.735-1.263.78-1.217.873-1.148.918-1.125.964-1.056 1.056-1.01 1.08-.941 1.147-.896 1.194-.849 1.24-.758 1.286z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_209"
                  d="M145.633 13.86l1.79-1.423 1.883-1.332 1.974-1.17 2.067-1.057 2.135-.895 2.296-.78 2.295-.644 2.296-.482 2.296-.344 2.296-.16h2.296l2.296.114 2.295.298 2.296.437 2.296.62 2.158.78-2.296-.62-2.295-.482-2.296-.367-2.296-.207h-4.592l-2.296.207-2.295.321-2.296.436-2.296.574-2.296.712-2.112.85-2.066.987-2.021 1.102-1.928 1.24-1.584 1.285z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_210"
                  d="M192.514 41.822a18.548 18.548 0 008.334-2.801 39.53 39.53 0 01-8.471-5.441c-2.296-2.113-4.592-4.592-7.072-6.383-12.81-10.951-47.684 3.122-47.684 3.122l.345 1.01c6.267-1.95 12.627 2.296 16.07 7.37 5.395 8.655 11.273 16.07 20.663 17.632 2.363.353 4.769.306 7.117-.138 1.194-.206 4.821-.941 4.821-.941l-3.88-.964a18.642 18.642 0 006.245-1.125 26.613 26.613 0 01-6.406-1.929 23.554 23.554 0 0010.492-2.548l-2.961-.78a14.803 14.803 0 01-6.107-3.513c2.031.347 4.097.447 6.153.298a27.878 27.878 0 005.326-1.148 12.762 12.762 0 01-2.985-1.721z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_211"
                  d="M199.103 38.792h-.184a16.3 16.3 0 01-8.724 1.653 9.497 9.497 0 01-1.492-.299c.168.275.369.53.596.758.278.285.586.539.919.757a8.129 8.129 0 001.974.919l1.263.459h-1.401c-.642 0-1.262 0-1.859.115-.597.114-1.24 0-1.837 0a15.218 15.218 0 01-6.887-1.584c.069.278.169.547.298.803a14.236 14.236 0 007.645 5.923l.735.207-.321.138a29.458 29.458 0 01-10.607.987l.298.298a11.25 11.25 0 005.441 2.595c-.524.087-1.053.14-1.584.16a23.146 23.146 0 01-6.635-.688c.395.407.834.769 1.309 1.079.568.353 1.167.652 1.791.895.713.278 1.441.516 2.181.712h-.551a26.082 26.082 0 01-4.822 0c-9.527-.896-14.785-7.324-20.226-15.566l-.964-1.47c-.23-.344-.482-.711-.735-1.032a18.045 18.045 0 00-9.872-6.612 11.983 11.983 0 00-6.887.16c1.194-.459 2.686-2.296 3.765-3.168a42.204 42.204 0 015.464-3.306 39.197 39.197 0 019.665-3.42 34.89 34.89 0 015.947-.781 33.452 33.452 0 0118.16 4.293c.826.46 1.653.964 2.456 1.515.804.551 1.171.804 1.722 1.263a26.218 26.218 0 012.158 1.79 42.842 42.842 0 013.788 4.386c.8 1.036 1.725 1.97 2.755 2.778 1.653 1.262 3.536 2.135 5.235 3.26l.023.023z"
                  fill="url(#paint68_radial_5287_7562)"
                />
                <Path
                  id="Vector_212"
                  style={{
                    mixBlendMode: 'screen',
                  }}
                  opacity={0.21}
                  d="M171.392 29.702a1.124 1.124 0 01-.344.436 33.444 33.444 0 00-10.676-5.142s.184 2.755 0 5.096l.896 1.08a56.877 56.877 0 013.581 5.188c.414-1.63.758-3.42 1.079-5.074a80.428 80.428 0 018.77 4.293c0-.711.115-1.676.184-2.732a41.376 41.376 0 01-1.928-1.676c-.643-.596-1.034-.964-1.562-1.469zM159.913 33.1a18.358 18.358 0 00-6.267-2.296h-.689a23.654 23.654 0 011.538 5.05c.23.368.482.736.712 1.126.229.39.872 1.377 1.332 2.089a22.075 22.075 0 000-5.074 23.39 23.39 0 017.438 5.717c.289-.678.527-1.376.712-2.09-1.401-1.882-2.916-3.856-4.385-5.51-.101.36-.272.696-.505.988h.114zm22.316-12.972a2.965 2.965 0 01-1.148 3.65 3.01 3.01 0 01-2.48.345 53.332 53.332 0 00-7.714-1.331c.551 1.558.86 3.192.919 4.844l3.191 3.512a13.9 13.9 0 00-.597-5.004s.941.183 5.418.849c2.296.367 3.168-.528 3.605-1.699a8.179 8.179 0 011.17-2.962c1.539-1.721 5.258-.482 8.197 1.24-4.087-4.5-11.64-6.589-10.676-3.444h.115z"
                  fill="url(#paint69_radial_5287_7562)"
                />
                <Path
                  id="Vector_213"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M136.289 22.606a.566.566 0 000 .184c.184 1.24 1.01 4.592 1.653 7.37h.873c1.653-.184 3.948-.138 5.372-.138h.597a18.37 18.37 0 0110.584 8.104c5.808 8.93 11.111 16.07 21.19 17.035a25.085 25.085 0 01-7.553-2.48c-4.293-2.112-10.309-9.871-13.936-15.818a22.49 22.49 0 00-5.671-6.474 12.51 12.51 0 00-6.887-2.571c4.132-3.903 11.295-1.125 14.923 1.515a15.242 15.242 0 011.997 1.79c3.145 3.192 6.543 8.312 8.839 11.159a68.216 68.216 0 00-6.887-11.09 25.996 25.996 0 00-4.592-4.729 12.904 12.904 0 00-9.505-2.755 16.063 16.063 0 00-5.785 1.929 21.368 21.368 0 018.816-4.89c2.137-.713 4.42-.871 6.635-.46a18.53 18.53 0 019.344 4.592c1.767 1.653 4.316 4.156 6.887 6.383a26.008 26.008 0 006.589 4.844 59.133 59.133 0 01-4.729-4.867 115.873 115.873 0 00-10.056-10.355 10.902 10.902 0 00-2.02-1.308c-4.592-2.296-10.883-1.814-18.091 1.607 6.703-7.232 17.632-8.22 21.397-8.426a22.362 22.362 0 00-16.071 1.722 28.104 28.104 0 00-10.561 10.928c-.597 1.102-2.135-2.433-1.24-5.28-.987.183-1.836-2.296-1.699-3.398-.826.321-1.699.16-1.813-.276l1.4 6.153z"
                  fill="url(#paint70_linear_5287_7562)"
                />
                <Path
                  id="Vector_214"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M179.795 54.38c.713.279 1.441.516 2.181.712h-.551c-.574-.206-1.125-.528-1.63-.712z"
                  fill="url(#paint71_linear_5287_7562)"
                />
                <Path
                  id="Vector_215"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M172.08 48.206c2.981 3 6.999 4.743 11.227 4.867a23.139 23.139 0 01-6.635-.688c.394.407.833.769 1.308 1.079a14.16 14.16 0 01-1.584-.942 21.372 21.372 0 01-4.316-4.316z"
                  fill="url(#paint72_linear_5287_7562)"
                />
                <Path
                  id="Vector_216"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M189.759 48.94a29.458 29.458 0 01-10.607.988l.299.298-.597-.16a10.439 10.439 0 01-3.926-3.743c4.568 3.077 11.387 2.663 14.831 2.617z"
                  fill="url(#paint73_linear_5287_7562)"
                />
                <Path
                  id="Vector_217"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M189.391 48.572l.734.206-.321.138a1.92 1.92 0 00-.413-.344z"
                  fill="url(#paint74_linear_5287_7562)"
                />
                <Path
                  id="Vector_218"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M202.247 43.936a14.854 14.854 0 01-4.591-1.286c-.666-.46-1.355 1.883-2.709 2.296-1.355.413-.827 4.43.918 6.015-1.217.321-1.974-1.056-3.627-.964a2.459 2.459 0 00-1.998 1.308 4.164 4.164 0 010-1.01v-6.888h-1.836a15.221 15.221 0 01-6.888-1.584c.069.279.169.548.299.804a4.231 4.231 0 01-.597-.643c-.574-1.033-.942-1.928-1.171-2.296 1.722 1.63 6.727 2.893 10.17 3.421.712 0 1.355.184 1.883.23.451.041.904.041 1.355 0l-.276-.161-.941-.505-1.975-1.125-.918-.551-.895-.597a7.483 7.483 0 01-1.791-1.722c1.147.41 2.331.71 3.535.896 2.921.482 5.916.245 8.725-.69a.229.229 0 00.183 0c0-.481-2.158-1.56-2.158-1.56a40.017 40.017 0 01-5.831-4.477c-.184-.16-.322-.322-.482-.482a50.07 50.07 0 00-5.74-5.855l.276.161a35.526 35.526 0 017.277 5.625 18.352 18.352 0 00-4.385-5.648c2.64.299 8.219 4.592 9.183 5.418.965.827-1.354-6.107-4.224-9.183a41.776 41.776 0 00-12.122-9.183 22.155 22.155 0 0113.936 8.356 33.2 33.2 0 015.579 15.91 6.157 6.157 0 01-.528 3.467c-.23.46 1.722 1.974 2.364 2.503z"
                  fill="url(#paint75_linear_5287_7562)"
                />
                <Path
                  id="Vector_219"
                  d="M139.963 27.796a16.07 16.07 0 018.081-3.33c1.5-.09 3.002.138 4.408.667a17.374 17.374 0 013.903 2.135 27.55 27.55 0 016.314 6.199 61.7 61.7 0 014.591 7.576 71.16 71.16 0 00-4.867-7.324 29.836 29.836 0 00-6.268-5.992 17.99 17.99 0 00-3.765-2.135 10.213 10.213 0 00-4.224-.758 16.21 16.21 0 00-8.173 2.962z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_220"
                  d="M141.523 24.008a36.52 36.52 0 014.592-2.893 22.22 22.22 0 015.074-1.929 16.574 16.574 0 015.418-.459 14.92 14.92 0 015.257 1.515 29.131 29.131 0 018.403 6.888 91.962 91.962 0 007.416 7.829 77.031 77.031 0 01-7.714-7.53 30.482 30.482 0 00-8.357-6.613 14.923 14.923 0 00-5.051-1.492 16.984 16.984 0 00-5.28.321 28.124 28.124 0 00-9.758 4.363z"
                  fill="#1C1E1F"
                />
              </G>
              <G id="Frame 2221" clipPath="url(#clip1_5287_7562)">
                <G id="Nose">
                  <Path
                    id="Vector_221"
                    d="M169.764 64.249c-1.813 1.492-6.29 8.632-5.28 12.168a29.259 29.259 0 01.758 11.778 3.607 3.607 0 011.584 2.295 3.281 3.281 0 01-1.102 3.33c-1.24.688-3.467.206-3.949.642-.482.436-1.01 1.607-2.663 1.607-1.653 0-1.975-.918-2.778-1.446-.804-.528-2.296 0-3.926-.896-1.63-.895-1.492-4.178.826-5.762a29.542 29.542 0 01.391-11.48c.826-2.823-3.077-9.045-5.969-13.04a3.026 3.026 0 01-.528-1.102c-.873-3.329 4.362-7.277 13.247-6.887 6.887.344 9.573 3.627 9.986 6.13a2.709 2.709 0 01-.597 2.663z"
                    fill="#D98B65"
                  />
                  <Path
                    id="Vector_222"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M169.764 64.249c-1.813 1.492-6.29 8.632-5.28 12.168a29.259 29.259 0 01.758 11.777c-1.424 0-3.421.436-3.697-1.033a46.565 46.565 0 01-.872-8.678 14.807 14.807 0 011.4-6.75 61.749 61.749 0 016.406-9.183 2.892 2.892 0 011.905-.85 2.701 2.701 0 01-.62 2.549z"
                    fill="url(#paint76_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_223"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M165.747 93.889c-1.24.688-3.467.206-3.949.642-.482.437-1.01 1.607-2.663 1.607-1.653 0-1.975-.918-2.778-1.446-.804-.528-2.296 0-3.926-.895-1.63-.896-1.493-4.179.826-5.763a29.542 29.542 0 01.39-11.479c.827-2.824-3.076-9.045-5.969-13.04a3.04 3.04 0 01-.528-1.102 7.693 7.693 0 014.294 1.515 34.474 34.474 0 015.28 9.413c.759 2.999.969 6.11.62 9.183-.138 3.742-.551 6.543-.689 8.082a2.515 2.515 0 00.491 1.982 2.509 2.509 0 001.805.956 4.82 4.82 0 003.03-1.331 3.652 3.652 0 014.064.321 2.494 2.494 0 00.826-2.043 3.283 3.283 0 01-1.124 3.398z"
                    fill="url(#paint77_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_224"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M165.747 93.889c-1.24.688-3.467.206-3.949.642-.482.437-1.01 1.607-2.663 1.607-1.653 0-1.975-.918-2.778-1.446-.804-.528-2.296 0-3.926-.895-1.63-.896-1.493-4.179.826-5.763a29.542 29.542 0 01.39-11.479c.827-2.824-3.076-9.045-5.969-13.04a3.04 3.04 0 01-.528-1.102 7.693 7.693 0 014.294 1.515 34.474 34.474 0 015.28 9.413c.759 2.999.969 6.11.62 9.183-.138 3.742-.551 6.543-.689 8.082a2.515 2.515 0 00.491 1.982 2.509 2.509 0 001.805.956 4.82 4.82 0 003.03-1.331 3.652 3.652 0 014.064.321 2.494 2.494 0 00.826-2.043 3.283 3.283 0 01-1.124 3.398z"
                    fill="url(#paint78_radial_5287_7562)"
                  />
                </G>
              </G>
              <G id="Right Brow">
                <Path
                  id="Vector_225"
                  d="M183.079 60.143a53.147 53.147 0 00-8.494-.138c-1.322.014-2.629.27-3.857.758v-.597a5.502 5.502 0 00-1.355.712 1.53 1.53 0 01-.253-.413 4.182 4.182 0 00-.987 5.372c1.685-.103 3.35-.411 4.959-.919a51.688 51.688 0 019.987-.688 10.582 10.582 0 014.752 2.089c2.296 1.607 3.834 2.87 4.592 3.283a23.072 23.072 0 00-3.237-5.786 9.184 9.184 0 00-6.107-3.673z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_226"
                  d="M191.045 67.857a16.784 16.784 0 00-7.921-4.385 50.246 50.246 0 00-10.216.712c-1.41.42-2.854.711-4.316.873v-.276a3.213 3.213 0 01.367-3.306 1.49 1.49 0 000 1.355 2.617 2.617 0 011.102-1.63 2.304 2.304 0 00-.161 1.216 6.598 6.598 0 014.868-1.653 53.3 53.3 0 018.333.138 7.92 7.92 0 014.202 2.066 24.213 24.213 0 013.742 4.89z"
                  fill="url(#paint79_linear_5287_7562)"
                />
                <Path
                  id="Vector_227"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M191.046 67.857a16.778 16.778 0 00-7.92-4.385 50.257 50.257 0 00-10.217.711c-1.41.42-2.854.712-4.316.873v-.276a3.015 3.015 0 010-1.515c.118.364.296.706.528 1.01.103-.452.257-.891.459-1.309a1.159 1.159 0 00.436.896c.345-.827 2.847-1.561 3.559-1.722-.161.344-.482.758-.482 1.01a39.464 39.464 0 018.632-.964 7.415 7.415 0 014.775 1.263 25.632 25.632 0 014.546 4.408z"
                  fill="url(#paint80_linear_5287_7562)"
                />
              </G>
              <G id="Left Brow">
                <Path
                  id="Vector_228"
                  d="M135.004 60.143a53.204 53.204 0 018.495-.138c1.321.014 2.628.27 3.857.758v-.597c.484.168.941.408 1.354.712a1.53 1.53 0 00.253-.414 4.152 4.152 0 01.987 5.373 21.05 21.05 0 01-4.959-.919 51.675 51.675 0 00-9.987-.689 10.698 10.698 0 00-4.752 2.09c-2.296 1.607-3.834 2.87-4.592 3.283a24.592 24.592 0 013.352-5.855 9.185 9.185 0 015.992-3.604z"
                  fill="#1C1E1F"
                />
                <Path
                  id="Vector_229"
                  d="M149.881 63.174a4.203 4.203 0 01-.391 1.882 25.005 25.005 0 01-4.316-.872 50.255 50.255 0 00-10.216-.712 16.876 16.876 0 00-7.921 4.385 23.481 23.481 0 013.88-4.89 7.855 7.855 0 014.178-2.066 53.387 53.387 0 018.334-.138 6.636 6.636 0 014.89 1.653c.064-.415 0-.84-.183-1.217.528.207.941 1.056 1.125 1.63a1.631 1.631 0 000-1.354 2.69 2.69 0 01.62 1.699z"
                  fill="url(#paint81_linear_5287_7562)"
                />
                <Path
                  id="Vector_230"
                  style={{
                    mixBlendMode: 'multiply',
                  }}
                  d="M149.881 63.172a4.202 4.202 0 01-.391 1.883 25.005 25.005 0 01-4.316-.873 50.248 50.248 0 00-10.216-.711 16.875 16.875 0 00-7.921 4.385 22.174 22.174 0 016.337-4.844 22.426 22.426 0 018.196-.781 9.71 9.71 0 013.099.964 6.555 6.555 0 00-.39-1.079 6.895 6.895 0 012.87 1.63c.183 0 0-.987 0-.987a9.183 9.183 0 011.905 1.653c.341-.366.62-.784.827-1.24z"
                  fill="url(#paint82_linear_5287_7562)"
                />
              </G>
              <G id="pressable_rightEye">
                <G id="Right Eye">
                  <Path
                    id="Vector_231"
                    d="M170.313 79.141a13.772 13.772 0 011.171-6.887c1.699-3.65 6.13-4.936 9.872-4.592a9.783 9.783 0 019.436 10.446c-1.493 6.888-10.079 7.209-15.566 5.74a6.88 6.88 0 01-4.591-2.801 2.71 2.71 0 01-.322-.918 8.13 8.13 0 010-.988z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_232"
                    d="M190.149 77.992c-.298 2.595-3.145 6.107-9.183 6.153-6.038.046-10.194-1.699-10.515-4.086-.321-2.388 0-10.974 8.724-11.48 8.724-.504 11.296 6.704 10.974 9.413z"
                    fill="url(#paint83_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_233"
                    d="M172.769 76.386a7.114 7.114 0 0012.279 5.292 7.117 7.117 0 10-12.279-5.292z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_234"
                    d="M179.863 82.838a6.452 6.452 0 100-12.904 6.452 6.452 0 000 12.904z"
                    fill="url(#paint84_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_235"
                    d="M179.863 82.838a6.452 6.452 0 100-12.904 6.452 6.452 0 000 12.904z"
                    fill="url(#paint85_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_236"
                    d="M179.864 80.197a3.81 3.81 0 100-7.622 3.81 3.81 0 000 7.622z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_237"
                    d="M182.848 75.032a.918.918 0 100-1.836.918.918 0 000 1.836z"
                    fill="#fff"
                  />
                  <Path
                    id="Vector_238"
                    d="M181.403 76.02a.46.46 0 100-.918.46.46 0 000 .919z"
                    fill="#fff"
                  />
                  <Path
                    id="Vector_239"
                    style={{
                      mixBlendMode: 'multiply',
                    }}
                    d="M179.129 70.534c7.554-.345 10.469 4.591 10.974 7.897.012-.114.012-.23 0-.344.322-2.709-2.158-9.757-11.02-9.344-8.287.413-8.999 7.99-8.793 10.905.299-3.535 1.929-8.862 8.839-9.114z"
                    fill="url(#paint86_linear_5287_7562)"
                  />
                </G>
              </G>
              <G id="pressable_leftEye">
                <G id="Left Eye">
                  <Path
                    id="Vector_240"
                    d="M148.762 79.141a13.55 13.55 0 00-1.171-6.887c-1.676-3.65-6.13-4.936-9.872-4.592a9.783 9.783 0 00-9.436 10.446c1.492 6.888 10.079 7.209 15.589 5.74a6.89 6.89 0 004.476-2.801c.162-.285.27-.596.322-.918a9.07 9.07 0 00.092-.988z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_241"
                    d="M128.927 77.992c.321 2.595 3.145 6.107 9.183 6.153 6.038.046 10.193-1.699 10.515-4.086.321-2.388 0-10.974-8.724-11.48-8.725-.504-11.296 6.704-10.974 9.413z"
                    fill="url(#paint87_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_242"
                    d="M132.209 76.388a7.12 7.12 0 004.289 6.94 7.113 7.113 0 007.99-1.649 7.12 7.12 0 001.932-5.292 7.108 7.108 0 00-7.106-7.105 7.104 7.104 0 00-7.105 7.106z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_243"
                    d="M139.303 82.838a6.451 6.451 0 100-12.902 6.451 6.451 0 000 12.902z"
                    fill="url(#paint88_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_244"
                    d="M139.303 82.838a6.451 6.451 0 100-12.902 6.451 6.451 0 000 12.902z"
                    fill="url(#paint89_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_245"
                    d="M139.303 80.197a3.81 3.81 0 100-7.622 3.81 3.81 0 000 7.622z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_246"
                    d="M142.264 75.032a.918.918 0 100-1.836.918.918 0 000 1.836z"
                    fill="#fff"
                  />
                  <Path
                    id="Vector_247"
                    d="M140.84 76.02a.459.459 0 100-.917.459.459 0 000 .918z"
                    fill="#fff"
                  />
                  <Path
                    id="Vector_248"
                    style={{
                      mixBlendMode: 'multiply',
                    }}
                    d="M129.064 78.337c.505-3.19 3.421-8.242 10.974-7.897a8.861 8.861 0 018.77 9.183c.23-2.916-.482-10.492-8.77-10.905-8.885-.413-11.479 6.635-11.043 9.344l.069.275z"
                    fill="url(#paint90_linear_5287_7562)"
                  />
                </G>
              </G>
              <G id="pressable_nose" clipPath="url(#clip2_5287_7562)">
                <G id="Nose_2">
                  <Path
                    id="Vector_249"
                    d="M169.991 64.14c-1.814 1.493-6.291 8.633-5.28 12.168a29.24 29.24 0 01.757 11.778 3.596 3.596 0 011.584 2.296 3.281 3.281 0 01-1.102 3.329c-1.239.688-3.466.206-3.948.642-.483.437-1.011 1.608-2.664 1.608-1.653 0-1.974-.919-2.778-1.447-.803-.528-2.295 0-3.925-.895-1.631-.896-1.493-4.179.826-5.763a29.523 29.523 0 01.39-11.479c.827-2.824-3.076-9.045-5.969-13.04a3.04 3.04 0 01-.528-1.102c-.872-3.33 4.362-7.278 13.247-6.888 6.888.345 9.574 3.628 9.987 6.13a2.708 2.708 0 01-.597 2.663z"
                    fill="#D98B65"
                  />
                  <Path
                    id="Vector_250"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M169.991 64.14c-1.814 1.492-6.291 8.632-5.28 12.168a29.24 29.24 0 01.757 11.778c-1.423 0-3.421.436-3.696-1.034a46.568 46.568 0 01-.873-8.678c-.07-2.328.41-4.641 1.401-6.75a61.674 61.674 0 016.405-9.183 2.895 2.895 0 011.906-.85 2.713 2.713 0 01-.62 2.55z"
                    fill="url(#paint91_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_251"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M165.973 93.78c-1.24.689-3.467.207-3.949.643-.482.436-1.01 1.607-2.663 1.607-1.653 0-1.974-.918-2.778-1.447-.803-.528-2.296 0-3.926-.895-1.63-.895-1.492-4.178.827-5.762a29.523 29.523 0 01.39-11.48c.827-2.823-3.076-9.045-5.969-13.04a3.025 3.025 0 01-.528-1.102 7.69 7.69 0 014.293 1.515 34.452 34.452 0 015.281 9.413c.759 2.999.969 6.11.619 9.184-.137 3.742-.551 6.543-.688 8.08-.063.347-.051.703.034 1.044a2.503 2.503 0 002.261 1.895 4.82 4.82 0 003.031-1.331 3.65 3.65 0 014.064.321 2.506 2.506 0 00.826-2.043 3.283 3.283 0 01-1.125 3.398z"
                    fill="url(#paint92_linear_5287_7562)"
                  />
                  <Path
                    id="Vector_252"
                    style={{
                      mixBlendMode: 'darken',
                    }}
                    d="M165.973 93.78c-1.24.689-3.467.207-3.949.643-.482.436-1.01 1.607-2.663 1.607-1.653 0-1.974-.918-2.778-1.447-.803-.528-2.296 0-3.926-.895-1.63-.895-1.492-4.178.827-5.762a29.523 29.523 0 01.39-11.48c.827-2.823-3.076-9.045-5.969-13.04a3.025 3.025 0 01-.528-1.102 7.69 7.69 0 014.293 1.515 34.452 34.452 0 015.281 9.413c.759 2.999.969 6.11.619 9.184-.137 3.742-.551 6.543-.688 8.08-.063.347-.051.703.034 1.044a2.503 2.503 0 002.261 1.895 4.82 4.82 0 003.031-1.331 3.65 3.65 0 014.064.321 2.506 2.506 0 00.826-2.043 3.283 3.283 0 01-1.125 3.398z"
                    fill="url(#paint93_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_253"
                    d="M153.462 87.927c-1.86 1.171-2.824 4.592-.574 5.878a10.61 10.61 0 003.398.642c.574.184.895.712 1.377 1.057.469.353 1.043.54 1.63.528a2.711 2.711 0 002.296-1.102c.207-.207.345-.483.62-.597 1.162-.061 2.32-.191 3.467-.39 2.296-1.057 1.79-4.592-.184-5.855 3.214 0 3.65 5.005.941 6.245-1.469.528-2.938-.299-4.224 0-.528.275-.643.918-1.079 1.4a2.294 2.294 0 01-2.824.597c-.895-.413-1.079-1.607-1.997-1.906-1.561-.206-3.375.666-4.775-.596a3.557 3.557 0 011.928-5.9z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_254"
                    d="M154.059 93.32c0-.459.734-.665 1.308-.596a2.297 2.297 0 011.722 1.538 2.043 2.043 0 00-1.653-.574c-.62.046-1.286.092-1.377-.368z"
                    fill="#1C1E1F"
                  />
                  <Path
                    id="Vector_255"
                    d="M164.733 93.32c0-.459-.735-.665-1.331-.596a2.297 2.297 0 00-1.722 1.538 2.084 2.084 0 011.676-.574c.597.046 1.262.092 1.377-.368z"
                    fill="#1C1E1F"
                  />
                </G>
              </G>
              <G id="Mouth">
                <G id="Teeth">
                  <Path
                    id="Vector_256"
                    d="M174.77 100.25c-2.64 3.857-8.081 11.777-14.923 11.777-6.842 0-10.308-4.591-15.749-11.777a85.903 85.903 0 0015.359 1.745 102.85 102.85 0 0015.313-1.745z"
                    fill="url(#paint94_radial_5287_7562)"
                  />
                  <G id="Teeth_2">
                    <G id="Group">
                      <Path
                        id="Vector_257"
                        d="M165.286 106.587c-2.295-.39-5.464 1.584-7.92.367-3.329-1.607-7.881-.226-7.467 2.492 3.938 1.709 4.253 5.061 9.74 5.061 4.591 0 8.855-2.317 9.154-5.117-.115-1.057-.201-2.344-3.507-2.803z"
                        fill="#823A38"
                      />
                      <Path
                        id="Vector_258"
                        d="M150.769 109.665c-.115-1.906 1.11-2.341 3.176-2.593a7.277 7.277 0 013.145.597 7.326 7.326 0 004.752 0 8.3 8.3 0 013.352-.437c2.503.345 3.306 1.539 3.421 2.641.115 1.102-3.513 3.765-8.977 3.765s-8.8-2.412-8.869-3.973z"
                        fill="url(#paint95_radial_5287_7562)"
                      />
                      <Path
                        id="Vector_259"
                        d="M159.773 100.117c-4.591.115-13.019.071-13.013.318.252 2.25.826 3.581 2.64 3.949a2.87 2.87 0 003.031.528 3.676 3.676 0 003.512.551c.555.331 1.19.505 1.837.505a3.426 3.426 0 001.63-.39 3.578 3.578 0 003.489-.184 3.465 3.465 0 003.054-.322 3.25 3.25 0 002.962-.275 2.13 2.13 0 001.412-.321c.42-.268.732-.674.883-1.148.509-1.248.564-1.338.695-2.679.213-.993-7.54-.44-12.132-.532z"
                        fill="#70707A"
                      />
                      <Path
                        id="Vector_260"
                        d="M171.408 100.223c-.133 1.161-.119 1.433-.519 2.53l-.184.344a1.605 1.605 0 01-1.86.965 2.526 2.526 0 01-2.869.206 2.753 2.753 0 01-3.123.322 2.984 2.984 0 01-3.466.229 2.846 2.846 0 01-3.352-.161 3.003 3.003 0 01-3.49-.551 2.295 2.295 0 01-2.893-.436h-.252c-1.355-.252-1.607-1.492-1.975-3.352-.183-1.079 6.79.269 12.277.224 5.487-.046 11.798-1.123 11.706-.32z"
                        fill="url(#paint96_radial_5287_7562)"
                      />
                      <Path
                        id="Vector_261"
                        style={{
                          mixBlendMode: 'multiply',
                        }}
                        d="M171.515 100.152c-.134 1.161-.226 1.505-.626 2.602l-.184.344c-.689-1.354-2.066-.987-3.214-.895-1.148.092-1.883.206-3.444.321a48.36 48.36 0 01-6.635.276 17.252 17.252 0 00-3.558-.276 9.65 9.65 0 01-2.916-.183c-.781 0-1.309.413-1.538 1.285-1.355-.252-1.607-1.492-1.975-3.352-.183-1.079 6.719.102 12.206.056 5.487-.046 11.975-.981 11.884-.178z"
                        fill="url(#paint97_linear_5287_7562)"
                      />
                      <Path
                        id="Vector_262"
                        d="M159.335 114.444c-6.511-.239-10.808-6.755-10.808-6.755a4.595 4.595 0 013.329 1.171 5.739 5.739 0 013.88.619 4.59 4.59 0 011.998-.206c.592.035 1.17.191 1.699.459a5.097 5.097 0 013.765-.161c1.014-.56 2.337-.728 3.485-.57.895-.735 1.854-1.196 3.012-1.221.427-.366.672-.695 1.23-.772 0 0-2.385 7.773-11.59 7.436z"
                        fill="#70707A"
                      />
                      <Path
                        id="Vector_263"
                        d="M159.311 114.355c-6.884.197-9.067-5.846-10.391-6.131.515-.109.47.045.984.154.67.177 1.271.553 1.722 1.079a5.626 5.626 0 012.549 0 2.93 2.93 0 011.446.689 4.106 4.106 0 013.719.206 4.41 4.41 0 013.88 0 3.772 3.772 0 011.607-.711 4.11 4.11 0 011.929 0c.208-.289.474-.532.78-.712a4.88 4.88 0 012.296-.551c-.978.543-1.659 6.551-10.521 5.977z"
                        fill="url(#paint98_radial_5287_7562)"
                      />
                      <Path
                        id="Vector_264"
                        style={{
                          mixBlendMode: 'multiply',
                        }}
                        d="M168.777 110.099s-1.269 4.386-9.154 4.425c-5.069.025-8.4-3.583-8.468-3.674-.069-.092-1.066-1.095-1.18-2.358.67.177 1.27.554 1.721 1.079a5.626 5.626 0 012.549 0 5.599 5.599 0 003.145 1.607 10.006 10.006 0 007.507-1.515 4.137 4.137 0 011.929 0c.208-.289.474-.531.781-.712a3.4 3.4 0 011.17 1.148z"
                        fill="url(#paint99_linear_5287_7562)"
                      />
                    </G>
                  </G>
                </G>
                <G id="Lips">
                  <Path
                    id="Vector_265"
                    d="M168.422 99.603a25.744 25.744 0 00-8.54.505c-1.906-1.08-5.464-.85-8.655-.551-2.618.23-4.913.321-7.485.436a56.748 56.748 0 003.054 5.372c4.982 8.15 8.839 9.688 13.338 9.688 4.959 0 8.128-2.548 12.857-10.652.574-1.056 1.86-3.168 2.434-4.592-2.273-.069-4.385-.16-7.003-.206zm-8.701 2.754c4.972-.206 9.922-.782 14.808-1.721-2.778 3.971-8.632 11.043-14.509 11.043-5.878 0-10.515-4.868-15.291-11.112a92.75 92.75 0 0014.992 1.79z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_266"
                    d="M174.92 100.247a102.7 102.7 0 01-15.313 1.744 85.821 85.821 0 01-15.359-1.744c3.903-.161 9.183-.161 11.25-.276a8.42 8.42 0 014.339.827 15.035 15.035 0 015.096-.666c1.745.115 7.416-.184 9.987.115z"
                    fill="url(#paint100_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_267"
                    d="M174.92 100.245c-5.992 11.48-10.813 14.235-14.969 14.235-4.155 0-9.711-2.296-15.703-14.235 5.441 7.118 8.931 11.778 15.749 11.778 6.819 0 12.283-7.921 14.923-11.778z"
                    fill="url(#paint101_radial_5287_7562)"
                  />
                  <Path
                    id="Vector_268"
                    d="M174.242 98.264c.38.238.727.523 1.033.85.158.173.304.357.437.55.149.205.251.441.298.689a4.02 4.02 0 010 1.401 4.836 4.836 0 01-.436 1.263v-1.332a7.335 7.335 0 000-1.24 2.98 2.98 0 00-.482-1.079 8.23 8.23 0 00-.85-1.102z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector_269"
                    d="M145.131 98.058c-.255.406-.485.828-.688 1.262a3.666 3.666 0 00-.391 1.263c-.056.442-.056.89 0 1.332 0 .459.161.941.207 1.423a6.933 6.933 0 01-.643-1.308 3.74 3.74 0 01-.206-1.516 3.129 3.129 0 01.597-1.423 5.619 5.619 0 011.124-1.033z"
                    fill="#915548"
                  />
                </G>
              </G>
              <Path
                id="highlight_face"
                d="M109.941 69.726c2.001-3.5 4.501-2.5 7.001-2-2.52-12.01-5.003-18.184-2.5-34.5 1.38-9 4-17.5 17.5-21 6.043-7.84 16.5-13.5 31-10.5-3 1-10.209.593-12.5 2.5 17-3 28.772 1.556 38 7.5 19 11.5 16.5 40.5 13.5 49l-3 7.5c6.32-2.945 9.5 1.5 9.5 7.5-.252 9.02-1.667 12.153-4 16-3.046 4.649-5.781 6.199-11.5 5.5-3.5 14-20 29-34.5 29-15 0-33-19-35-29-6.5.5-10.707-3.096-13.501-12.5-1.826-7.055-1.999-11 0-15z"
                fill="#A430FF"
                fillOpacity={0.25}
                stroke="#A430FF"
                strokeWidth={1.5}
                opacity={highlightedParts.includes(BODY_PARTS.head) ? 1 : 0}
              />
            </G>
          </G>
          <G id="Group 27666">
            <G id="pressableContainerSelected_hips">
              <BodyPartSvgButton
                type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                bodyPart={BODY_PARTS.hips}
                onPress={onPress}
                onActivate={setActive}
                activateAsSelect
                x={230}
                y={275}
                width={81.5}
                height={37.1}

              />
            </G>
            <G id="Group_2">
              <G
                id="Ellipse 83_2"
                transform="rotate(-134.71 184.62 267.932)"
                fill="#fff"
              >
                <Circle cx={184.62} cy={267.932} r={2} />
                <Circle cx={184.62} cy={267.932} r={2} />
              </G>
              <Path
                id="Line 78_2"
                stroke="#fff"
                d="M235.113 295.747L183.386 267.078"
              />
            </G>
          </G>
          <G id="Group 27655">
            <G id="Group 27650">
              <G id="Ellipse 82" fill="#fff">
                <Circle cx={144.23} cy={48.0977} r={2} />
                <Circle cx={144.23} cy={48.0977} r={2} />
              </G>
              <Path
                id="Line 76"
                stroke="#fff"
                d="M79.0499 32.6119L144.05 47.6119"
              />
            </G>
            <G id="pressableArea_face">
              {active !== BODY_PARTS.head ?
                <G id="pressableButton_face">
                  <BodyPartSvgButton
                    type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                    bodyPart={BODY_PARTS.head}
                    forceTitle="Face"
                    onPress={onPress}
                    onActivate={setActive}
                    width={81.5}
                    height={37}
                    x={4}
                    y={5}
                  />
                </G>
                :
                <G id="pressable_containerSelected_face">
                  <G id="pressableSelect_face">
                    <BodyPartSvgButton
                      type={BODY_PARTS_SVG_BUTTON_TYPES.select}
                      bodyPart={BODY_PARTS.head}
                      forceTitle="Select Face"
                      onPress={onPress}
                      onActivate={setActive}
                      x={0.9375}
                      y={49.0992}
                      width={87.4102}
                      height={55.0266}
                    />
                  </G>
                  <G id="pressableEnlarge_face">
                    <BodyPartSvgButton
                      type={BODY_PARTS_SVG_BUTTON_TYPES.enlarge}
                      bodyPart={BODY_PARTS.head}
                      onPress={onPress}
                      onActivate={setActive}
                      x={0.9375}
                      y={2.09924}
                      width={87.4102}
                      height={46.6699}
                    />
                  </G>
                </G>
              }
            </G>
          </G>
          <G id="Group 27661">
            <G id="pressableArea_torso">
              {active !== BODY_PARTS.torso ?
                <G id="pressableButton_torso">
                  <BodyPartSvgButton
                    type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                    bodyPart={BODY_PARTS.torso}
                    onPress={onPress}
                    onActivate={setActive}
                    x={231}
                    y={132.5}
                    width={81.5}
                    height={37.13}
                  />
                </G>
                :
                <G id="pressable_containerSelected_Torso">
                  <G id="pressableSelect_torso">
                    <BodyPartSvgButton
                      type={BODY_PARTS_SVG_BUTTON_TYPES.select}
                      bodyPart={BODY_PARTS.torso}
                      onPress={onPress}
                      onActivate={setActive}
                      x={226.918}
                      y={174.428}
                      width={87.4102}
                      height={55.0266}
                    />
                  </G>
                  <G id="pressableEnlarge_torso">
                    <BodyPartSvgButton
                      type={BODY_PARTS_SVG_BUTTON_TYPES.enlarge}
                      bodyPart={BODY_PARTS.torso}
                      onPress={onPress}
                      onActivate={setActive}
                      x={226.918}
                      y={127.428}
                      width={87.4102}
                      height={46.6699}
                    />
                  </G>
                </G>
              }
            </G>
            <G id="Group 27652">
              <G id="Ellipse 80" fill="#fff">
                <Circle cx={169.338} cy={161.951} r={2} />
                <Circle cx={169.338} cy={161.951} r={2} />
              </G>
              <Path
                id="Line 77"
                stroke="#fff"
                d="M171.206 161.469L233.206 144.469"
              />
            </G>
          </G>
          <G id="Group 27664">
            <G id="Group 27653">
              <G
                id="Ellipse 81"
                transform="rotate(45.408 85.023 186.637)"
                fill="#fff"
              >
                <Circle cx={85.0228} cy={186.637} r={2} />
                <Circle cx={85.0228} cy={186.637} r={2} />
              </G>
              <Path
                id="Line 79"
                stroke="#fff"
                d="M84.7196 187.626L46.1437 242.507"
              />
            </G>
            <G id="pressableArea_arm">
              {active !== BODY_PARTS.arm ?
                <G id="pressableButton_arm">
                  <BodyPartSvgButton
                    type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                    bodyPart={BODY_PARTS.arm}
                    onPress={onPress}
                    onActivate={setActive}
                    x={3}
                    y={233}
                    width={81.5}
                    height={37.1}
                  />
                </G>
                :
                <G id="pressable_containerSelected_Arm">
                  <G id="pressableSelect_Arm">
                    <BodyPartSvgButton
                      type={BODY_PARTS_SVG_BUTTON_TYPES.select}
                      bodyPart={BODY_PARTS.arm}
                      onPress={onPress}
                      onActivate={setActive}
                      x={0.619141}
                      y={276.575}
                      width={87.4102}
                      height={55.0266}
                    />
                  </G>
                  <G id="pressableEnlarge_Arm">
                    <BodyPartSvgButton
                      type={BODY_PARTS_SVG_BUTTON_TYPES.enlarge}
                      bodyPart={BODY_PARTS.arm}
                      onPress={onPress}
                      onActivate={setActive}
                      x={0.619141}
                      y={230}
                      width={87.4102}
                      height={46.6699}
                    />
                  </G>
                </G>
              }
            </G>
          </G>
          <G id="Group 27665">
            <G id="pressableArea_legs">
              {active !== BODY_PARTS.leg ?
                <G id="pressableButton_leg">
                  <BodyPartSvgButton
                    type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                    bodyPart={BODY_PARTS.leg}
                    onPress={onPress}
                    onActivate={setActive}
                    x={3.5}
                    y={367.5}
                    width={81.5}
                    height={37.1}
                  />
                </G>
                :
                <G id="pressable_containerSelected_leg">
                  <G id="pressableSelect_leg">
                    <BodyPartSvgButton
                      type={BODY_PARTS_SVG_BUTTON_TYPES.select}
                      bodyPart={BODY_PARTS.leg}
                      onPress={onPress}
                      onActivate={setActive}
                      x={1.09375}
                      y={410.247}
                      width={87.4102}
                      height={55.0266}
                    />
                  </G>
                  <G id="pressableEnlarge_leg">
                    <BodyPartSvgButton
                      type={BODY_PARTS_SVG_BUTTON_TYPES.enlarge}
                      bodyPart={BODY_PARTS.leg}
                      onPress={onPress}
                      onActivate={setActive}
                      x={1.09375}
                      y={363.247}
                      width={87.4102}
                      height={46.6699}
                    />
                  </G>
                </G>
              }
            </G>
            <G id="Group 27652_2">
              <G id="Ellipse 83_2" fill="#fff">
                <Circle cx={126.992} cy={379.718} r={2} />
                <Circle cx={126.992} cy={379.718} r={2} />
              </G>
              <Path
                id="Line 78_2"
                stroke="#fff"
                d="M79.4733 392.443L128.473 379.443"
              />
            </G>
          </G>
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_5287_7562"
            x1={168.102}
            y1={327.889}
            x2={186.936}
            y2={390.721}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C48054" />
            <Stop offset={0.552083} stopColor="#A3643C" />
            <Stop offset={0.817708} stopColor="#C68256" />
          </LinearGradient>
          <LinearGradient
            id="paint1_linear_5287_7562"
            x1={164.234}
            y1={394.463}
            x2={209.542}
            y2={394.463}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint2_linear_5287_7562"
            x1={168.864}
            y1={328.085}
            x2={187.698}
            y2={390.917}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C48054" />
            <Stop offset={0.552083} stopColor="#A3643C" />
            <Stop offset={0.817708} stopColor="#C68256" />
          </LinearGradient>
          <LinearGradient
            id="paint3_linear_5287_7562"
            x1={164.998}
            y1={394.658}
            x2={210.306}
            y2={394.658}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint4_linear_5287_7562"
            x1={114.365}
            y1={331.503}
            x2={132.326}
            y2={391.372}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C58155" />
            <Stop offset={0.526042} stopColor="#A3643C" />
            <Stop offset={0.911458} stopColor="#C58155" />
          </LinearGradient>
          <LinearGradient
            id="paint5_linear_5287_7562"
            x1={109.593}
            y1={394.518}
            x2={155.15}
            y2={394.518}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint6_linear_5287_7562"
            x1={115.537}
            y1={331.819}
            x2={133.498}
            y2={391.688}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C58155" />
            <Stop offset={0.526042} stopColor="#A3643C" />
            <Stop offset={0.911458} stopColor="#C58155" />
          </LinearGradient>
          <LinearGradient
            id="paint7_linear_5287_7562"
            x1={110.764}
            y1={394.834}
            x2={156.321}
            y2={394.834}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint8_linear_5287_7562"
            x1={159.349}
            y1={231.017}
            x2={159.349}
            y2={272.201}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#CD8C62" />
            <Stop offset={1} stopColor="#CE8D63" />
          </LinearGradient>
          <LinearGradient
            id="paint9_linear_5287_7562"
            x1={156.305}
            y1={226.675}
            x2={146.719}
            y2={161.214}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C48054" />
            <Stop offset={0.608984} stopColor="#E8A979" />
            <Stop offset={1} stopColor="#D18B63" />
          </LinearGradient>
          <LinearGradient
            id="paint10_linear_5287_7562"
            x1={131.526}
            y1={163.945}
            x2={131.526}
            y2={234.199}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#DB9469" />
            <Stop offset={0.927083} stopColor="#DE986B" />
          </LinearGradient>
          <RadialGradient
            id="paint11_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(41.1696 0 0 34.3793 185.894 275.867)"
          >
            <Stop stopColor="#44484D" />
            <Stop offset={1} stopColor="#34373B" />
          </RadialGradient>
          <RadialGradient
            id="paint12_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(24.8925 0 0 20.7869 141.938 286.284)"
          >
            <Stop stopColor="#44484D" />
            <Stop offset={1} stopColor="#44484D" stopOpacity={0} />
          </RadialGradient>
          <LinearGradient
            id="paint13_linear_5287_7562"
            x1={73.8405}
            y1={228.454}
            x2={182.07}
            y2={296.5}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint14_linear_5287_7562"
            x1={197.981}
            y1={306.399}
            x2={149.179}
            y2={245.95}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint15_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(41.1696 0 0 34.3793 185.172 276.072)"
          >
            <Stop stopColor="#44484D" />
            <Stop offset={1} stopColor="#34373B" />
          </RadialGradient>
          <RadialGradient
            id="paint16_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(24.8925 0 0 20.7869 141.215 286.489)"
          >
            <Stop stopColor="#44484D" />
            <Stop offset={1} stopColor="#44484D" stopOpacity={0} />
          </RadialGradient>
          <LinearGradient
            id="paint17_linear_5287_7562"
            x1={73.1178}
            y1={228.659}
            x2={181.347}
            y2={296.705}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint18_linear_5287_7562"
            x1={197.258}
            y1={306.604}
            x2={148.456}
            y2={246.155}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint19_linear_5287_7562"
            x1={184.963}
            y1={226.721}
            x2={204.134}
            y2={220.644}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D28C64" />
            <Stop offset={1} stopColor="#D28C64" />
          </LinearGradient>
          <LinearGradient
            id="paint20_linear_5287_7562"
            x1={195.134}
            y1={217.848}
            x2={229.061}
            y2={180.649}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint21_linear_5287_7562"
            x1={186.768}
            y1={232.665}
            x2={218.55}
            y2={309.778}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint22_linear_5287_7562"
            x1={192.929}
            y1={288.502}
            x2={206.312}
            y2={270.159}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D28C64" />
            <Stop offset={1} stopColor="#D28C64" />
          </LinearGradient>
          <LinearGradient
            id="paint23_linear_5287_7562"
            x1={111.719}
            y1={200.917}
            x2={99.1482}
            y2={193.287}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#BE734E" />
            <Stop offset={1} stopColor="#D28C64" />
          </LinearGradient>
          <LinearGradient
            id="paint24_linear_5287_7562"
            x1={72.498}
            y1={210.693}
            x2={87.8071}
            y2={189.716}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D38D65" />
            <Stop offset={1} stopColor="#C27852" />
          </LinearGradient>
          <LinearGradient
            id="paint25_linear_5287_7562"
            x1={126.102}
            y1={244.987}
            x2={64.2145}
            y2={153.998}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint26_linear_5287_7562"
            x1={69.1132}
            y1={164.537}
            x2={82.7159}
            y2={144.278}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#BA704A" />
            <Stop offset={1} stopColor="#C58457" />
          </LinearGradient>
          <LinearGradient
            id="paint27_linear_5287_7562"
            x1={56.7798}
            y1={138.857}
            x2={72.2471}
            y2={137.023}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint28_linear_5287_7562"
            x1={64.5133}
            y1={131.896}
            x2={79.1244}
            y2={132.156}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint29_linear_5287_7562"
            x1={57.2254}
            y1={156.212}
            x2={77.8113}
            y2={149.92}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint30_linear_5287_7562"
            x1={75.9312}
            y1={130.552}
            x2={88.5135}
            y2={134.684}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint31_linear_5287_7562"
            x1={87.3226}
            y1={136.099}
            x2={92.9624}
            y2={156.033}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint32_linear_5287_7562"
            x1={111.815}
            y1={201.029}
            x2={99.2439}
            y2={193.399}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#BE734E" />
            <Stop offset={1} stopColor="#D28C64" />
          </LinearGradient>
          <LinearGradient
            id="paint33_linear_5287_7562"
            x1={72.5956}
            y1={210.805}
            x2={87.9048}
            y2={189.828}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D38D65" />
            <Stop offset={1} stopColor="#C27852" />
          </LinearGradient>
          <LinearGradient
            id="paint34_linear_5287_7562"
            x1={126.2}
            y1={245.099}
            x2={64.3121}
            y2={154.11}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint35_linear_5287_7562"
            x1={69.2108}
            y1={164.649}
            x2={82.8135}
            y2={144.39}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#BA704A" />
            <Stop offset={1} stopColor="#C58457" />
          </LinearGradient>
          <LinearGradient
            id="paint36_linear_5287_7562"
            x1={56.8774}
            y1={138.969}
            x2={72.3447}
            y2={137.135}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint37_linear_5287_7562"
            x1={64.6109}
            y1={132.008}
            x2={79.222}
            y2={132.268}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint38_linear_5287_7562"
            x1={57.3231}
            y1={156.324}
            x2={77.909}
            y2={150.033}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint39_linear_5287_7562"
            x1={76.0289}
            y1={130.664}
            x2={88.6112}
            y2={134.796}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint40_linear_5287_7562"
            x1={87.4203}
            y1={136.211}
            x2={93.06}
            y2={156.145}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint41_linear_5287_7562"
            x1={184.59}
            y1={227.287}
            x2={203.761}
            y2={221.209}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D28C64" />
            <Stop offset={1} stopColor="#D28C64" />
          </LinearGradient>
          <LinearGradient
            id="paint42_linear_5287_7562"
            x1={194.761}
            y1={218.414}
            x2={228.688}
            y2={181.214}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint43_linear_5287_7562"
            x1={186.395}
            y1={233.23}
            x2={218.177}
            y2={310.344}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint44_linear_5287_7562"
            x1={192.556}
            y1={289.067}
            x2={205.939}
            y2={270.724}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#D28C64" />
            <Stop offset={1} stopColor="#D28C64" />
          </LinearGradient>
          <LinearGradient
            id="paint45_linear_5287_7562"
            x1={155.463}
            y1={127.266}
            x2={158.778}
            y2={142.706}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#E3A475" />
            <Stop offset={1} stopColor="#D28C64" />
          </LinearGradient>
          <LinearGradient
            id="paint46_linear_5287_7562"
            x1={155.891}
            y1={116.963}
            x2={158.479}
            y2={153.3}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint47_linear_5287_7562"
            x1={157.433}
            y1={226.742}
            x2={147.848}
            y2={161.281}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C48054" />
            <Stop offset={0.608984} stopColor="#E8A979" />
            <Stop offset={1} stopColor="#D18B63" />
          </LinearGradient>
          <LinearGradient
            id="paint48_linear_5287_7562"
            x1={132.655}
            y1={164.011}
            x2={132.655}
            y2={234.265}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#DB9469" />
            <Stop offset={0.927083} stopColor="#DE986B" />
          </LinearGradient>
          <LinearGradient
            id="paint49_linear_5287_7562"
            x1={157.667}
            y1={127.178}
            x2={160.982}
            y2={142.619}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#E3A475" />
            <Stop offset={1} stopColor="#D28C64" />
          </LinearGradient>
          <LinearGradient
            id="paint50_linear_5287_7562"
            x1={158.093}
            y1={116.875}
            x2={160.681}
            y2={153.212}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint51_linear_5287_7562"
            x1={109.89}
            y1={95.5175}
            x2={124.859}
            y2={71.7327}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#E3A475" />
            <Stop offset={1} stopColor="#D98B65" />
          </LinearGradient>
          <LinearGradient
            id="paint52_linear_5287_7562"
            x1={124.996}
            y1={79.9292}
            x2={101.808}
            y2={91.7527}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint53_linear_5287_7562"
            x1={193.836}
            y1={83.6438}
            x2={205.866}
            y2={81.1644}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#E3A475" />
            <Stop offset={1} stopColor="#D98B65" />
          </LinearGradient>
          <LinearGradient
            id="paint54_linear_5287_7562"
            x1={197.19}
            y1={80.7282}
            x2={208.095}
            y2={84.3786}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint55_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(48.6945 0 0 48.6944 159.109 77.291)"
          >
            <Stop offset={0.0145865} stopColor="#D38D65" />
            <Stop offset={0.76} stopColor="#D38D65" />
            <Stop offset={1} stopColor="#D38D65" />
          </RadialGradient>
          <LinearGradient
            id="paint56_linear_5287_7562"
            x1={57.3137}
            y1={39.1371}
            x2={212.718}
            y2={86.2472}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint57_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(135.28 94.856) scale(10.8363)"
          >
            <Stop stopColor="#FFC0BF" />
            <Stop offset={1} stopColor="#FFC0BF" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint58_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(182 94.856) scale(10.8363)"
          >
            <Stop stopColor="#FFC0BF" />
            <Stop offset={1} stopColor="#FFC0BF" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint59_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(11.7316 0 0 11.7317 147.425 71.072)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint60_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(156.722 94.373) scale(10.7904)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint61_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(171.462 71.072) scale(11.7317)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint62_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(9.43581 0 0 9.43583 159.362 110.674)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint63_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(3.0305 0 0 3.03048 142.833 100.94)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint64_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(3.0305 0 0 3.03048 174.216 100.94)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint65_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(48.6027 0 0 48.6026 159.707 17.9)"
          >
            <Stop stopColor="#4B4E50" />
            <Stop offset={1} stopColor="#3C3F41" />
          </RadialGradient>
          <RadialGradient
            id="paint66_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(16.8975 0 0 16.8973 128.322 21.182)"
          >
            <Stop stopColor="#fff" />
            <Stop offset={1} stopColor="#fff" stopOpacity={0} />
          </RadialGradient>
          <LinearGradient
            id="paint67_linear_5287_7562"
            x1={157.778}
            y1={-34.1472}
            x2={159.845}
            y2={90.5619}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint68_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(162.737 21.435) scale(34.4144)"
          >
            <Stop stopColor="#4B4E50" />
            <Stop offset={1} stopColor="#3C3F41" />
          </RadialGradient>
          <RadialGradient
            id="paint69_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(35.9066 0 0 35.9067 173.39 25.248)"
          >
            <Stop stopColor="#fff" />
            <Stop offset={1} stopColor="#fff" stopOpacity={0} />
          </RadialGradient>
          <LinearGradient
            id="paint70_linear_5287_7562"
            x1={152.521}
            y1={52.7963}
            x2={164.941}
            y2={-15.9406}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint71_linear_5287_7562"
            x1={179.795}
            y1={54.7478}
            x2={181.976}
            y2={54.7478}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint72_linear_5287_7562"
            x1={172.08}
            y1={50.8464}
            x2={183.307}
            y2={50.8464}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint73_linear_5287_7562"
            x1={174.928}
            y1={48.2747}
            x2={189.759}
            y2={48.2747}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint74_linear_5287_7562"
            x1={189.391}
            y1={48.7322}
            x2={190.125}
            y2={48.7322}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint75_linear_5287_7562"
            x1={179.978}
            y1={32.4794}
            x2={202.202}
            y2={32.4794}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint76_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(9.98688 0 0 9.98684 171.28 70.356)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <LinearGradient
            id="paint77_linear_5287_7562"
            x1={166.527}
            y1={97.6078}
            x2={149.217}
            y2={75.4991}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint78_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(13.0402 0 0 13.0403 148.436 70.287)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <LinearGradient
            id="paint79_linear_5287_7562"
            x1={179.359}
            y1={65.6534}
            x2={182.022}
            y2={60.8781}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#3C3F41" />
            <Stop offset={1} stopColor="#4B4E50" />
          </LinearGradient>
          <LinearGradient
            id="paint80_linear_5287_7562"
            x1={181.656}
            y1={57.0892}
            x2={177.547}
            y2={75.4328}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <LinearGradient
            id="paint81_linear_5287_7562"
            x1={138.608}
            y1={65.1022}
            x2={139.618}
            y2={60.2121}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#3C3F41" />
            <Stop offset={1} stopColor="#4B4E50" />
          </LinearGradient>
          <LinearGradient
            id="paint82_linear_5287_7562"
            x1={139.871}
            y1={56.9734}
            x2={137.552}
            y2={71.3912}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint83_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(182.78 76.385) scale(15.6346)"
          >
            <Stop offset={0.74} stopColor="#fff" />
            <Stop offset={1} stopColor="#A1A1AD" />
          </RadialGradient>
          <RadialGradient
            id="paint84_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(6.45126 0 0 6.45127 179.863 76.387)"
          >
            <Stop offset={0.82} stopColor="#744136" />
            <Stop offset={1} stopColor="#2E3536" />
          </RadialGradient>
          <RadialGradient
            id="paint85_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(180.162 79.739) scale(8.33384)"
          >
            <Stop offset={0.81} stopColor="#2E3536" stopOpacity={0} />
            <Stop offset={1} stopColor="#2E3536" />
          </RadialGradient>
          <LinearGradient
            id="paint86_linear_5287_7562"
            x1={180.254}
            y1={68.9957}
            x2={180.254}
            y2={78.179}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint87_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(141.117 76.844) scale(14.4178)"
          >
            <Stop offset={0.71} stopColor="#fff" />
            <Stop offset={1} stopColor="#A1A1AD" />
          </RadialGradient>
          <RadialGradient
            id="paint88_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(6.45126 0 0 6.45127 139.303 76.387)"
          >
            <Stop offset={0.82} stopColor="#744136" />
            <Stop offset={1} stopColor="#2E3536" />
          </RadialGradient>
          <RadialGradient
            id="paint89_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(139.739 80.06) scale(8.33384)"
          >
            <Stop offset={0.81} stopColor="#2E3536" stopOpacity={0} />
            <Stop offset={1} stopColor="#2E3536" />
          </RadialGradient>
          <LinearGradient
            id="paint90_linear_5287_7562"
            x1={138.844}
            y1={68.7408}
            x2={138.844}
            y2={78.7965}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint91_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(9.98688 0 0 9.98684 171.506 70.247)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <LinearGradient
            id="paint92_linear_5287_7562"
            x1={166.754}
            y1={97.4992}
            x2={149.443}
            y2={75.3905}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint93_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(13.0402 0 0 13.0403 148.663 70.179)"
          >
            <Stop stopColor="#C97551" />
            <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
          </RadialGradient>
          <RadialGradient
            id="paint94_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(159.434 106.15) scale(11.6169)"
          >
            <Stop stopColor="#44211F" />
            <Stop offset={1} stopColor="#21100F" />
          </RadialGradient>
          <RadialGradient
            id="paint95_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(7.64508 0 0 7.6451 160.742 112.329)"
          >
            <Stop stopColor="#D15F5D" />
            <Stop offset={1} stopColor="#B5504E" />
          </RadialGradient>
          <RadialGradient
            id="paint96_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(12.5351 0 0 12.5352 160.994 108.699)"
          >
            <Stop offset={0.62} stopColor="#fff" />
            <Stop offset={1} stopColor="#A1A1AD" />
          </RadialGradient>
          <LinearGradient
            id="paint97_linear_5287_7562"
            x1={159.593}
            y1={94.0756}
            x2={159.593}
            y2={106.703}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint98_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(161.544 104.544) scale(10.5378)"
          >
            <Stop offset={0.62} stopColor="#fff" />
            <Stop offset={1} stopColor="#A1A1AD" />
          </RadialGradient>
          <LinearGradient
            id="paint99_linear_5287_7562"
            x1={159.204}
            y1={114.071}
            x2={159.387}
            y2={108.607}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#A1A1AD" />
            <Stop offset={1} stopColor="#A1A1AD" stopOpacity={0} />
          </LinearGradient>
          <RadialGradient
            id="paint100_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(160.25 91.5) scale(10.8592)"
          >
            <Stop stopColor="#F0A873" />
            <Stop offset={1} stopColor="#B86947" />
          </RadialGradient>
          <RadialGradient
            id="paint101_radial_5287_7562"
            cx={0}
            cy={0}
            r={1}
            gradientUnits="userSpaceOnUse"
            gradientTransform="matrix(8.70116 0 0 8.70117 159.63 108.625)"
          >
            <Stop offset={0.39} stopColor="#BE734C" />
            <Stop offset={1} stopColor="#C97551" />
          </RadialGradient>
          <ClipPath id="clip0_5287_7562">
            <Path
              fill="#fff"
              transform="translate(112.33 226.594)"
              d="M0 0H90V73H0z"
            />
          </ClipPath>
          <ClipPath id="clip1_5287_7562">
            <Path
              fill="#fff"
              transform="translate(147.033 55.43)"
              d="M0 0H23V19H0z"
            />
          </ClipPath>
          <ClipPath id="clip2_5287_7562">
            <Path
              fill="#fff"
              transform="translate(146.26 74.32)"
              d="M0 0H26V23H0z"
            />
          </ClipPath>
        </Defs>
      </Svg>
    </View>
  );
};

export { BodyTypesSVG_fullBodyFront };
